function numeralFemaleEnding(condition) {
    return condition + "-";
}

function numeralMaleEnding(condition) {
    return condition + "-";
}

function numeralNeuterEnding(condition) {
    return condition + "-";
}

function plural(count, parameters) {
    const m10 = count % 10;
    const m100 = count % 100;

    if (m10 === 1 && m100 !== 11) {
        return parameters[0];
    }

    if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) {
        return parameters[1];
    }

    return parameters[2];
}

function signed(condition) {
    if (condition === 0) {
        return '0';
    }

    const num = Number.parseFloat(condition.toFixed(2));

    if (condition > 0) {
        return '+' + num.toString();
    }

    return num.toString();
}

function europeanHandicapCondition(condition) {
    if (condition < 0) {
        return "0:" + Math.abs(condition);
    }
    else {
        return Math.abs(condition) + ":0";
    }
}

const sl_b1 = (match, outcome) => 'Natija';
const sl_c1 = (match, outcome) => 'Fora';
const sl_d1 = (match, outcome) => 'Jami hisob';
const sl_e1 = (match, outcome) => `Kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const sl_f1 = (match, outcome) => `Kim ${numeralNeuterEnding(outcome.condition)} ochkoni yutadi`;
const sl_g1 = (match, outcome) => `${match.homeTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const sl_h1 = (match, outcome) => `${match.awayTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const sl_i1 = (match, outcome) => `Jami hisob: ${match.homeTeam}`;
const sl_j1 = (match, outcome) => `Jami hisob: ${match.awayTeam}`;
const sl_k1 = (match, outcome) => 'G&apos;alaba';
const sl_l1 = (match, outcome) => 'Aniq jami hisob';
const sl_m1 = (match, outcome) => `${match.homeTeam} farq bilan g&apos;alaba`;
const sl_n1 = (match, outcome) => `${match.awayTeam} farq bilan g&apos;alaba`;
const sl_o1 = (match, outcome) => 'Ochkolar farqi';
const sl_p1 = (match, outcome) => 'O&apos;yinda birinchi';
const sl_q1 = (match, outcome) => 'Nechta jamoa to&apos;p kiritadi?';
const sl_r1 = (match, outcome) => 'Aniq hisob';
const sl_s1 = (match, outcome) => `G&apos;alaba va jami hisobi ${outcome.condition}`;
const sl_t1 = (match, outcome) => `Kib birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const sl_u1 = (match, outcome) => 'Juft/toq';
const sl_v1 = (match, outcome) => `${match.homeTeam} farq bilan g&apos;alaba qozonadi`;
const sl_w1 = (match, outcome) => `${match.awayTeam} farq bilan g&apos;alaba qozonadi`;
const sl_x1 = (match, outcome) => `${match.homeTeam} aniq hisob`;
const sl_y1 = (match, outcome) => `${match.awayTeam} aniq hisob`;
const sl_z1 = (match, outcome) => 'Farq bilan g&apos;alaba';
const sl_a2 = (match, outcome) => `Kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['qotillik', 'qotillik', 'qotillik'])} jamlaydi`;
const sl_b2 = (match, outcome) => 'First Blood';
const sl_c2 = (match, outcome) => `${match.homeTeam} to&apos;p kiritadimi?`;
const sl_d2 = (match, outcome) => `${match.awayTeam} to&apos;p kiritadimi?`;
const sl_e2 = (match, outcome) => 'Nechta jamoa to&apos;p kiritadi';
const sl_f2 = (match, outcome) => `${match.homeTeam} nechta to&apos;p kiritadi?`;
const sl_g2 = (match, outcome) => `${match.awayTeam} nechta to&apos;p kiritadi?`;
const sl_h2 = (match, outcome) => 'Qo&apos;shib berilgan vaqt';
const sl_i2 = (match, outcome) => `Yevropacha fora${europeanHandicapCondition(outcome.condition)}`;
const sl_j2 = (match, outcome) => `Kim ${numeralMaleEnding(outcome.condition)}-golni kiritadi?`;
const sl_k2 = (match, outcome) => `Qolgan vaqtda (hozirgi hisob ${outcome.condition}:${outcome.conditionTwo})`;
const sl_l2 = (match, outcome) => 'Ikkilangan natija';
const sl_m2 = (match, outcome) => 'Har bir bayroqchadan';
const sl_n2 = (match, outcome) => 'Simulyatsiya uchun';
const sl_o2 = (match, outcome) => 'Fudbolkani yechganlik uchun';
const sl_p2 = (match, outcome) => `Kiritilgan jami penaltilar: ${match.awayTeam}`;
const sl_q2 = (match, outcome) => `Kiritilgan jami penaltilar: ${match.homeTeam}`;
const sl_r2 = (match, outcome) => 'Kiritilgan jami penaltilar';
const sl_s2 = (match, outcome) => 'Kiritilmagan jami penaltilar';
const sl_t2 = (match, outcome) => 'Aniq Jami hisob';
const sl_u2 = (match, outcome) => 'Kim birinchi sharni savatga tushiradi?';
const sl_v2 = (match, outcome) => `Kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])}ni qo&apos;lga kiritadi`;
const sl_w2 = (match, outcome) => 'Qaysi rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const sl_x2 = (match, outcome) => 'Результат';
const sl_y2 = (match, outcome) => 'Фора';
const sl_z2 = (match, outcome) => 'Тотал';
const sl_a3 = (match, outcome) => 'Кто первым(ой) забьет шар?';
const sl_b3 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])}`;
const sl_c3 = (match, outcome) => 'Какой цветной шар будет забит первым?';
const sl_d3 = (match, outcome) => 'Чет/Нечет';
const sl_e3 = (match, outcome) => `Kim ${numeralNeuterEnding(outcome.condition)} ochkoni yutib oladi`;
const sl_f3 = (match, outcome) => `Kim birinchi ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])}ni yutadi`;
const sl_g3 = (match, outcome) => `${match.homeTeam} ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} farqi bilan g&apos;alaba qozonadi`;
const sl_h3 = (match, outcome) => `${match.awayTeam} ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} farqi bilan g&apos;alaba qozonadi`;
const sl_i3 = (match, outcome) => 'Juft/toq jami hisobi';
const sl_j3 = (match, outcome) => `${outcome.condition}-geymda bo&apos;ladimi?`;
const sl_k3 = (match, outcome) => 'Breyklar jami hisobi';
const sl_l3 = (match, outcome) => `Kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['geym', 'geym', 'geym'])} ni qo&apos;lga kiritadi`;
const sl_m3 = (match, outcome) => `G&apos;alaba va jami hisob ${outcome.condition}`;
const sl_n3 = (match, outcome) => 'Tie-brake bo&apos;ladimi?';
const sl_o3 = (match, outcome) => 'Tie-brakeda kim g&apos;alaba qozonadi?';
const sl_p3 = (match, outcome) => 'Tie-brakening aniq jami hisobi';
const sl_q3 = (match, outcome) => 'Tie-brakening aniq hisobi';
const sl_r3 = (match, outcome) => 'Tie-brakelar aniq hisobi';
const sl_s3 = (match, outcome) => `Tie-brake jami hisobi: ${match.homeTeam}`;
const sl_t3 = (match, outcome) => `Tie-brake jami hisobi: ${match.awayTeam}`;
const sl_u3 = (match, outcome) => `Kimdir ${outcome.condition} ${plural(outcome.condition, ['geym', 'geym', 'geym'])} ni ketma-ket yuta oladimi?`;
const sl_v3 = (match, outcome) => `${match.homeTeam} ${outcome.condition} ${plural(outcome.condition, ['geym', 'geym', 'geym'])} ni ketma-ket yuta oladimi?`;
const sl_w3 = (match, outcome) => `${match.awayTeam} ${outcome.condition} ${plural(outcome.condition, ['geym', 'geym', 'geym'])} ni ketma-ket yuta oladimi?`;
const sl_x3 = (match, outcome) => 'Breyklar bo&apos;yicha natija';
const sl_y3 = (match, outcome) => 'Breyklar bo&apos;yicha fora';
const sl_z3 = (match, outcome) => `Kim birinchi ${numeralNeuterEnding(outcome.condition)} ochko to&apos;playdi`;

const bo_b1 = (match, outcome) => 'Fora';
const bo_c1 = (match, outcome) => 'O&apos;yinning jami hisobi';
const bo_d1 = (match, outcome) => `Jami hisob: ${match.homeTeam}`;
const bo_e1 = (match, outcome) => `Jami hisob: ${match.awayTeam}`;
const bo_f1 = (match, outcome) => 'O&apos;yinning jami hisobi juft/toq';
const bo_g1 = (match, outcome) => `${match.homeTeam} - ${match.awayTeam}`;
const bo_h1 = (match, outcome) => `${outcome.teamOne} - ${outcome.teamTwo}`;
const bo_i1 = (match, outcome) => `${outcome.teamOne}`;
const bo_j1 = (match, outcome) => 'Birinchi setdagi Fora';
const bo_k1 = (match, outcome) => 'Ikkinchi setdagi Fora';
const bo_l1 = (match, outcome) => 'Uchinchi setdagi Fora';
const bo_m1 = (match, outcome) => 'Birinchi setdagi jami hisob';
const bo_n1 = (match, outcome) => 'Ikkinchi setdagi jami hisob';
const bo_o1 = (match, outcome) => 'Uchinchi setdagi jami hisob';
const bo_p1 = (match, outcome) => 'O&apos;yindagi jami setlar soni';
const bo_q1 = (match, outcome) => 'O&apos;yin hisobi';
const bo_r1 = (match, outcome) => 'Birinchi set natijasi';
const bo_s1 = (match, outcome) => 'Ikkinchi set natijasi';
const bo_t1 = (match, outcome) => 'Uchinchi set natijasi';
const bo_u1 = (match, outcome) => `Birinchi setda ${match.homeTeam} ning jami hisobi`;
const bo_v1 = (match, outcome) => `Ikkinchi setda ${match.homeTeam} ning jami hisobi`;
const bo_w1 = (match, outcome) => `Uchinchi setda ${match.homeTeam} ning jami hisobi`;
const bo_x1 = (match, outcome) => `Birinchi setda ${match.awayTeam} ning jami hisobi`;
const bo_y1 = (match, outcome) => `Ikkinchi setda ${match.awayTeam} ning jami hisobi`;
const bo_z1 = (match, outcome) => `Uchinchi setda ${match.awayTeam} ning jami hisobi`;
const bo_a2 = (match, outcome) => `${match.homeTeam} birinchi setda ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} farq bilan g&apos;alaba qozonadi`;
const bo_b2 = (match, outcome) => `${match.homeTeam} ikkinchi setda ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} farq bilan g&apos;alaba qozonadi`;
const bo_c2 = (match, outcome) => `${match.homeTeam} uchinchi setda ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} farq bilan g&apos;alaba qozonadi`;
const bo_d2 = (match, outcome) => `${match.awayTeam} birinchi setda ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} farq bilan g&apos;alaba qozonadi`;
const bo_e2 = (match, outcome) => `${match.awayTeam} ikkinchi setda ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} farq bilan g&apos;alaba qozonadi`;
const bo_f2 = (match, outcome) => `${match.awayTeam} uchinchi setda ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} farq bilan g&apos;alaba qozonadi`;
const bo_g2 = (match, outcome) => `1-setda kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_h2 = (match, outcome) => `2-setda kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_i2 = (match, outcome) => `3-setda kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_j2 = (match, outcome) => `Kim birinchi setda ${numeralNeuterEnding(outcome.condition)} ochko yutadi`;
const bo_k2 = (match, outcome) => `Kim ikkinchi setda ${numeralNeuterEnding(outcome.condition)} ochko yutadi`;
const bo_l2 = (match, outcome) => `Kim uchinchi setda ${numeralNeuterEnding(outcome.condition)} ochko yutadi`;
const bo_m2 = (match, outcome) => 'Birinchi setning 10 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
const bo_n2 = (match, outcome) => 'Ikkinchi setning 10 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
const bo_o2 = (match, outcome) => 'Uchinchi setning 10 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
const bo_p2 = (match, outcome) => 'Birinchi setning 10 ochkogacha bo&apos;lgan minisetida fora';
const bo_q2 = (match, outcome) => 'Ikkinchi setning 10 ochkogacha bo&apos;lgan minisetida fora';
const bo_r2 = (match, outcome) => 'Uchinchi setning 10 ochkogacha bo&apos;lgan minisetida fora';
const bo_s2 = (match, outcome) => 'Birinchi setning 10 ochkogacha bo&apos;lgan minisetida jami hisob';
const bo_t2 = (match, outcome) => 'Ikkinchi setning 10 ochkogacha bo&apos;lgan minisetida jami hisob';
const bo_u2 = (match, outcome) => 'Uchinchi setning 10 ochkogacha bo&apos;lgan minisetida jami hisob';
const bo_v2 = (match, outcome) => 'Birinchi setning 15 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
const bo_w2 = (match, outcome) => 'Ikkinchi setning 15 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
const bo_x2 = (match, outcome) => 'Uchinchi setning 15 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
const bo_y2 = (match, outcome) => 'Birinchi setning 15 ochkogacha bo&apos;lgan minisetida fora';
const bo_z2 = (match, outcome) => 'Ikkinchi setning 15 ochkogacha bo&apos;lgan minisetida fora';
const bo_a3 = (match, outcome) => 'Uchinchi setning 15 ochkogacha bo&apos;lgan minisetida fora';
const bo_b3 = (match, outcome) => 'Birinchi setning 15 ochkogacha bo&apos;lgan minisetida jami hisob';
const bo_c3 = (match, outcome) => 'Ikkinchi setning 15 ochkogacha bo&apos;lgan minisetida jami hisob';
const bo_d3 = (match, outcome) => 'Uchinchi setning 15 ochkogacha bo&apos;lgan minisetida jami hisob';
const bo_e3 = (match, outcome) => `${match.homeTeam} ning birinchi bo&apos;limdagi jami hisobi`;
const bo_f3 = (match, outcome) => 'Birinchi bo&apos;limda fora';
const bo_g3 = (match, outcome) => 'Birinchi bo&apos;lim natijasi';
const bo_h3 = (match, outcome) => `${match.awayTeam} ning birinchi bo&apos;limdagi jami hisobi`;
const bo_i3 = (match, outcome) => `Kim ${numeralMaleEnding(outcome.condition)} chi golni kiritadi?`;
const bo_j3 = (match, outcome) => 'Ikkilangan natija';
const bo_k3 = (match, outcome) => 'Birinchi bo&apos;lim jami hisobi';
const bo_l3 = (match, outcome) => `G&apos;alaba va o&apos;yinning jami hisobi ${outcome.condition}`;
const bo_m3 = (match, outcome) => `${match.homeTeam} jamoasi ${outcome.condition} ${plural(outcome.condition, ['gol', 'gol', 'gol'])} farqi bilan g&apos;alaba qozonadi`;
const bo_n3 = (match, outcome) => `${match.awayTeam} jamoasi ${outcome.condition} ${plural(outcome.condition, ['gol', 'gol', 'gol'])} farqi bilan g&apos;alaba qozonadi`;
const bo_o3 = (match, outcome) => 'O&apos;yinning aniq jami hisobi';
const bo_p3 = (match, outcome) => 'Nechta jamoa to&apos;p kiritadi';
const bo_q3 = (match, outcome) => 'Aniq hisob';
const bo_r3 = (match, outcome) => 'Osiyocha fora';
const bo_s3 = (match, outcome) => 'Fora birinchi chorakda';
const bo_t3 = (match, outcome) => 'Fora ikkinchi chorakda';
const bo_u3 = (match, outcome) => 'Fora uchinchi chorakda';
const bo_v3 = (match, outcome) => 'Fora to&apos;rtinchi chorakda';
const bo_w3 = (match, outcome) => 'Birinchi chorakning jami hisobi';
const bo_x3 = (match, outcome) => 'Ikkinchi chorakning jami hisobi';
const bo_y3 = (match, outcome) => 'Uchinchi chorakning jami hisobi';
const bo_z3 = (match, outcome) => 'To&apos;rtinchi chorakning jami hisobi';
const bo_a4 = (match, outcome) => 'Birinchi chorak natijasi';
const bo_b4 = (match, outcome) => 'Ikkinchi chorak natijasi';
const bo_c4 = (match, outcome) => 'Uchinchi chorak natijasi';
const bo_d4 = (match, outcome) => 'To&apos;rtinchi chorak natijasi';
const bo_e4 = (match, outcome) => `${match.homeTeam} ning birinchi chorakdagi jami hisobi`;
const bo_f4 = (match, outcome) => `${match.homeTeam} ning ikkinchi chorakdagi jami hisobi`;
const bo_g4 = (match, outcome) => `${match.homeTeam} ning uchinchi chorakdagi jami hisobi`;
const bo_h4 = (match, outcome) => `${match.homeTeam} ning to&apos;rtinchi chorakdagi jami hisobi`;
const bo_i4 = (match, outcome) => `${match.awayTeam} ning birinchi chorakdagi jami hisobi`;
const bo_j4 = (match, outcome) => `${match.awayTeam} ning ikkinchi chorakdagi jami hisobi`;
const bo_k4 = (match, outcome) => `${match.awayTeam} ning uchinchi chorakdagi jami hisobi`;
const bo_l4 = (match, outcome) => `${match.awayTeam} ning to&apos;rtinchi chorakdagi jami hisobi`;
const bo_m4 = (match, outcome) => 'O&apos;yin birinchi yarimining jami hisobi';
const bo_n4 = (match, outcome) => 'O&apos;yin ikkinchi yarimining natijasi';
const bo_o4 = (match, outcome) => 'O&apos;yin ikkinchi yarimining jami hisobi';
const bo_p4 = (match, outcome) => 'O&apos;yin birinchi yarimida fora bilan g&apos;alaba qozonadi';
const bo_q4 = (match, outcome) => 'O&apos;yin ikkinchi yarimida fora bilan g&apos;alaba qozonadi';
const bo_r4 = (match, outcome) => 'O&apos;yin birinchi yarimining natijasi';
const bo_s4 = (match, outcome) => `O&apos;yin birinchi yarimida ${match.homeTeam} ning jami hisobi`;
const bo_t4 = (match, outcome) => `O&apos;yin ikkinchi yarimida ${match.homeTeam} ning jami hisobi`;
const bo_u4 = (match, outcome) => `O&apos;yin birinchi yarimida ${match.awayTeam} ning jami hisobi`;
const bo_v4 = (match, outcome) => `O&apos;yin ikkinchi yarimida ${match.awayTeam} ning jami hisobi`;
const bo_w4 = (match, outcome) => `1-chorakda kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_x4 = (match, outcome) => `2-chorakda kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_y4 = (match, outcome) => `3-chorakda kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_z4 = (match, outcome) => `4-chorakda kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_a5 = (match, outcome) => 'O&apos;yindagi aniq jami hisob';
const bo_b5 = (match, outcome) => 'Birinchi chorakdagi aniq jami hisob';
const bo_c5 = (match, outcome) => 'Ikkinchi chorakdagi aniq jami hisob';
const bo_d5 = (match, outcome) => 'Uchinchi chorakdagi aniq jami hisob';
const bo_e5 = (match, outcome) => 'To&apos;rtinchi chorakdagi aniq jami hisob';
const bo_f5 = (match, outcome) => `${match.homeTeam} ochkolar farqi bilan g&apos;alaba qozonadi`;
const bo_g5 = (match, outcome) => `${match.awayTeam} ochkolar farqi bilan g&apos;alaba qozonadi`;
const bo_h5 = (match, outcome) => 'O&apos;tish';
const bo_i5 = (match, outcome) => `${match.homeTeam} barcha choraklarda g&apos;alaba qozonadi`;
const bo_j5 = (match, outcome) => `${match.awayTeam} barcha choraklarda g&apos;alaba qozonadi`;
const bo_k5 = (match, outcome) => `${match.homeTeam} o&apos;yinning ikkala yarmida ham g&apos;alaba qozonadi`;
const bo_l5 = (match, outcome) => `${match.awayTeam} o&apos;yinning ikkala yarmida ham g&apos;alaba qozonadi`;
const bo_m5 = (match, outcome) => 'Eng sermahsul o&apos;yinning yarmi';
const bo_n5 = (match, outcome) => 'Eng sermahsul o&apos;yin choragi';
const bo_o5 = (match, outcome) => 'Eng sermahsul chorakning jami hisobi';
const bo_p5 = (match, outcome) => 'Eng sermahsul bo&apos;lmagan chorakning jami hisobi';
const bo_q5 = (match, outcome) => `${match.homeTeam} birinchi chorakda va o&apos;yinda g&apos;alaba qozonadi`;
const bo_r5 = (match, outcome) => `${match.awayTeam} birinchi chorakda va o&apos;yinda g&apos;alaba qozonadi`;
const bo_s5 = (match, outcome) => `${match.homeTeam} o&apos;yinning birinchi yarmida va o&apos;yinda g&apos;alaba qozonadi`;
const bo_t5 = (match, outcome) => `${match.awayTeam} o&apos;yinning birinchi yarmida va o&apos;yinda g&apos;alaba qozonadi`;
const bo_u5 = (match, outcome) => 'Overtime bo&apos;ladimi';
const bo_v5 = (match, outcome) => 'O&apos;yinda ochko farqi bilan g&apos;alaba';
const bo_w5 = (match, outcome) => 'Birinchi chorakda ochko farqi bilan g&apos;alaba';
const bo_x5 = (match, outcome) => 'Ikkinchi chorakda ochko farqi bilan g&apos;alaba';
const bo_y5 = (match, outcome) => 'Uchinchi chorakda ochko farqi bilan g&apos;alaba';
const bo_z5 = (match, outcome) => 'To&apos;rtinchi chorakda ochko farqi bilan g&apos;alaba';
const bo_a6 = (match, outcome) => `Jami hisob: ${outcome.playerName} (${match.homeTeam})`;
const bo_b6 = (match, outcome) => `Jami hisob: ${outcome.playerName} (${match.awayTeam})`;
const bo_c6 = (match, outcome) => 'Jami hisob: 3 ochkolik to&apos;p otishlar';
const bo_d6 = (match, outcome) => 'Jami hisob: 2 ochkolik to&apos;p otishlar';
const bo_e6 = (match, outcome) => `Jami hisob: ${match.homeTeam} ning 3 ochkolik to&apos;p otishlari`;
const bo_f6 = (match, outcome) => `Jami hisob: ${match.awayTeam} ning 3 ochkolik to&apos;p otishlari`;
const bo_g6 = (match, outcome) => `Jami hisob: ${match.homeTeam} ning 2 ochkolik to&apos;p otishlari`;
const bo_h6 = (match, outcome) => `Jami hisob: ${match.awayTeam} ning 2 ochkolik to&apos;p otishlari`;
const bo_i6 = (match, outcome) => 'Fora 3 ochkolik to&apos;p otishlari';
const bo_j6 = (match, outcome) => 'Fora 2 ochkolik to&apos;p otishlari';
const bo_k6 = (match, outcome) => '3 ochkolik to&apos;p otishlari bo&apos;yicha natija';
const bo_l6 = (match, outcome) => '2 ochkolik to&apos;p otishlari bo&apos;yicha natija';
const bo_m6 = (match, outcome) => 'Eng sermahsul bo&apos;lmagan chorak';
const bo_n6 = (match, outcome) => 'O&apos;yindagi jami uzatmalar soni';
const bo_o6 = (match, outcome) => `${match.homeTeam} o&apos;yindagi jami uzatmalar soni`;
const bo_p6 = (match, outcome) => `${match.awayTeam} o&apos;yindagi jami uzatmalar soni`;
const bo_q6 = (match, outcome) => 'O&apos;yindagi uzatmalar sonida fora';
const bo_r6 = (match, outcome) => 'O&apos;yindagi uzatmalar soni bo&apos;yicha g&apos;alaba';
const bo_s6 = (match, outcome) => 'O&apos;yindagi birinchi 2 ochkolik to&apos;p otish';
const bo_t6 = (match, outcome) => 'O&apos;yindagi birinchi 3 ochkolik to&apos;p otish';
const bo_u6 = (match, outcome) => 'O&apos;yindagi birinchi jarimadan to&apos;p otilishi';
const bo_v6 = (match, outcome) => 'Qaysi biri oldin bo&apos;ladi';
const bo_w6 = (match, outcome) => 'Choraklardagi eng ko&apos;p ochko';
const bo_x6 = (match, outcome) => `O&apos;yinda kim birinchi ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} yig&apos;adi`;
const bo_y6 = (match, outcome) => 'O&apos;yindagi jami triple-double soni';
const bo_z6 = (match, outcome) => 'O&apos;yindagi jami double-double soni';
const bo_a7 = (match, outcome) => `Birinchi chorakda kim birinchi ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_b7 = (match, outcome) => `Ikkinchi chorakda kim birinchi ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_c7 = (match, outcome) => `Uchinchi chorakda kim birinchi ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_d7 = (match, outcome) => `To&apos;rtinchi chorakda kim birinchi ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_e7 = (match, outcome) => 'O&apos;yindagi ochkolar farqi';
const bo_f7 = (match, outcome) => 'Birinchi chorakdagi ochkolar farqi';
const bo_g7 = (match, outcome) => 'Ikkinchi chorakdagi ochkolar farqi';
const bo_h7 = (match, outcome) => 'Uchinchi chorakdagi ochkolar farqi';
const bo_i7 = (match, outcome) => 'To&apos;rtinchi chorakdagi ochkolar farqi';
const bo_j7 = (match, outcome) => 'O&apos;yinning birinchi yarimida fora';
const bo_k7 = (match, outcome) => 'O&apos;yinning ikkinchi yarimida fora';
const bo_l7 = (match, outcome) => 'O&apos;yinning birinchi yarimi natijasi';
const bo_m7 = (match, outcome) => 'O&apos;yinning ikkinchi yarimi natijasi';
const bo_n7 = (match, outcome) => 'O&apos;yinning birinchi yarimi jami hisobi';
const bo_o7 = (match, outcome) => 'O&apos;yinning ikkinchi yarimi jami hisobi';
const bo_p7 = (match, outcome) => 'O&apos;yinning birinchi yarimi aniq natijasi';
const bo_q7 = (match, outcome) => 'O&apos;yinning ikkinchi yarimi aniq natijasi';
const bo_r7 = (match, outcome) => 'O&apos;yinning birinchi yarimida ochko farqi bilan g&apos;alaba';
const bo_s7 = (match, outcome) => 'O&apos;yinning ikkinchi yarimida ochko farqi bilan g&apos;alaba';
const bo_t7 = (match, outcome) => `O&apos;yinning birinchi yarimida kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_u7 = (match, outcome) => `O&apos;yinning ikkinchi yarimida kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_v7 = (match, outcome) => `O&apos;yinda kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_w7 = (match, outcome) => 'O&apos;yinning eng sermahsul yarmi';
const bo_x7 = (match, outcome) => 'O&apos;yinning eng sermahsul yarmi jami hisobi';
const bo_y7 = (match, outcome) => 'O&apos;yinning eng sermahsul bo&apos;lmagan yarmi jami hisobi';
const bo_z7 = (match, outcome) => `${match.homeTeam} o&apos;yinning birinchi yarmida ham g&apos;alaba qozonadi`;
const bo_a8 = (match, outcome) => `${match.awayTeam} o&apos;yinning birinchi yarmida ham g&apos;alaba qozonadi`;
const bo_b8 = (match, outcome) => `${match.homeTeam} ning o&apos;yin birinchi yarmidagi jami hisobi`;
const bo_c8 = (match, outcome) => `${match.homeTeam} ning o&apos;yin ikkinchi yarmidagi jami hisobi`;
const bo_d8 = (match, outcome) => `${match.awayTeam} ning o&apos;yin birinchi yarmidagi jami hisobi`;
const bo_e8 = (match, outcome) => `${match.awayTeam} ning o&apos;yin ikkinchi yarmidagi jami hisobi`;
const bo_f8 = (match, outcome) => `O&apos;yinning birinchi yarmida kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_g8 = (match, outcome) => `O&apos;yinning ikkinchi yarmida kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_h8 = (match, outcome) => 'Birinchi davr jami hisobi';
const bo_i8 = (match, outcome) => 'Ikkinchi davr jami hisobi';
const bo_j8 = (match, outcome) => 'Uchinchi davr jami hisobi';
const bo_k8 = (match, outcome) => 'Birinchi davr natijasi';
const bo_l8 = (match, outcome) => 'Ikkinchi davr natijasi';
const bo_m8 = (match, outcome) => 'Uchinchi davr natijasi';
const bo_n8 = (match, outcome) => 'Penaltini hisobga olgandagi g&apos;alaba';
const bo_o8 = (match, outcome) => 'Farq bilan g&apos;alaba 1';
const bo_p8 = (match, outcome) => 'Farq bilan g&apos;alaba 2';
const bo_q8 = (match, outcome) => '1-davrda nechta jamoa gol uradi?';
const bo_r8 = (match, outcome) => '2-davrda nechta jamoa gol uradi?';
const bo_s8 = (match, outcome) => '3-davrda nechta jamoa gol uradi?';
const bo_t8 = (match, outcome) => 'Davr-o&apos;yin';
const bo_u8 = (match, outcome) => 'Overtime jami hisobi';
const bo_v8 = (match, outcome) => 'Overtime natijasi';
const bo_w8 = (match, outcome) => 'Overtime da fora';
const bo_x8 = (match, outcome) => 'Birinchi davrda fora';
const bo_y8 = (match, outcome) => 'Ikkinchi davrda fora';
const bo_z8 = (match, outcome) => 'Uchinchi davrda fora';
const bo_a9 = (match, outcome) => 'Birinchi davr aniq hisobi';
const bo_b9 = (match, outcome) => 'Ikkinchi davr aniq hisobi';
const bo_c9 = (match, outcome) => 'Uchinchi davr aniq hisobi';
const bo_d9 = (match, outcome) => `Kim ${numeralMaleEnding(outcome.condition)}-golni kiritadi?`;
const bo_e9 = (match, outcome) => 'Birinchi setda Fora';
const bo_f9 = (match, outcome) => 'Ikkinchi setda Fora';
const bo_g9 = (match, outcome) => 'Uchinchi setda Fora';
const bo_h9 = (match, outcome) => 'Birinchi set jami hisobi';
const bo_i9 = (match, outcome) => 'Ikkinchi set jami hisobi';
const bo_j9 = (match, outcome) => 'Uchinchi set jami hisobi';
const bo_k9 = (match, outcome) => 'O&apos;yindagi jami setlar hisobi';
const bo_l9 = (match, outcome) => 'O&apos;yin jami hisobining juft/tuq';
const bo_m9 = (match, outcome) => `${match.homeTeam} ning birinchi setdagi jami hisobi`;
const bo_n9 = (match, outcome) => `${match.homeTeam} ning ikkinchi setdagi jami hisobi`;
const bo_o9 = (match, outcome) => `${match.homeTeam} ning uchinchi setdagi jami hisobi`;
const bo_p9 = (match, outcome) => `${match.awayTeam} ning birinchi setdagi jami hisobi`;
const bo_q9 = (match, outcome) => `${match.awayTeam} ning ikkinchi setdagi jami hisobi`;
const bo_r9 = (match, outcome) => `${match.awayTeam} ning uchinchi setdagi jami hisobi`;
const bo_s9 = (match, outcome) => 'O&apos;yin partiyalari bo&apos;yicha fora';
const bo_t9 = (match, outcome) => 'Birinchi setning aniq jami hisobi';
const bo_u9 = (match, outcome) => 'Ikkinchi setning aniq jami hisobi';
const bo_v9 = (match, outcome) => 'Uchinchi setning aniq jami hisobi';
const bo_w9 = (match, outcome) => `${match.homeTeam} birinchi setda farq bilan g&apos;alaba qozonadi`;
const bo_x9 = (match, outcome) => `${match.homeTeam} ikkinchi setda farq bilan g&apos;alaba qozonadi`;
const bo_y9 = (match, outcome) => `${match.homeTeam} uchinchi setda farq bilan g&apos;alaba qozonadi`;
const bo_z9 = (match, outcome) => `${match.awayTeam} birinchi setda farq bilan g&apos;alaba qozonadi`;
const bo_a10 = (match, outcome) => `${match.awayTeam} ikkinchi setda farq bilan g&apos;alaba qozonadi`;
const bo_b10 = (match, outcome) => `${match.awayTeam} uchinchi setda farq bilan g&apos;alaba qozonadi`;
const bo_c10 = (match, outcome) => 'Birinchi set juft/toq';
const bo_d10 = (match, outcome) => 'Ikkinchi set juft/toq';
const bo_e10 = (match, outcome) => 'Uchinchi set juft/toq';
const bo_f10 = (match, outcome) => `Birinchi set g&apos;alaba va ${outcome.condition} jami hisob`;
const bo_g10 = (match, outcome) => `Ikkinchi set g&apos;alaba va ${outcome.condition} jami hisob`;
const bo_h10 = (match, outcome) => `Uchinchi set g&apos;alaba va ${outcome.condition} jami hisob`;
const bo_i10 = (match, outcome) => 'Birinchi setning 10 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
const bo_j10 = (match, outcome) => 'Ikkinchi setning 10 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
const bo_k10 = (match, outcome) => 'Birinchi setning 10 ochkogacha bo&apos;lgan kichik setida fora';
const bo_l10 = (match, outcome) => 'Ikkinchi setning 10 ochkogacha bo&apos;lgan kichik setida fora';
const bo_m10 = (match, outcome) => 'Birinchi setning 10 ochkogacha bo&apos;lgan kichik setida jami hisob';
const bo_n10 = (match, outcome) => 'Ikkinchi setning 10 ochkogacha bo&apos;lgan kichik setida jami hisob';
const bo_o10 = (match, outcome) => 'Birinchi setning 15 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
const bo_p10 = (match, outcome) => 'Ikkinchi setning 15 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
const bo_q10 = (match, outcome) => 'Birinchi setning 15 ochkogacha bo&apos;lgan kichik setida fora';
const bo_r10 = (match, outcome) => 'Ikkinchi setning 15 ochkogacha bo&apos;lgan kichik setida fora';
const bo_s10 = (match, outcome) => 'Birinchi setning 15 ochkogacha bo&apos;lgan kichik setida jami hisob';
const bo_t10 = (match, outcome) => 'Ikkinchi setning 15 ochkogacha bo&apos;lgan kichik setida jami hisob';
const bo_u10 = (match, outcome) => `Birinchi setda kim ${numeralNeuterEnding(outcome.condition)} ochkoni ni yutadi`;
const bo_v10 = (match, outcome) => `Ikkinchi setda kim ${numeralNeuterEnding(outcome.condition)} ochkoni ni yutadi`;
const bo_w10 = (match, outcome) => `Uchinchi setda kim ${numeralNeuterEnding(outcome.condition)} ochkoni ni yutadi`;
const bo_x10 = (match, outcome) => `O&apos;yin jami hisobi ${outcome.condition} va g&apos;alaba`;
const bo_y10 = (match, outcome) => 'Birinchi setda farq bilan g&apos;alaba';
const bo_z10 = (match, outcome) => 'Ikkinchi setda farq bilan g&apos;alaba';
const bo_a11 = (match, outcome) => 'Uchinchi setda farq bilan g&apos;alaba';
const bo_b11 = (match, outcome) => 'Birinchi otish marrasidagi jami hisob';
const bo_c11 = (match, outcome) => 'Ikkinchi otish marrasidagi jami hisob';
const bo_d11 = (match, outcome) => 'Uchinchi otish marrasidagi jami hisob';
const bo_e11 = (match, outcome) => 'To&apos;rtinchi otish marrasidagi jami hisob';
const bo_f11 = (match, outcome) => 'Beshinchi otish marrasidagi jami hisob';
const bo_g11 = (match, outcome) => 'Oltinchi otish marrasidagi jami hisob';
const bo_h11 = (match, outcome) => 'Yettinchi otish marrasidagi jami hisob';
const bo_i11 = (match, outcome) => 'Sakkizinchi otish marrasidagi jami hisob';
const bo_j11 = (match, outcome) => `Birinchi otish marrasidagi ${match.homeTeam} jami hisobi`;
const bo_k11 = (match, outcome) => `Ikkinchi otish marrasidagi ${match.homeTeam} jami hisobi`;
const bo_l11 = (match, outcome) => `Uchinchi otish marrasidagi ${match.homeTeam} jami hisobi`;
const bo_m11 = (match, outcome) => `To&apos;rtinchi otish marrasidagi ${match.homeTeam} jami hisobi`;
const bo_n11 = (match, outcome) => `Beshinchi otish marrasidagi ${match.homeTeam} jami hisobi`;
const bo_o11 = (match, outcome) => `Oltinchi otish marrasidagi ${match.homeTeam} jami hisobi`;
const bo_p11 = (match, outcome) => `Yettinchi otish marrasidagi ${match.homeTeam} jami hisobi`;
const bo_q11 = (match, outcome) => `Sakkizinchi otish marrasidagi ${match.homeTeam} jami hisobi`;
const bo_r11 = (match, outcome) => `Birinchi otish marrasidagi ${match.awayTeam} jami hisobi`;
const bo_s11 = (match, outcome) => `Ikkinchi otish marrasidagi ${match.awayTeam} jami hisobi`;
const bo_t11 = (match, outcome) => `Uchinchi otish marrasidagi ${match.awayTeam} jami hisobi`;
const bo_u11 = (match, outcome) => `To&apos;rtinchi otish marrasidagi ${match.awayTeam} jami hisobi`;
const bo_v11 = (match, outcome) => `Beshinchi otish marrasidagi ${match.awayTeam} jami hisobi`;
const bo_w11 = (match, outcome) => `Oltinchi otish marrasidagi ${match.awayTeam} jami hisobi`;
const bo_x11 = (match, outcome) => `Yettinchi otish marrasidagi ${match.awayTeam} jami hisobi`;
const bo_y11 = (match, outcome) => `Sakkizinchi otish marrasidagi ${match.awayTeam} jami hisobi`;
const bo_z11 = (match, outcome) => 'Birinchi otish marrasidagi fora';
const bo_a12 = (match, outcome) => 'Ikkinchi otish marrasidagi fora';
const bo_b12 = (match, outcome) => 'Uchinchi otish marrasidagi fora';
const bo_c12 = (match, outcome) => 'To&apos;rtinchi otish marrasidagi fora';
const bo_d12 = (match, outcome) => 'Beshinchi otish marrasidagi fora';
const bo_e12 = (match, outcome) => 'Oltinchi otish marrasidagi fora';
const bo_f12 = (match, outcome) => 'Yettinchi otish marrasidagi fora';
const bo_g12 = (match, outcome) => 'Sakkinzinchi otish marrasidagi fora';
const bo_h12 = (match, outcome) => 'Birinchi otish marrasi natijasi';
const bo_i12 = (match, outcome) => 'Ikkinchi otish marrasi natijasi';
const bo_j12 = (match, outcome) => 'Uchinchi otish marrasi natijasi';
const bo_k12 = (match, outcome) => 'To&apos;rtinchi otish marrasi natijasi';
const bo_l12 = (match, outcome) => 'Beshinchi otish marrasi natijasi';
const bo_m12 = (match, outcome) => 'Oltinchi otish marrasi natijasi';
const bo_n12 = (match, outcome) => 'Yettinchi otish marrasi natijasi';
const bo_o12 = (match, outcome) => 'Sakkizinchi otish marrasi natijasi';
const bo_p12 = (match, outcome) => 'Birinchi otish marrasida aniq jami hisob';
const bo_q12 = (match, outcome) => 'Ikkinchi otish marrasida aniq jami hisob';
const bo_r12 = (match, outcome) => 'Uchinchi otish marrasida aniq jami hisob';
const bo_s12 = (match, outcome) => 'To&apos;rtinchi otish marrasida aniq jami hisob';
const bo_t12 = (match, outcome) => 'Beshinchi otish marrasida aniq jami hisob';
const bo_u12 = (match, outcome) => 'Oltinchi otish marrasida aniq jami hisob';
const bo_v12 = (match, outcome) => 'Yettinchi otish marrasida aniq jami hisob';
const bo_w12 = (match, outcome) => 'Sakkizinchi otish marrasida aniq jami hisob';
const bo_x12 = (match, outcome) => 'Muddatidan avval g&apos;alaba bo&apos;ladimi?';
const bo_y12 = (match, outcome) => 'Jangdagi g&apos;alaba usullari';
const bo_z12 = (match, outcome) => 'Jangdagi g&apos;alaba';
const bo_a13 = (match, outcome) => `Kim ${outcome.condition} raundda g&apos;alaba qozonadi?`;
const bo_b13 = (match, outcome) => 'FirstBlood';
const bo_c13 = (match, outcome) => `FirstBlood ${outcome.condition} raundda`;
const bo_d13 = (match, outcome) => `Kim ${outcome.condition} xaritasida g&apos;alaba qozonadi?`;
const bo_e13 = (match, outcome) => `FirstBlood ${outcome.condition} xaritasida`;
const bo_f13 = (match, outcome) => `Kim birinchi bo&apos;lib 1-xaritada ${outcome.condition} ta o&apos;ldirishlarni amalga oshiradi`;
const bo_g13 = (match, outcome) => `Kim birinchi bo&apos;lib 2-xaritada ${outcome.condition} ta o&apos;ldirishlarni amalga oshiradi`;
const bo_h13 = (match, outcome) => `Kim birinchi bo&apos;lib 3-xaritada ${outcome.condition} ta o&apos;ldirishlarni amalga oshiradi`;
const bo_i13 = (match, outcome) => `Kim birinchi bo&apos;lib 4-xaritada ${outcome.condition} ta o&apos;ldirishlarni amalga oshiradi`;
const bo_j13 = (match, outcome) => `Kim birinchi bo&apos;lib 5-xaritada ${outcome.condition} ta o&apos;ldirishlarni amalga oshiradi`;
const bo_k13 = (match, outcome) => 'O&apos;yin natijasi';
const bo_l13 = (match, outcome) => 'Birinchi xaritada g&apos;alaba';
const bo_m13 = (match, outcome) => 'Ikkinchi xaritada g&apos;alaba';
const bo_n13 = (match, outcome) => 'Uchinchi xaritada g&apos;alaba';
const bo_o13 = (match, outcome) => 'To&apos;rtinchi xaritada g&apos;alaba';
const bo_p13 = (match, outcome) => 'Beshinchi xaritada g&apos;alaba';
const bo_q13 = (match, outcome) => 'Birinchi xaritada First blood';
const bo_r13 = (match, outcome) => 'Ikkinchi xaritada First blood';
const bo_s13 = (match, outcome) => 'Uchinchi xaritada First blood';
const bo_t13 = (match, outcome) => 'To&apos;rtinchi xaritada First blood';
const bo_u13 = (match, outcome) => 'Beshinchi xaritada First blood';
const bo_v13 = (match, outcome) => 'Bullitlarni hisobga olgandagi g&apos;alaba';
const bo_w13 = (match, outcome) => `${match.homeTeam} ikkala o&apos;yinda ham g&apos;alaba qozonadi`;
const bo_x13 = (match, outcome) => `${match.awayTeam} ikkala o&apos;yinda ham g&apos;alaba qozonadi`;
const bo_y13 = (match, outcome) => `${outcome.conditionTwo} ta va undan ko&apos;p gol urgan jamoalar (ularning jamisi)`;
const bo_z13 = (match, outcome) => 'Eng sermahsul jamoa (uning jamisi)';
const bo_a14 = (match, outcome) => 'Eng sermahsul bo&apos;lim (jami)';
const bo_b14 = (match, outcome) => `Ikkala bo&apos;lim ham ${outcome.condition} dan kam`;
const bo_c14 = (match, outcome) => `Ikkala bo&apos;lim ham ${outcome.condition} dan ko&apos;p`;
const bo_d14 = (match, outcome) => 'Birinchi bo&apos;lim juft/toq';
const bo_e14 = (match, outcome) => 'Ikkinchi bo&apos;lim juft/toq';
const bo_f14 = (match, outcome) => `${match.homeTeam} birinchi bo&apos;limda nechta gol kiritadi?`;
const bo_g14 = (match, outcome) => `${match.homeTeam} ikkinchi bo&apos;limda nechta gol kiritadi?`;
const bo_h14 = (match, outcome) => `${match.awayTeam}  birinchi bo&apos;limda nechta gol kiritadi?`;
const bo_i14 = (match, outcome) => `${match.awayTeam} ikkinchi bo&apos;limda nechta gol kiritadi?`;
const bo_j14 = (match, outcome) => `${match.homeTeam} o&apos;yinda nechta to&apos;p kiritadi?`;
const bo_k14 = (match, outcome) => `${match.awayTeam} o&apos;yinda nechta to&apos;p kiritadi?`;
const bo_l14 = (match, outcome) => 'Eng sermahsul bo&apos;lmagan jamoa (uning jamisi)';
const bo_m14 = (match, outcome) => `${match.homeTeam} faqat birinchi bo&apos;limda to&apos;p kiritadimi?`;
const bo_n14 = (match, outcome) => `${match.awayTeam} faqat birinchi bo&apos;limda to&apos;p kiritadimi?`;
const bo_o14 = (match, outcome) => `${match.homeTeam} faqat ikkinchi bo&apos;limda to&apos;p kiritadimi?`;
const bo_p14 = (match, outcome) => `${match.awayTeam} faqat ikkinchi bo&apos;limda to&apos;p kiritadimi?`;
const bo_q14 = (match, outcome) => 'Birinchi bo&apos;limda nechta to&apos;p kiritadi';
const bo_r14 = (match, outcome) => 'Ikkinchi bo&apos;limda nechta to&apos;p kiritadi';
const bo_s14 = (match, outcome) => `Nechta jamoalar ${outcome.condition} dan ko&apos;p ${plural(outcome.condition, ['gol', 'gol', 'gol'])} urishadi`;
const bo_t14 = (match, outcome) => 'Birinchi gol qanday kiritiladi?';
const bo_u14 = (match, outcome) => 'Keyingi davraga o&apos;tish';
const bo_v14 = (match, outcome) => 'Kim maydon markazidan boshlaydi?';
const bo_w14 = (match, outcome) => 'Bir jamoa tomonidan ketma-ket ikkita to&apos;p';
const bo_x14 = (match, outcome) => `${match.homeTeam} jamoasi irodali g&apos;alabaga erishadi`;
const bo_y14 = (match, outcome) => `Kim ${numeralFemaleEnding(outcome.condition)} SK oladi`;
const bo_z14 = (match, outcome) => `${match.awayTeam} jamoasi irodali g&apos;alabaga erishadi`;
const bo_a15 = (match, outcome) => 'O&apos;yinda oldin nima sodir bo&apos;ladi?';
const bo_b15 = (match, outcome) => 'Dubl';
const bo_c15 = (match, outcome) => 'Xet-trik';
const bo_d15 = (match, outcome) => `Kim ${numeralMaleEnding(outcome.condition)} burchak to&apos;pini oshirib beradi`;
const bo_e15 = (match, outcome) => `Aniq ${outcome.conditionTwo} ta ${plural(outcome.conditionTwo, ['gol', 'gol', 'gol'])} kiritgan jamoalar jami soni`;
const bo_f15 = (match, outcome) => `O&apos;yinda aniq  ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} kiritiladimi`;
const bo_g15 = (match, outcome) => 'Kim oxirgi golni kiritadi';
const bo_h15 = (match, outcome) => 'Avtogol';
const bo_i15 = (match, outcome) => 'Zahiradan maydonga tushgan o&apos;yinchi gol uradimi?';
const bo_j15 = (match, outcome) => 'Oxirgi gol vaqti';
const bo_k15 = (match, outcome) => 'Kubok sohibi';
const bo_l15 = (match, outcome) => 'Superkubok sohibi';
const bo_m15 = (match, outcome) => `Qaysi bo&apos;limda ${numeralMaleEnding(outcome.condition)} gol kiritiladi?`;
const bo_n15 = (match, outcome) => '1-daqiqadan 15-daqiqagacha ikkilangan natija';
const bo_o15 = (match, outcome) => '16-daqiqadan 30-daqiqagacha ikkilangan natija';
const bo_p15 = (match, outcome) => '31-daqiqadan tanaffusgacha ikkilangan natija';
const bo_q15 = (match, outcome) => '46-daqiqadan 60-daqiqagacha ikkilangan natija';
const bo_r15 = (match, outcome) => '61-daqiqadan 75-daqiqagacha ikkilangan natija';
const bo_s15 = (match, outcome) => '76-daqiqadan o&apos;yin oxirigacha ikkilangan natija';
const bo_t15 = (match, outcome) => `${match.homeTeam} jamoasi ${numeralMaleEnding(outcome.condition)} penaltini amalga oshiradimi (penaltilar seriyasida)?`;
const bo_u15 = (match, outcome) => `${match.awayTeam} jamoasi ${numeralMaleEnding(outcome.condition)} penaltini amalga oshiradimi (penaltilar seriyasida)?`;
const bo_v15 = (match, outcome) => `${match.homeTeam} o&apos;zining ${numeralMaleEnding(outcome.condition)}-chi golini kiritadi`;
const bo_w15 = (match, outcome) => `${match.awayTeam} o&apos;zining ${numeralMaleEnding(outcome.condition)}-chi golini kiritadi`;
const bo_x15 = (match, outcome) => 'Birinchi bo&apos;limdagi jami burchak to&apos;p oshirilishlari soni';
const bo_y15 = (match, outcome) => 'Birinchi bo&apos;limdagi jami SK soni';
const bo_z15 = (match, outcome) => 'O&apos;yin davomidagi burchak zarbalari bo&apos;yicha  fora';
const bo_a16 = (match, outcome) => 'Birinchi bo&apos;lim uchun burchak zarbalari bo&apos;yicha fora';
const bo_b16 = (match, outcome) => 'Sariq kartochkalar bo&apos;yicha fora';
const bo_c16 = (match, outcome) => 'Birinchi bo&apos;lim uchun sariq kartochkalar bo&apos;yicha fora';
const bo_d16 = (match, outcome) => 'Burchak zarbalari bo&apos;yicha natija';
const bo_e16 = (match, outcome) => 'Burchak zarbalari bo&apos;yicha birinchi bo&apos;lim natijasi';
const bo_f16 = (match, outcome) => 'Sariq kartochkalar bo&apos;yicha natija';
const bo_g16 = (match, outcome) => 'Sariq kartochkalar bo&apos;yicha birinchi bo&apos;lim natijasi';
const bo_h16 = (match, outcome) => `Kim birinchi ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} kiritadi`;
const bo_i16 = (match, outcome) => `${numeralMaleEnding(outcome.condition)}- penalti aniq amalga oshiriladimi?`;
const bo_j16 = (match, outcome) => 'O&apos;yinda kiritilgan to&apos;plar jamisi';
const bo_k16 = (match, outcome) => 'Ikkitalik natija';
const bo_l16 = (match, outcome) => 'Yon tomondan to&apos;p oshirilishlar jamisi';
const bo_m16 = (match, outcome) => 'Bo&apos;lim-o&apos;yin';
const bo_n16 = (match, outcome) => 'O&apos;yin hisobi jamisi (Osiyo)';
const bo_o16 = (match, outcome) => 'O&apos;yin hisobining aniq jamisi';
const bo_p16 = (match, outcome) => 'Jami burchak to&apos;plari';
const bo_q16 = (match, outcome) => 'O&apos;yin qanday tugaydi?';
const bo_r16 = (match, outcome) => 'Penaltilar (jami)';
const bo_s16 = (match, outcome) => 'Jami qizil kartochkalar';
const bo_t16 = (match, outcome) => 'Birinchi gol vaqti';
const bo_u16 = (match, outcome) => 'Gollar yig&apos;indisi';
const bo_v16 = (match, outcome) => `Jami: ${match.homeTeam}`;
const bo_w16 = (match, outcome) => `Jami: ${match.awayTeam}`;
const bo_x16 = (match, outcome) => 'Birinchi bo&apos;lim jamisi';
const bo_y16 = (match, outcome) => 'Ikkinchi bo&apos;lim jamisi';
const bo_z16 = (match, outcome) => 'Birinchi bo&apos;lim uchun fora';
const bo_a17 = (match, outcome) => 'Ikkinchi bo&apos;lim uchun fora';
const bo_b17 = (match, outcome) => 'Darvoza tomon zarbalar';
const bo_c17 = (match, outcome) => `G&apos;alaba va ${outcome.condition} jami hisob`;
const bo_d17 = (match, outcome) => 'Jami sariq kartochkalar';
const bo_e17 = (match, outcome) => 'Ikkinchi bo&apos;lim natijasi';
const bo_f17 = (match, outcome) => 'O&apos;yinning 1-daqiqasidan 15-daqiqasigacha fora';
const bo_g17 = (match, outcome) => 'O&apos;yinning 16-daqiqasidan 30-daqiqasigacha fora';
const bo_h17 = (match, outcome) => 'O&apos;yinning 31-daqiqasidan tanaffusgacha fora';
const bo_i17 = (match, outcome) => 'O&apos;yinning 46-daqiqasidan 60-daqiqasigacha fora';
const bo_j17 = (match, outcome) => 'O&apos;yinning 61-daqiqasidan 75-daqiqasigacha fora';
const bo_k17 = (match, outcome) => 'O&apos;yinning 76-daqiqasidan o&apos;yin yakuniga qadar fora';
const bo_l17 = (match, outcome) => `${match.homeTeam} gollar`;
const bo_m17 = (match, outcome) => `${match.awayTeam} gollar`;
const bo_n17 = (match, outcome) => 'Jami o&apos;zgartirishlar';
const bo_o17 = (match, outcome) => 'Jami hisob Juft/Toq';
const bo_p17 = (match, outcome) => '1-dan 15-daqaqiqagacha jami hisob';
const bo_q17 = (match, outcome) => '16-dan 30-daqaqiqagacha jami hisob';
const bo_r17 = (match, outcome) => '31-daqiqadan tanaffusgacha jami hisob';
const bo_s17 = (match, outcome) => '46-dan 60-daqaqiqagacha jami hisob';
const bo_t17 = (match, outcome) => '61-dan 75-daqaqiqagacha jami hisob';
const bo_u17 = (match, outcome) => '76-daqiqadan o&apos;yin yakunigacha jami hisob';
const bo_v17 = (match, outcome) => `1-dan 15-daqiqagacha ${match.homeTeam} ning jami hisobi`;
const bo_w17 = (match, outcome) => `16-dan 30-daqiqagacha ${match.homeTeam} ning jami hisobi`;
const bo_x17 = (match, outcome) => `31-daqiqadan tanaffusgacha ${match.homeTeam} ning jami hisobi`;
const bo_y17 = (match, outcome) => `46-dan 60-daqiqagacha ${match.homeTeam} ning jami hisobi`;
const bo_z17 = (match, outcome) => `61-dan 75-daqiqagacha ${match.homeTeam} ning jami hisobi`;
const bo_a18 = (match, outcome) => `76-daqiqadan o&apos;yin yakunigacha ${match.homeTeam} ning jami hisobi`;
const bo_b18 = (match, outcome) => `1-dan 15-daqiqagacha ${match.awayTeam} ning jami hisobi`;
const bo_c18 = (match, outcome) => `16-dan 30-daqiqagacha ${match.awayTeam} ning jami hisobi`;
const bo_d18 = (match, outcome) => `31-daqiqadan tanaffusgacha ${match.awayTeam} ning jami hisobi`;
const bo_e18 = (match, outcome) => `46-dan 60-daqiqagacha ${match.awayTeam} ning jami hisobi`;
const bo_f18 = (match, outcome) => `61-dan 75-daqiqagacha ${match.awayTeam} ning jami hisobi`;
const bo_g18 = (match, outcome) => `76-daqiqadan o&apos;yin yakunigacha ${match.awayTeam} ning jami hisobi`;
const bo_h18 = (match, outcome) => 'Birinchi bo&apos;limning aniq jami hisobi';
const bo_i18 = (match, outcome) => 'Ikkinchi bo&apos;limning aniq jami hisobi';
const bo_j18 = (match, outcome) => `${match.homeTeam} g&apos;alaba qozonadi va yutqazmaydi`;
const bo_k18 = (match, outcome) => `${match.awayTeam} g&apos;alaba qozonadi va yutqazmaydi`;
const bo_l18 = (match, outcome) => `${match.homeTeam} aniq ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} kiritadi`;
const bo_m18 = (match, outcome) => `${match.awayTeam} aniq ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} kiritadi`;
const bo_n18 = (match, outcome) => 'Birinchi bo&apos;limning aniq hisobi';
const bo_o18 = (match, outcome) => 'Ikkinchi bo&apos;limning aniq hisobi';
const bo_p18 = (match, outcome) => 'Jami kiritilmagan penaltilar soni';
const bo_q18 = (match, outcome) => `Ikkala jamoa ham ${outcome.condition} tadan kam to&apos;p kiritishadi`;
const bo_r18 = (match, outcome) => `Ikkala jamoa ham ${outcome.condition} tadan ko&apos;p to&apos;p kiritishadi`;
const bo_s18 = (match, outcome) => 'Bo&apos;limlarni taqqoslash (gollar)';
const bo_t18 = (match, outcome) => '1-dan 15-daqiqagacha g&apos;alaba';
const bo_u18 = (match, outcome) => '16-dan 30-daqiqagacha g&apos;alaba';
const bo_v18 = (match, outcome) => '31-daqiqadan tanaffusgacha g&apos;alaba';
const bo_w18 = (match, outcome) => '46-dan 60-daqiqagacha g&apos;alaba';
const bo_x18 = (match, outcome) => '61-dan 75-daqiqagacha g&apos;alaba';
const bo_y18 = (match, outcome) => '76-daqiqadan o&apos;yin yakunigacha g&apos;alaba';
const bo_z18 = (match, outcome) => `${match.homeTeam} jamoasi ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} farqi bilan g&apos;alaba qozonadi`;
const bo_a19 = (match, outcome) => `${match.awayTeam} jamoasi ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} farqi bilan g&apos;alaba qozonadi`;
const bo_b19 = (match, outcome) => `${match.homeTeam} bitta bo&apos;limda g&apos;alaba qozonadi`;
const bo_c19 = (match, outcome) => `${match.awayTeam} bitta bo&apos;limda g&apos;alaba qozonadi`;
const bo_d19 = (match, outcome) => `${outcome.conditionTwo} tadan ${outcome.conditionThree} gacha to&apos;p kiritgan jamoalarining jami soni`;
const bo_e19 = (match, outcome) => `Jami: ${match.homeTeam} uchun birinchi bo&apos;lim`;
const bo_f19 = (match, outcome) => `Jami: ${match.homeTeam} uchun ikkinchi bo&apos;lim`;
const bo_g19 = (match, outcome) => `Jami: ${match.awayTeam} uchun birinchi bo&apos;lim`;
const bo_h19 = (match, outcome) => `Jami: ${match.awayTeam} uchun ikkinchi bo&apos;lim`;
const bo_i19 = (match, outcome) => `(${match.homeTeam}) jamoasidagi ${outcome.playerName} to&apos;p kiritadimi?`;
const bo_j19 = (match, outcome) => `(${match.awayTeam}) jamoasidagi ${outcome.playerName} to&apos;p kiritadimi?`;
const bo_k19 = (match, outcome) => 'O&apos;yin forasi';
const bo_l19 = (match, outcome) => 'O&apos;yin jami hisobi';
const bo_m19 = (match, outcome) => 'Mezbonlar jami hisobi';
const bo_n19 = (match, outcome) => 'Mehmonlar jami hisobi';
const bo_o19 = (match, outcome) => 'Eng sermahsul o&apos;yin jami hisobi';
const bo_p19 = (match, outcome) => 'Eng sermahsul bo&apos;lmagan o&apos;yin jami hisobi';
const bo_q19 = (match, outcome) => 'Golsiz o&apos;yinlar jami hisobi';
const bo_r19 = (match, outcome) => 'Mezbonlarning jami g&apos;alabalari';
const bo_s19 = (match, outcome) => 'Mehmonlarning jami g&apos;alabalari';
const bo_t19 = (match, outcome) => 'Durranglar jami soni';
const bo_u19 = (match, outcome) => `Jami: ${outcome.playerName} (${match.homeTeam})`;
const bo_v19 = (match, outcome) => `Jami: ${outcome.playerName} (${match.awayTeam})`;
const bo_w19 = (match, outcome) => 'Ikkala jamoa ham 1-bo&apos;lim / 2-bo&apos;limda to&apos;p kiritadi';
const bo_x19 = (match, outcome) => `Jami hisob ${outcome.condition} va ikkala jamoa to&apos;p kiritadi`;
const bo_y19 = (match, outcome) => `${match.homeTeam} to&apos;p kiritadi va g&apos;alaba qozonmaydi`;
const bo_z19 = (match, outcome) => `(${match.awayTeam}) to&apos;p kiritadi va g&apos;alaba qozonmaydi`;
const bo_a20 = (match, outcome) => 'Метод победы в матче O&apos;yinda g&apos;alaba qozonish usuli';
const bo_b20 = (match, outcome) => '1-bo&apos;limga qo&apos;shib berilgan vaqt';
const bo_c20 = (match, outcome) => '2-bo&apos;limga qo&apos;shib berilgan vaqt';
const bo_d20 = (match, outcome) => 'O&apos;yinda to&apos;sin / ustunga to&apos;p tegadimi';
const bo_e20 = (match, outcome) => 'Birinchi o&apos;yin almashtirilish vaqti';
const bo_f20 = (match, outcome) => `Qizil kartochkani ${match.homeTeam} jamoasi vakili oladi`;
const bo_g20 = (match, outcome) => `Qizil kartochkani ${match.awayTeam} jamoasi vakili oladi`;
const bo_h20 = (match, outcome) => 'Penalti va chetlatish bo&apos;ladimi';
const bo_i20 = (match, outcome) => 'Qo&apos;shimcha vaqtda gol';
const bo_j20 = (match, outcome) => 'Simulyatsiya uchun sariq kartochka';
const bo_k20 = (match, outcome) => 'Fudbolkani yechganlik uchun SK';
const bo_l20 = (match, outcome) => 'Har bir bayroqchadan burchak to&apos;pi';
const bo_m20 = (match, outcome) => 'Kim 3-o&apos;rinni egallaydi?';
const bo_n20 = (match, outcome) => `Jami: ${match.awayTeam}  (qo&apos;shimcha bo&apos;lim)`;
const bo_o20 = (match, outcome) => `Jami: ${match.homeTeam}  (qo&apos;shimcha bo&apos;lim)`;
const bo_p20 = (match, outcome) => 'Ikkilangan natija (qo&apos;shimcha vaqt)';
const bo_q20 = (match, outcome) => 'Aniq hisob  (qo&apos;shimcha bo&apos;lim)';
const bo_r20 = (match, outcome) => 'Fora (Qo&apos;shimcha bo&apos;lim)';
const bo_s20 = (match, outcome) => 'Jami hisob  (Qo&apos;shimcha bo&apos;lim)';
const bo_t20 = (match, outcome) => 'Natija (Qo&apos;shimcha bo&apos;lim)';
const bo_u20 = (match, outcome) => `Qo&apos;shimcha bo&apos;limda ${numeralMaleEnding(outcome.condition)} golni kim kiritadi?`;
const bo_v20 = (match, outcome) => '1-qo&apos;shimcha bo&apos;limdagi fora';
const bo_w20 = (match, outcome) => '1-qo&apos;shimcha bo&apos;limdagi jami hisob';
const bo_x20 = (match, outcome) => '1-qo&apos;shimcha bo&apos;limdagi natija';
const bo_y20 = (match, outcome) => '2-qo&apos;shimcha bo&apos;limdagi fora';
const bo_z20 = (match, outcome) => '2-qo&apos;shimcha bo&apos;limdagi jami hisob';
const bo_a21 = (match, outcome) => '2-qo&apos;shimcha bo&apos;limdagi natija';
const bo_b21 = (match, outcome) => 'Penaltilar seriyasidagi aniq hisob';
const bo_c21 = (match, outcome) => `Jami kiritilgan penaltilar soni: ${match.awayTeam} (penaltilar seriyasida)`;
const bo_d21 = (match, outcome) => `Jami kiritilgan penaltilar soni: ${match.homeTeam} (penaltilar seriyasida)`;
const bo_e21 = (match, outcome) => 'Jami kiritilgan penaltilar soni (penaltilar seriyasida)';
const bo_f21 = (match, outcome) => 'Jami kiritilmagan penaltilar soni (penaltilar seriyasida)';
const bo_g21 = (match, outcome) => `Yevropacha fora  ${europeanHandicapCondition(outcome.condition)}`;
const bo_h21 = (match, outcome) => `1-bo&apos;limda yevropacha fora  ${europeanHandicapCondition(outcome.condition)}`;
const bo_i21 = (match, outcome) => `2-bo&apos;limda yevropacha fora  ${europeanHandicapCondition(outcome.condition)}`;
const bo_j21 = (match, outcome) => `Birinchi bo&apos;limda kim ${numeralMaleEnding(outcome.condition)} golni kiritadi?`;
const bo_k21 = (match, outcome) => `O&apos;yinning qolgan vaqti (hozirgi hisob ${outcome.condition}:${outcome.conditionTwo})`;
const bo_l21 = (match, outcome) => `Birinchi bo&apos;limning qolgan vaqti (hozirgi hisob ${outcome.condition}:${outcome.conditionTwo})`;
const bo_m21 = (match, outcome) => `${match.homeTeam} ning jami burchak zarbalari soni`;
const bo_n21 = (match, outcome) => `${match.awayTeam} ning jami burchak zarbalari soni`;
const bo_o21 = (match, outcome) => `${match.homeTeam} ning jami burchak to&apos;plari soni`;
const bo_p21 = (match, outcome) => `${match.awayTeam} ning jami burchak to&apos;plari soni`;
const bo_q21 = (match, outcome) => 'Birinchi golning daqiqasi';
const bo_r21 = (match, outcome) => 'Birinchi bo&apos;lim ikkilangan natija';
const bo_s21 = (match, outcome) => 'Ikkinchi bo&apos;lim ikkilangan natija';
const bo_t21 = (match, outcome) => 'Ikkalasi gor uradimi?';
const bo_u21 = (match, outcome) => `${match.homeTeam} ikkala bo&apos;limda ham g&apos;alaba qozonadi`;
const bo_v21 = (match, outcome) => `${match.awayTeam} ikkala bo&apos;limda ham g&apos;alaba qozonadi`;
const bo_w21 = (match, outcome) => 'O&apos;yin hisobi jamisi';
const bo_x21 = (match, outcome) => 'Gollar vaqtlari yig&apos;indisi';
const bo_y21 = (match, outcome) => `${match.homeTeam} g&apos;alaba qozonadi va to&apos;p o&apos;tqazmaydi`;
const bo_z21 = (match, outcome) => `${match.awayTeam} g&apos;alaba qozonadi va to&apos;p o&apos;tqazmaydi`;
const bo_a22 = (match, outcome) => 'Ikkinchi bo&apos;lim jami hisobi';
const bo_b22 = (match, outcome) => 'Birinchi bo&apos;lim aniq jami hisobi';
const bo_c22 = (match, outcome) => 'Ikkinchi bo&apos;lim aniq jami hisobi';
const bo_d22 = (match, outcome) => `O&apos;yinning jami hisobi ${outcome.condition} va g&apos;alaba`;
const bo_e22 = (match, outcome) => `${match.homeTeam} farq bilan birinchi bo&apos;limdagi g&apos;alabasi`;
const bo_f22 = (match, outcome) => `${match.homeTeam} farq bilan ikkinchi bo&apos;limdagi g&apos;alabasi`;
const bo_g22 = (match, outcome) => `${match.awayTeam} farq bilan birinchi bo&apos;limdagi g&apos;alabasi`;
const bo_h22 = (match, outcome) => `${match.awayTeam} farq bilan ikkinchi bo&apos;limdagi g&apos;alabasi`;
const bo_i22 = (match, outcome) => `Kim birinchi bo&apos;lib ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} kiritadi`;
const bo_j22 = (match, outcome) => 'Ikkinchi bo&apos;limda fora';
const bo_k22 = (match, outcome) => 'Xet-triklar (jami hisobi)';
const bo_l22 = (match, outcome) => 'O&apos;yin jami hisobi jami hisobi juft/toq';
const bo_m22 = (match, outcome) => `${match.homeTeam} g&apos;alaba qozonadi va o&apos;tkazib yubormaydi`;
const bo_n22 = (match, outcome) => `${match.awayTeam} g&apos;alaba qozonadi va o&apos;tkazib yubormaydi`;
const bo_o22 = (match, outcome) => 'Birinchi davr aniq jami hisobi';
const bo_p22 = (match, outcome) => 'Ikkinchi davr aniq jami hisobi';
const bo_q22 = (match, outcome) => 'Uchinchi davr aniq jami hisobi';
const bo_r22 = (match, outcome) => `Nechta jamoa  ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} kiritadi`;
const bo_s22 = (match, outcome) => `${match.homeTeam} aniq ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} bilan g&apos;alaba qozonadi`;
const bo_t22 = (match, outcome) => `${match.awayTeam} aniq ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} bilan g&apos;alaba qozonadi`;
const bo_u22 = (match, outcome) => `Nechta jamoa ${outcome.condition} ta ${plural(outcome.condition, ['gol', 'gol', 'gol'])} kiritadi`;
const bo_v22 = (match, outcome) => 'Eng sermahsul jamoa (uning jami hisobi)';
const bo_w22 = (match, outcome) => 'Eng sermahsul bo&apos;lmagan jamoa (uning jami hisobi)';
const bo_x22 = (match, outcome) => 'Birinchi davr juft/toq';
const bo_y22 = (match, outcome) => 'Ikkinchi davr juft/toq';
const bo_z22 = (match, outcome) => 'Uchinchi davr juft/toq';
const bo_a23 = (match, outcome) => 'Eng sermahsul davr (jami hisob)';
const bo_b23 = (match, outcome) => 'Eng sermahsul bo&apos;lmagan davr (jami hisob)';
const bo_c23 = (match, outcome) => 'Birinchi davrning aniq jami hisobi';
const bo_d23 = (match, outcome) => 'Ikkinchi davrning aniq jami hisobi';
const bo_e23 = (match, outcome) => 'Uchinchi davrning aniq jami hisobi';
const bo_f23 = (match, outcome) => `${match.homeTeam} ning birinchi davrdagi jami hisobi`;
const bo_g23 = (match, outcome) => `${match.homeTeam} ning ikkinchi davrdagi jami hisobi`;
const bo_h23 = (match, outcome) => `${match.homeTeam} ning uchinchi davrdagi jami hisobi`;
const bo_i23 = (match, outcome) => `${match.awayTeam} ning birinchi davrdagi jami hisobi`;
const bo_j23 = (match, outcome) => `${match.awayTeam} ning ikkinchi davrdagi jami hisobi`;
const bo_k23 = (match, outcome) => `${match.awayTeam} ning uchinchi davrdagi jami hisobi`;
const bo_l23 = (match, outcome) => `G&apos;alaba va o&apos;yinning aniq hisobi ${outcome.condition}`;
const bo_m23 = (match, outcome) => 'Overtime bo&apos;lidimi';
const bo_n23 = (match, outcome) => 'Ikkala jamoa ham gol uradi';
const bo_o23 = (match, outcome) => `${match.homeTeam} ${numeralMaleEnding(outcome.condition)}-bullitni kiritadimi?`;
const bo_p23 = (match, outcome) => `${match.awayTeam} ${numeralMaleEnding(outcome.condition)}-bullitni kiritadimi?`;
const bo_q23 = (match, outcome) => 'OT ni hisobga olgandagi g&apos;alaba';
const bo_r23 = (match, outcome) => 'Davr-O&apos;yin';
const bo_s23 = (match, outcome) => `${match.homeTeam} har bir davrda gol uradi`;
const bo_t23 = (match, outcome) => `${match.awayTeam} har bir davrda gol uradi`;
const bo_u23 = (match, outcome) => 'Har bir davrda gol uriladi';
const bo_v23 = (match, outcome) => 'Birinchi va ikkinchi davrni taqqoslash';
const bo_w23 = (match, outcome) => 'Birinchi va uchinchi davrni taqqoslash';
const bo_x23 = (match, outcome) => 'Uchinchi va ikkinchi davrni taqqoslash';
const bo_y23 = (match, outcome) => `${match.homeTeam} davrlarning birida g&apos;alaba qozonadi`;
const bo_z23 = (match, outcome) => `${match.awayTeam} davrlarning birida g&apos;alaba qozonadi`;
const bo_a24 = (match, outcome) => 'Hech bo&apos;lmaganda bitta davrda durrang';
const bo_b24 = (match, outcome) => 'O&apos;yinning 1 dan 10-daqiqasigacha g&apos;alaba';
const bo_c24 = (match, outcome) => 'O&apos;yinning 11 dan 20-daqiqasigacha g&apos;alaba';
const bo_d24 = (match, outcome) => 'O&apos;yinning 21 dan 30-daqiqasigacha g&apos;alaba';
const bo_e24 = (match, outcome) => 'O&apos;yinning 31 dan 40-daqiqasigacha g&apos;alaba';
const bo_f24 = (match, outcome) => 'O&apos;yinning 41 dan 50-daqiqasigacha g&apos;alaba';
const bo_g24 = (match, outcome) => 'O&apos;yinning 51 dan 60-daqiqasigacha g&apos;alaba';
const bo_h24 = (match, outcome) => 'O&apos;yinning 1 dan 10-daqiqasigacha fora';
const bo_i24 = (match, outcome) => 'O&apos;yinning 11 dan 20-daqiqasigacha fora';
const bo_j24 = (match, outcome) => 'O&apos;yinning 21 dan 30-daqiqasigacha fora';
const bo_k24 = (match, outcome) => 'O&apos;yinning 31 dan 40-daqiqasigacha fora';
const bo_l24 = (match, outcome) => 'O&apos;yinning 41 dan 50-daqiqasigacha fora';
const bo_m24 = (match, outcome) => 'O&apos;yinning 51 dan 60-daqiqasigacha fora';
const bo_n24 = (match, outcome) => 'O&apos;yinning 1 dan 10-daqiqasigacha jami hisob';
const bo_o24 = (match, outcome) => 'O&apos;yinning 11 dan 20-daqiqasigacha jami hisob';
const bo_p24 = (match, outcome) => 'O&apos;yinning 21 dan 30-daqiqasigacha jami hisob';
const bo_q24 = (match, outcome) => 'O&apos;yinning 31 dan 40-daqiqasigacha jami hisob';
const bo_r24 = (match, outcome) => 'O&apos;yinning 41 dan 50-daqiqasigacha jami hisob';
const bo_s24 = (match, outcome) => 'O&apos;yinning 51 dan 60-daqiqasigacha jami hisob';
const bo_t24 = (match, outcome) => 'Nechta jamoa birinchi davrda gol uradi?';
const bo_u24 = (match, outcome) => 'Nechta jamoa ikkinchi davrda gol uradi?';
const bo_v24 = (match, outcome) => 'Nechta jamoa uchinchi davrda gol uradi?';
const bo_w24 = (match, outcome) => `${match.homeTeam} irodali g&apos;alaba qozonadi`;
const bo_x24 = (match, outcome) => `${match.awayTeam} irodali g&apos;alaba qozonadi`;
const bo_y24 = (match, outcome) => 'Tushgan eng katta shar juft/toq';
const bo_z24 = (match, outcome) => 'Tushgan eng kichik shar juft/toq';
const bo_a25 = (match, outcome) => 'Tushgan birinchi shar juft/toq';
const bo_b25 = (match, outcome) => 'Tushgan oxirgi shar juft/toq';
const bo_c25 = (match, outcome) => 'Birinchisi oxirgisidan kichik/katta';
const bo_d25 = (match, outcome) => 'Barcha sharlat juft';
const bo_e25 = (match, outcome) => 'Barcha sharlat toq';
const bo_f25 = (match, outcome) => 'Hech bo&apos;lmaganda ikkita shar qo&apos;shni raqamlar';
const bo_g25 = (match, outcome) => 'Tushgan eng kichik shar';
const bo_h25 = (match, outcome) => 'Tushgan eng katta shar';
const bo_i25 = (match, outcome) => 'Tushgan jami sharlar yig&apos;indisi';
const bo_j25 = (match, outcome) => `Hech bo&apos;lmaganda bitta shar karrali ${outcome.condition}`;
const bo_k25 = (match, outcome) => 'Eng kichik va eng katta sharlar farqi';
const bo_l25 = (match, outcome) => 'Toq sharlar yig&apos;indisi';
const bo_m25 = (match, outcome) => 'Juft sharlar yig&apos;indisi';
const bo_n25 = (match, outcome) => 'Birinchi tushgan shar';
const bo_o25 = (match, outcome) => 'Ikkinchi tushgan shar';
const bo_p25 = (match, outcome) => 'Uchinchi tushgan shar';
const bo_q25 = (match, outcome) => 'To&apos;rtinchi tushgan shar';
const bo_r25 = (match, outcome) => 'Beshinchi tushgan shar';
const bo_s25 = (match, outcome) => 'Oltinchi tushgan shar';
const bo_t25 = (match, outcome) => 'Yettinchi tushgan shar';
const bo_u25 = (match, outcome) => `Hech bo&apos;lmaganda bitta shar ${outcome.condition} dan ${outcome.conditionTwo} gacha oraliqda tushadi`;
const bo_v25 = (match, outcome) => 'Eng katta va eng kichik sharlar yig&apos;indisi';
const bo_w25 = (match, outcome) => 'Match Total';
const bo_x25 = (match, outcome) => 'Round Betting';
const bo_y25 = (match, outcome) => 'Will Fight Go The Distance?';
const bo_z25 = (match, outcome) => `${match.homeTeam} to win by Submission`;
const bo_a26 = (match, outcome) => `${match.awayTeam} to win by Submission`;
const bo_b26 = (match, outcome) => `${match.homeTeam} to win by KO/TKO/DQ`;
const bo_c26 = (match, outcome) => `${match.awayTeam} to win by KO/TKO/DQ`;
const bo_d26 = (match, outcome) => 'Jami medallar soni';
const bo_e26 = (match, outcome) => 'Yigirma to&apos;qqizinchi partiya natijasi';
const bo_f26 = (match, outcome) => 'O&apos;ttizinchi partiya natijasi';
const bo_g26 = (match, outcome) => 'O&apos;ttiz birinchi partiya natijasi';
const bo_h26 = (match, outcome) => 'O&apos;ttiz ikkinchi partiya natijasi';
const bo_i26 = (match, outcome) => 'O&apos;ttiz uchinchi partiya natijasi';
const bo_j26 = (match, outcome) => 'O&apos;ttiz to&apos;rtinchi partiya natijasi';
const bo_k26 = (match, outcome) => 'O&apos;ttiz beshinchi partiya natijasi';
const bo_l26 = (match, outcome) => 'O&apos;ttiz oltinchi partiya natijasi';
const bo_m26 = (match, outcome) => 'O&apos;ttiz yettinchi partiya natijasi';
const bo_n26 = (match, outcome) => 'O&apos;n sakkizinchi partiya juft/toq';
const bo_o26 = (match, outcome) => 'O&apos;n to&apos;qqizinchi partiya juft/toq';
const bo_p26 = (match, outcome) => 'Yigirmanchi partiya juft/toq';
const bo_q26 = (match, outcome) => 'Yigirma birinchi partiya juft/toq';
const bo_r26 = (match, outcome) => 'Yigirma ikkinchi partiya juft/toq';
const bo_s26 = (match, outcome) => 'Yigirma uchinchi partiya juft/toq';
const bo_t26 = (match, outcome) => 'Yigirma to&apos;rtinchi partiya juft/toq';
const bo_u26 = (match, outcome) => 'Yigirma beshinchi partiya juft/toq';
const bo_v26 = (match, outcome) => 'Yigirma oltinchi partiya juft/toq';
const bo_w26 = (match, outcome) => 'Yigirma yettinchi partiya juft/toq';
const bo_x26 = (match, outcome) => 'Yigirma sakkizinchi partiya juft/toq';
const bo_y26 = (match, outcome) => 'Yigirma to&apos;qqizinchi partiya juft/toq';
const bo_z26 = (match, outcome) => 'O&apos;ttizinchi partiya juft/toq';
const bo_a27 = (match, outcome) => 'O&apos;ttiz birinchi partiya juft/toq';
const bo_b27 = (match, outcome) => 'O&apos;ttiz ikkinchi partiya juft/toq';
const bo_c27 = (match, outcome) => 'O&apos;ttiz uchinchi partiya juft/toq';
const bo_d27 = (match, outcome) => 'O&apos;ttiz to&apos;rtinchi partiya juft/toq';
const bo_e27 = (match, outcome) => 'O&apos;ttiz beshinchi partiya juft/toq';
const bo_f27 = (match, outcome) => 'O&apos;ttiz oltinchi partiya juft/toq';
const bo_g27 = (match, outcome) => 'O&apos;ttiz yettinchi partiya juft/toq';
const bo_h27 = (match, outcome) => 'Birinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_i27 = (match, outcome) => 'Ikkinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_j27 = (match, outcome) => 'Uchinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_k27 = (match, outcome) => 'To&apos;rtinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_l27 = (match, outcome) => 'Beshinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_m27 = (match, outcome) => 'Oltinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_n27 = (match, outcome) => 'Yettinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_o27 = (match, outcome) => 'Sakkizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_p27 = (match, outcome) => 'To&apos;qqizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_q27 = (match, outcome) => 'O&apos;ninchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_r27 = (match, outcome) => 'O&apos;n birinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_s27 = (match, outcome) => 'O&apos;n ikkinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_t27 = (match, outcome) => 'O&apos;n uchinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_u27 = (match, outcome) => 'O&apos;n to&apos;rtinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_v27 = (match, outcome) => 'O&apos;n beshinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_w27 = (match, outcome) => 'O&apos;n oltinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_x27 = (match, outcome) => 'O&apos;n yettinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_y27 = (match, outcome) => 'O&apos;n sakkizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_z27 = (match, outcome) => 'O&apos;n to&apos;qqizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_a28 = (match, outcome) => 'Yigirmanchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_b28 = (match, outcome) => 'Yigirma birinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_c28 = (match, outcome) => 'Yigirma ikkinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_d28 = (match, outcome) => 'Yigirma uchinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_e28 = (match, outcome) => 'Yigirma to&apos;rtinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_f28 = (match, outcome) => 'Yigirma beshinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_g28 = (match, outcome) => 'Yigirma oltinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_h28 = (match, outcome) => 'Yigirma yettinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_i28 = (match, outcome) => 'Yigirma sakkizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_j28 = (match, outcome) => 'Yigirma to&apos;qqizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_k28 = (match, outcome) => 'O&apos;ttizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_l28 = (match, outcome) => 'O&apos;ttiz birinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_m28 = (match, outcome) => 'O&apos;ttiz ikkinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_n28 = (match, outcome) => 'O&apos;ttiz uchinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_o28 = (match, outcome) => 'O&apos;ttiz to&apos;rtinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_p28 = (match, outcome) => 'O&apos;ttiz beshinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_q28 = (match, outcome) => 'O&apos;ttiz oltinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_r28 = (match, outcome) => 'O&apos;ttiz yettinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
const bo_s28 = (match, outcome) => 'Birinchi partiya natijasi';
const bo_t28 = (match, outcome) => 'Ikkinchi partiya natijasi';
const bo_u28 = (match, outcome) => 'Uchinchi partiya natijasi';
const bo_v28 = (match, outcome) => 'To&apos;rtinchi partiya natijasi';
const bo_w28 = (match, outcome) => 'Beshinchi partiya natijasi';
const bo_x28 = (match, outcome) => 'Oltinchi partiya natijasi';
const bo_y28 = (match, outcome) => 'Yettinchi partiya natijasi';
const bo_z28 = (match, outcome) => 'Sakkizinchi partiya natijasi';
const bo_a29 = (match, outcome) => 'To&apos;qqizinchi partiya natijasi';
const bo_b29 = (match, outcome) => 'O&apos;ninchi partiya natijasi';
const bo_c29 = (match, outcome) => 'O&apos;n birinchi partiya natijasi';
const bo_d29 = (match, outcome) => 'O&apos;n ikkinchi partiya natijasi';
const bo_e29 = (match, outcome) => 'O&apos;n uchinchi partiya natijasi';
const bo_f29 = (match, outcome) => 'O&apos;n to&apos;rtinchi partiya natijasi';
const bo_g29 = (match, outcome) => 'O&apos;n beshinchi partiya natijasi';
const bo_h29 = (match, outcome) => 'O&apos;n oltinchi partiya natijasi';
const bo_i29 = (match, outcome) => 'O&apos;n yettinchi partiya natijasi';
const bo_j29 = (match, outcome) => 'O&apos;n sakkizinchi partiya natijasi';
const bo_k29 = (match, outcome) => 'O&apos;n to&apos;qqizinchi partiya natijasi';
const bo_l29 = (match, outcome) => 'Yigirmanchi partiya natijasi';
const bo_m29 = (match, outcome) => 'Yigirma birinchi partiya natijasi';
const bo_n29 = (match, outcome) => 'Yigirma ikkinchi partiya natijasi';
const bo_o29 = (match, outcome) => 'Yigirma uchinchi partiya natijasi';
const bo_p29 = (match, outcome) => 'Yigirma to&apos;rtinchi partiya natijasi';
const bo_q29 = (match, outcome) => 'Yigirma beshinchi partiya natijasi';
const bo_r29 = (match, outcome) => 'Yigirma oltinchi partiya natijasi';
const bo_s29 = (match, outcome) => 'Yigirma yettinchi partiya natijasi';
const bo_t29 = (match, outcome) => 'Yigirma sakkizinchi partiya natijasi';
const bo_u29 = (match, outcome) => 'Kim yettinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_v29 = (match, outcome) => 'Kim sakkizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_w29 = (match, outcome) => 'Kim to&apos;qqizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_x29 = (match, outcome) => 'Kim o&apos;ninchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_y29 = (match, outcome) => 'Kim o&apos;n birinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_z29 = (match, outcome) => 'Kim o&apos;n ikkinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_a30 = (match, outcome) => 'Kim o&apos;n uchinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_b30 = (match, outcome) => 'Kim o&apos;n to&apos;rtinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_c30 = (match, outcome) => 'Kim o&apos;n beshinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_d30 = (match, outcome) => 'Kim o&apos;n oltinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_e30 = (match, outcome) => 'Kim o&apos;n yettinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_f30 = (match, outcome) => 'Kim o&apos;n sakkizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_g30 = (match, outcome) => 'Kim o&apos;n to&apos;qqizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_h30 = (match, outcome) => 'Kim yigirmanchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_i30 = (match, outcome) => 'Kim yigirma birinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_j30 = (match, outcome) => 'Kim yigirma ikkinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_k30 = (match, outcome) => 'Kim yigirma uchinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_l30 = (match, outcome) => 'Kim yigirma to&apos;rtinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_m30 = (match, outcome) => 'Kim yigirma beshinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_n30 = (match, outcome) => 'Kim yigirma oltinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_o30 = (match, outcome) => 'Kim yigirma yettinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_p30 = (match, outcome) => 'Kim yigirma sakkizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_q30 = (match, outcome) => 'Kim yigirma to&apos;qqizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_r30 = (match, outcome) => 'Kim o&apos;ttizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_s30 = (match, outcome) => 'Kim o&apos;ttiz birinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_t30 = (match, outcome) => 'Kim o&apos;ttiz ikkinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_u30 = (match, outcome) => 'Kim o&apos;ttiz uchinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_v30 = (match, outcome) => 'Kim o&apos;ttiz to&apos;rtinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_w30 = (match, outcome) => 'Kim o&apos;ttiz beshinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_x30 = (match, outcome) => 'Kim o&apos;ttiz oltinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_y30 = (match, outcome) => 'Kim o&apos;ttiz yettinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
const bo_z30 = (match, outcome) => `Kim birinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_a31 = (match, outcome) => `Kim ikkinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_b31 = (match, outcome) => `Kim uchinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_c31 = (match, outcome) => `Kim to&apos;rtinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_d31 = (match, outcome) => `Kim beshinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_e31 = (match, outcome) => `Kim oltinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_f31 = (match, outcome) => `Kim yettinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_g31 = (match, outcome) => `Kim sakkizinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_h31 = (match, outcome) => `Kim to&apos;qqizinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_i31 = (match, outcome) => `Kim o&apos;ninchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_j31 = (match, outcome) => `Kim o&apos;n birinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_k31 = (match, outcome) => `Kim o&apos;n ikkinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_l31 = (match, outcome) => `Kim o&apos;n uchinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_m31 = (match, outcome) => `Kim o&apos;n to&apos;rtinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_n31 = (match, outcome) => `Kim o&apos;n beshinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_o31 = (match, outcome) => `Kim o&apos;n oltinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_p31 = (match, outcome) => `Kim o&apos;n yettinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_q31 = (match, outcome) => `Kim o&apos;n sakkizinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_r31 = (match, outcome) => `Kim o&apos;n to&apos;qqizinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_s31 = (match, outcome) => `Kim yigirmanchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_t31 = (match, outcome) => `Kim yigirma birinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_u31 = (match, outcome) => `Kim yigirma ikkinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_v31 = (match, outcome) => `Kim yigirma uchinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_w31 = (match, outcome) => `Kim yigirma to&apos;rtinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_x31 = (match, outcome) => `Kim yigirma beshinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_y31 = (match, outcome) => `Kim yigirma oltinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_z31 = (match, outcome) => `Kim yigirma yettinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_a32 = (match, outcome) => `Kim yigirma sakkizinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_b32 = (match, outcome) => `Kim yigirma to&apos;qqizinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_c32 = (match, outcome) => `Kim o&apos;ttizinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_d32 = (match, outcome) => `Kim o&apos;ttiz birinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_e32 = (match, outcome) => `Kim o&apos;ttiz ikkinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_f32 = (match, outcome) => `Kim o&apos;ttiz uchinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_g32 = (match, outcome) => `Kim o&apos;ttiz to&apos;rtinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_h32 = (match, outcome) => `Kim o&apos;ttiz beshinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_i32 = (match, outcome) => `Kim o&apos;ttiz oltinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_j32 = (match, outcome) => `Kim o&apos;ttiz yettinchi partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_k32 = (match, outcome) => 'Birinchi partiya juft/toq';
const bo_l32 = (match, outcome) => 'Ikkinchi partiya juft/toq';
const bo_m32 = (match, outcome) => 'Uchinchi partiya juft/toq';
const bo_n32 = (match, outcome) => 'To&apos;rtinchi partiya juft/toq';
const bo_o32 = (match, outcome) => 'Beshinchi partiya juft/toq';
const bo_p32 = (match, outcome) => 'Oltinchi partiya juft/toq';
const bo_q32 = (match, outcome) => 'Yettinchi partiya juft/toq';
const bo_r32 = (match, outcome) => 'Sakkizinchi partiya juft/toq';
const bo_s32 = (match, outcome) => 'To&apos;qqizinchi partiya juft/toq';
const bo_t32 = (match, outcome) => 'O&apos;ninchi partiya juft/toq';
const bo_u32 = (match, outcome) => 'O&apos;n birinchi partiya juft/toq';
const bo_v32 = (match, outcome) => 'O&apos;n ikkinchi partiya juft/toq';
const bo_w32 = (match, outcome) => 'O&apos;n uchinchi partiya juft/toq';
const bo_x32 = (match, outcome) => 'O&apos;n to&apos;rtinchi partiya juft/toq';
const bo_y32 = (match, outcome) => 'O&apos;n beshinchi partiya juft/toq';
const bo_z32 = (match, outcome) => 'O&apos;n oltinchi partiya juft/toq';
const bo_a33 = (match, outcome) => 'O&apos;n yettinchi partiya juft/toq';
const bo_b33 = (match, outcome) => 'O&apos;yindagi Asr breyklari jami hisobi';
const bo_c33 = (match, outcome) => 'Birinchi partiyadagi fora';
const bo_d33 = (match, outcome) => 'Ikkinchi partiyadagi fora';
const bo_e33 = (match, outcome) => 'Uchinchi partiyadagi fora';
const bo_f33 = (match, outcome) => 'To&apos;rtinchi partiyadagi fora';
const bo_g33 = (match, outcome) => 'Beshinchi partiyadagi fora';
const bo_h33 = (match, outcome) => 'Oltinchi partiyadagi fora';
const bo_i33 = (match, outcome) => 'Yettinchi partiyadagi fora';
const bo_j33 = (match, outcome) => 'Sakkizinchi partiyadagi fora';
const bo_k33 = (match, outcome) => 'To&apos;qqizinchi partiyadagi fora';
const bo_l33 = (match, outcome) => 'O&apos;ninchi partiyadagi fora';
const bo_m33 = (match, outcome) => 'O&apos;n birinchi partiyadagi fora';
const bo_n33 = (match, outcome) => 'O&apos;n ikkinchi partiyadagi fora';
const bo_o33 = (match, outcome) => 'O&apos;n uchinchi partiyadagi fora';
const bo_p33 = (match, outcome) => 'O&apos;n to&apos;rtinchi partiyadagi fora';
const bo_q33 = (match, outcome) => 'O&apos;n beshinchi partiyadagi fora';
const bo_r33 = (match, outcome) => 'O&apos;n oltinchi partiyadagi fora';
const bo_s33 = (match, outcome) => 'O&apos;n yettinchi partiyadagi fora';
const bo_t33 = (match, outcome) => 'O&apos;n sakkizinchi partiyadagi fora';
const bo_u33 = (match, outcome) => 'O&apos;n to&apos;qqizinchi partiyadagi fora';
const bo_v33 = (match, outcome) => 'Yigirmanchi partiyadagi fora';
const bo_w33 = (match, outcome) => 'Yigirma birinchi partiyadagi fora';
const bo_x33 = (match, outcome) => 'Yigirma ikkinchi partiyadagi fora';
const bo_y33 = (match, outcome) => 'Yigirma uchinchi partiyadagi fora';
const bo_z33 = (match, outcome) => 'Yigirma to&apos;rtinchi partiyadagi fora';
const bo_a34 = (match, outcome) => 'Yigirma beshinchi partiyadagi fora';
const bo_b34 = (match, outcome) => 'Yigirma oltinchi partiyadagi fora';
const bo_c34 = (match, outcome) => 'Yigirma yettinchi partiyadagi fora';
const bo_d34 = (match, outcome) => 'Yigirma sakkizinchi partiyadagi fora';
const bo_e34 = (match, outcome) => 'Yigirma to&apos;qqizinchi partiyadagi fora';
const bo_f34 = (match, outcome) => 'O&apos;ttizinchi partiyadagi fora';
const bo_g34 = (match, outcome) => 'O&apos;ttiz birinchi partiyadagi fora';
const bo_h34 = (match, outcome) => 'O&apos;ttiz ikkinchi partiyadagi fora';
const bo_i34 = (match, outcome) => 'O&apos;ttiz uchinchi partiyadagi fora';
const bo_j34 = (match, outcome) => 'O&apos;ttiz to&apos;rtinchi partiyadagi fora';
const bo_k34 = (match, outcome) => 'O&apos;ttiz beshinchi partiyadagi fora';
const bo_l34 = (match, outcome) => 'O&apos;ttiz oltinchi partiyadagi fora';
const bo_m34 = (match, outcome) => 'O&apos;ttiz yettinchi partiyadagi fora';
const bo_n34 = (match, outcome) => 'Birinchi partiya jami hisobi';
const bo_o34 = (match, outcome) => 'Ikkinchi partiya jami hisobi';
const bo_p34 = (match, outcome) => 'Uchinchi partiya jami hisobi';
const bo_q34 = (match, outcome) => 'To&apos;rtinchi partiya jami hisobi';
const bo_r34 = (match, outcome) => 'Beshinchi partiya jami hisobi';
const bo_s34 = (match, outcome) => 'Oltinchi partiya jami hisobi';
const bo_t34 = (match, outcome) => 'Yettinchi partiya jami hisobi';
const bo_u34 = (match, outcome) => 'Sakkizinchi partiya jami hisobi';
const bo_v34 = (match, outcome) => 'To&apos;qqizinchi partiya jami hisobi';
const bo_w34 = (match, outcome) => 'O&apos;ninchi partiya jami hisobi';
const bo_x34 = (match, outcome) => 'O&apos;n birinchi partiya jami hisobi';
const bo_y34 = (match, outcome) => 'O&apos;n ikkinchi partiya jami hisobi';
const bo_z34 = (match, outcome) => 'O&apos;n uchinchi partiya jami hisobi';
const bo_a35 = (match, outcome) => 'O&apos;n to&apos;rtinchi partiya jami hisobi';
const bo_b35 = (match, outcome) => 'O&apos;n beshinchi partiya jami hisobi';
const bo_c35 = (match, outcome) => 'O&apos;n oltinchi partiya jami hisobi';
const bo_d35 = (match, outcome) => 'O&apos;n yettinchi partiya jami hisobi';
const bo_e35 = (match, outcome) => 'O&apos;n sakkizinchi partiya jami hisobi';
const bo_f35 = (match, outcome) => 'O&apos;n to&apos;qqizinchi partiya jami hisobi';
const bo_g35 = (match, outcome) => 'Yigirmanchi partiya jami hisobi';
const bo_h35 = (match, outcome) => 'Yigirma birinchi partiya jami hisobi';
const bo_i35 = (match, outcome) => 'Yigirma ikkinchi partiya jami hisobi';
const bo_j35 = (match, outcome) => 'Yigirma uchinchi partiya jami hisobi';
const bo_k35 = (match, outcome) => 'Yigirma to&apos;rtinchi partiya jami hisobi';
const bo_l35 = (match, outcome) => 'Yigirma beshinchi partiya jami hisobi';
const bo_m35 = (match, outcome) => 'Yigirma oltinchi partiya jami hisobi';
const bo_n35 = (match, outcome) => 'Yigirma yettinchi partiya jami hisobi';
const bo_o35 = (match, outcome) => 'Yigirma sakkizinchi partiya jami hisobi';
const bo_p35 = (match, outcome) => 'Yigirma to&apos;qqizinchi partiya jami hisobi';
const bo_q35 = (match, outcome) => 'O&apos;ttizinchi partiya jami hisobi';
const bo_r35 = (match, outcome) => 'O&apos;ttiz birinchi partiya jami hisobi';
const bo_s35 = (match, outcome) => 'O&apos;ttiz ikkinchi partiya jami hisobi';
const bo_t35 = (match, outcome) => 'O&apos;ttiz uchinchi partiya jami hisobi';
const bo_u35 = (match, outcome) => 'O&apos;ttiz to&apos;rtinchi partiya jami hisobi';
const bo_v35 = (match, outcome) => 'O&apos;ttiz beshinchi partiya jami hisobi';
const bo_w35 = (match, outcome) => 'O&apos;ttiz oltinchi partiya jami hisobi';
const bo_x35 = (match, outcome) => 'O&apos;ttiz yettinchi partiya jami hisobi';
const bo_y35 = (match, outcome) => 'Kim birinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
const bo_z35 = (match, outcome) => 'Kim ikkinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
const bo_a36 = (match, outcome) => 'Kim uchinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
const bo_b36 = (match, outcome) => 'Kim to&apos;rtinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
const bo_c36 = (match, outcome) => 'Kim beshinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
const bo_d36 = (match, outcome) => 'Kim oltinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
const bo_e36 = (match, outcome) => 'Birinchi partiyadagi Fora';
const bo_f36 = (match, outcome) => 'Ikkinchi partiyadagi Fora';
const bo_g36 = (match, outcome) => 'Uchinchi partiyadagi Fora';
const bo_h36 = (match, outcome) => 'To&apos;rtinchi partiyadagi Fora';
const bo_i36 = (match, outcome) => 'Beshinchi partiyadagi Fora';
const bo_j36 = (match, outcome) => 'Oltinchi partiyadagi Fora';
const bo_k36 = (match, outcome) => 'Yettinchi partiyadagi Fora';
const bo_l36 = (match, outcome) => 'O&apos;yindagi jami partiyalar soni';
const bo_m36 = (match, outcome) => `${match.homeTeam} ning birinchi partiyadagi jami hisobi`;
const bo_n36 = (match, outcome) => `${match.homeTeam} ning ikkinchi partiyadagi jami hisobi`;
const bo_o36 = (match, outcome) => `${match.homeTeam} ning uchinchi partiyadagi jami hisobi`;
const bo_p36 = (match, outcome) => `${match.homeTeam} ning to&apos;rtinchi partiyadagi jami hisobi`;
const bo_q36 = (match, outcome) => `${match.homeTeam} ning beshinchi partiyadagi jami hisobi`;
const bo_r36 = (match, outcome) => `${match.homeTeam} ning oltinchi partiyadagi jami hisobi`;
const bo_s36 = (match, outcome) => `${match.homeTeam} ning yettinchi partiyadagi jami hisobi`;
const bo_t36 = (match, outcome) => `${match.awayTeam} ning birinchi partiyadagi jami hisobi`;
const bo_u36 = (match, outcome) => `${match.awayTeam} ning ikkinchi partiyadagi jami hisobi`;
const bo_v36 = (match, outcome) => `${match.awayTeam} ning uchinchi partiyadagi jami hisobi`;
const bo_w36 = (match, outcome) => `${match.awayTeam} ning to&apos;rtinchi partiyadagi jami hisobi`;
const bo_x36 = (match, outcome) => `${match.awayTeam} ning beshinchi partiyadagi jami hisobi`;
const bo_y36 = (match, outcome) => `${match.awayTeam} ning oltinchi partiyadagi jami hisobi`;
const bo_z36 = (match, outcome) => `${match.awayTeam} ning yettinchi partiyadagi jami hisobi`;
const bo_a37 = (match, outcome) => `Kim 1-partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_b37 = (match, outcome) => `Kim 2-partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_c37 = (match, outcome) => `Kim 3-partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_d37 = (match, outcome) => `Kim 4-partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_e37 = (match, outcome) => `Kim 5-partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_f37 = (match, outcome) => `Kim 6-partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_g37 = (match, outcome) => `Kim 7-partiyada birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_h37 = (match, outcome) => `Birinchi partiyada ${match.homeTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_i37 = (match, outcome) => `Ikkinchi partiyada ${match.homeTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_j37 = (match, outcome) => `Uchinchi partiyada ${match.homeTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_k37 = (match, outcome) => `To&apos;rtinchi partiyada ${match.homeTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_l37 = (match, outcome) => `Beshinchi partiyada ${match.homeTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_m37 = (match, outcome) => `Oltinchi partiyada ${match.homeTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_n37 = (match, outcome) => `Yettinchi partiyada ${match.homeTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_o37 = (match, outcome) => `Birinchi partiyada ${match.awayTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_p37 = (match, outcome) => `Ikkinchi partiyada ${match.awayTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_q37 = (match, outcome) => `Uchinchi partiyada ${match.awayTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_r37 = (match, outcome) => `To&apos;rtinchi partiyada ${match.awayTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_s37 = (match, outcome) => `Beshinchi partiyada ${match.awayTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_t37 = (match, outcome) => `Oltinchi partiyada ${match.awayTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_u37 = (match, outcome) => `Yettinchi partiyada ${match.awayTeam} aniq ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} bilan g&apos;alaba qozonadi`;
const bo_v37 = (match, outcome) => 'Birinchi partiya aniq jami hisobi';
const bo_w37 = (match, outcome) => 'Ikkinchi partiya aniq jami hisobi';
const bo_x37 = (match, outcome) => 'Uchinchi partiya aniq jami hisobi';
const bo_y37 = (match, outcome) => 'To&apos;rtinchi partiya aniq jami hisobi';
const bo_z37 = (match, outcome) => 'Beshinchi partiya aniq jami hisobi';
const bo_a38 = (match, outcome) => 'Oltinchi partiya aniq jami hisobi';
const bo_b38 = (match, outcome) => 'Yettinchi partiya aniq jami hisobi';
const bo_c38 = (match, outcome) => `Kim birinchi partiyada ${numeralNeuterEnding(outcome.condition)} ochkoni yutadi`;
const bo_d38 = (match, outcome) => `Kim ikkinchi partiyada ${numeralNeuterEnding(outcome.condition)} ochkoni yutadi`;
const bo_e38 = (match, outcome) => `Kim uchinchi partiyada ${numeralNeuterEnding(outcome.condition)} ochkoni yutadi`;
const bo_f38 = (match, outcome) => `Kim to&apos;rtinchi partiyada ${numeralNeuterEnding(outcome.condition)} ochkoni yutadi`;
const bo_g38 = (match, outcome) => `Kim beshinchi partiyada ${numeralNeuterEnding(outcome.condition)} ochkoni yutadi`;
const bo_h38 = (match, outcome) => `Kim oltinchi partiyada ${numeralNeuterEnding(outcome.condition)} ochkoni yutadi`;
const bo_i38 = (match, outcome) => `Kim yettinchi partiyada ${numeralNeuterEnding(outcome.condition)} ochkoni yutadi`;
const bo_j38 = (match, outcome) => 'Birinchi partiyada aniq jami hisob';
const bo_k38 = (match, outcome) => 'Ikkinchi partiyada aniq jami hisob';
const bo_l38 = (match, outcome) => 'Uchinchi partiyada aniq jami hisob';
const bo_m38 = (match, outcome) => 'To&apos;rtinchi partiyada aniq jami hisob';
const bo_n38 = (match, outcome) => 'Beshinchi partiyada aniq jami hisob';
const bo_o38 = (match, outcome) => 'Oltinchi partiyada aniq jami hisob';
const bo_p38 = (match, outcome) => 'Yettinchi partiyada aniq jami hisob';
const bo_q38 = (match, outcome) => 'Birinchi davr aniq jami hisobi juft/toq';
const bo_r38 = (match, outcome) => 'Ikkinchi davr aniq jami hisobi juft/toq';
const bo_s38 = (match, outcome) => 'Uchinchi davr aniq jami hisobi juft/toq';
const bo_t38 = (match, outcome) => 'To&apos;rtinchi davr aniq jami hisobi juft/toq';
const bo_u38 = (match, outcome) => 'Beshinchi davr aniq jami hisobi juft/toq';
const bo_v38 = (match, outcome) => 'Oltinchi davr aniq jami hisobi juft/toq';
const bo_w38 = (match, outcome) => 'Yettinchi davr aniq jami hisobi juft/toq';
const bo_x38 = (match, outcome) => 'O&apos;yinning aniq hisobi';
const bo_y38 = (match, outcome) => `${match.awayTeam} 1 chi yoki 2 chi geymda breykni amalga oshiradi`;
const bo_z38 = (match, outcome) => 'Tennischi tomonidan ketma-ket yutilgan geymlarning maksimal soni';
const bo_a39 = (match, outcome) => 'Breyklar bilan almashinadimi (ketma-ket ikki marta)?';
const bo_b39 = (match, outcome) => `${match.homeTeam} ning to&apos;rtinchi setdagi jami hisobi`;
const bo_c39 = (match, outcome) => `${match.homeTeam} ning beshinchi setdagi jami hisobi`;
const bo_d39 = (match, outcome) => `${match.awayTeam} ning to&apos;rtinchi setdagi jami hisobi`;
const bo_e39 = (match, outcome) => `${match.awayTeam} ning beshinchi setdagi jami hisobi`;
const bo_f39 = (match, outcome) => 'To&apos;rtinchi set juft/toq';
const bo_g39 = (match, outcome) => 'Beshinchi set juft/toq';
const bo_h39 = (match, outcome) => 'Birinchi set/o&apos;yin';
const bo_i39 = (match, outcome) => `${outcome.condition}-geymda breyk point amalga oshadi`;
const bo_j39 = (match, outcome) => 'Ikkinchi setdagi jami breyklar soni';
const bo_k39 = (match, outcome) => 'Uchinchi setdagi jami breyklar soni';
const bo_l39 = (match, outcome) => 'To&apos;rtinchi setdagi jami breyklar soni';
const bo_m39 = (match, outcome) => 'Beshinchi setdagi jami breyklar soni';
const bo_n39 = (match, outcome) => `G&apos;alaba va ikkinchi set jami hisobi ${outcome.condition}`;
const bo_o39 = (match, outcome) => `G&apos;alaba va uchinchi set jami hisobi ${outcome.condition}`;
const bo_p39 = (match, outcome) => `G&apos;alaba va to&apos;rtinchi set jami hisobi ${outcome.condition}`;
const bo_q39 = (match, outcome) => `G&apos;alaba va beshinchi set jami hisobi ${outcome.condition}`;
const bo_r39 = (match, outcome) => `${match.homeTeam} birinchi setdagi jami breyklar soni`;
const bo_s39 = (match, outcome) => `${match.homeTeam} ikkinchi setdagi jami breyklar soni`;
const bo_t39 = (match, outcome) => `${match.homeTeam} uchinchi setdagi jami breyklar soni`;
const bo_u39 = (match, outcome) => `${match.homeTeam} to&apos;rtinchi setdagi jami breyklar soni`;
const bo_v39 = (match, outcome) => `${match.homeTeam} beshinchi setdagi jami breyklar soni`;
const bo_w39 = (match, outcome) => `${match.awayTeam} birinchi setdagi jami breyklar soni`;
const bo_x39 = (match, outcome) => `${match.awayTeam} ikkinchi setdagi jami breyklar soni`;
const bo_y39 = (match, outcome) => `${match.awayTeam} uchinchi setdagi jami breyklar soni`;
const bo_z39 = (match, outcome) => `${match.awayTeam} to&apos;rtinchi setdagi jami breyklar soni`;
const bo_a40 = (match, outcome) => `${match.awayTeam} beshinchi setdagi jami breyklar soni`;
const bo_b40 = (match, outcome) => `Kimdir birinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_c40 = (match, outcome) => `Kimdir ikkinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_d40 = (match, outcome) => `Kimdir uchinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_e40 = (match, outcome) => `Kimdir to&apos;rtinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_f40 = (match, outcome) => `Kimdir beshinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_g40 = (match, outcome) => `${match.homeTeam} birinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_h40 = (match, outcome) => `${match.homeTeam} ikkinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_i40 = (match, outcome) => `${match.homeTeam} uchinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_j40 = (match, outcome) => `${match.homeTeam} to&apos;rtinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_k40 = (match, outcome) => `${match.homeTeam} beshinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_l40 = (match, outcome) => `${match.awayTeam} birinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_m40 = (match, outcome) => `${match.awayTeam} ikkinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_n40 = (match, outcome) => `${match.awayTeam} uchinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_o40 = (match, outcome) => `${match.awayTeam} to&apos;rtinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_p40 = (match, outcome) => `${match.awayTeam} beshinchi setda ketma-ket ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadimi?`;
const bo_q40 = (match, outcome) => 'To&apos;rtinchi setdagi Fora';
const bo_r40 = (match, outcome) => 'Beshinchi setdagi Fora';
const bo_s40 = (match, outcome) => 'To&apos;rtinchi set jami hisobi';
const bo_t40 = (match, outcome) => 'Beshinchi set jami hisobi';
const bo_u40 = (match, outcome) => `${outcome.condition}-geymning aniq hisobi`;
const bo_v40 = (match, outcome) => `Kim ${outcome.condition}-geymni yutadi?`;
const bo_w40 = (match, outcome) => 'Birinchi set aniq natijasi';
const bo_x40 = (match, outcome) => 'Ikkinchi set aniq natijasi';
const bo_y40 = (match, outcome) => 'Uchinchi set aniq natijasi';
const bo_z40 = (match, outcome) => 'To&apos;rtinchi set aniq natijasi';
const bo_a41 = (match, outcome) => 'Beshinchi set aniq natijasi';
const bo_b41 = (match, outcome) => `${outcome.condition}-geymda 15x15 bo&apos;ladimi?`;
const bo_c41 = (match, outcome) => `${outcome.condition}-geymda 30x30 bo&apos;ladimi?`;
const bo_d41 = (match, outcome) => `${outcome.condition}-geymda 40x40 bo&apos;ladimi?`;
const bo_e41 = (match, outcome) => `Kim 1-setda birinchi bo&apos;lib ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadi`;
const bo_f41 = (match, outcome) => `Kim 2-setda birinchi bo&apos;lib ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadi`;
const bo_g41 = (match, outcome) => `Kim 3-setda birinchi bo&apos;lib ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadi`;
const bo_h41 = (match, outcome) => `Kim 4-setda birinchi bo&apos;lib ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadi`;
const bo_i41 = (match, outcome) => `Kim 5-setda birinchi bo&apos;lib ${outcome.condition} ta ${plural(outcome.condition, ['geym', 'geym', 'geym'])} yutadi`;
const bo_j41 = (match, outcome) => 'To&apos;rtinchi set natijasi';
const bo_k41 = (match, outcome) => 'Beshinchi set natijasi';
const bo_l41 = (match, outcome) => `${outcome.condition}-geymdagi birinchi ochko`;
const bo_m41 = (match, outcome) => 'Birinchi setda tie-breyk bo&apos;ladimi?';
const bo_n41 = (match, outcome) => 'Ikkinchi setda tie-breyk bo&apos;ladimi?';
const bo_o41 = (match, outcome) => 'Uchinchi setda tie-breyk bo&apos;ladimi?';
const bo_p41 = (match, outcome) => 'To&apos;rtinchi setda tie-breyk bo&apos;ladimi?';
const bo_q41 = (match, outcome) => 'Beshinchi setda tie-breyk bo&apos;ladimi?';
const bo_r41 = (match, outcome) => 'O&apos;yinda tie-break bo&apos;ladimi?';
const bo_s41 = (match, outcome) => 'Birinchi setdagi jami tie-braeklar soni';
const bo_t41 = (match, outcome) => 'Ikkinchi setdagi jami tie-braeklar soni';
const bo_u41 = (match, outcome) => 'Uchinchi setdagi jami tie-braeklar soni';
const bo_v41 = (match, outcome) => 'To&apos;rtinchi setdagi jami tie-braeklar soni';
const bo_w41 = (match, outcome) => 'Beshinchi setdagi jami tie-braeklar soni';
const bo_x41 = (match, outcome) => 'Birinchi setdagi tie-breakning aniq hisobi';
const bo_y41 = (match, outcome) => 'Ikkinchi setdagi tie-breakning aniq hisobi';
const bo_z41 = (match, outcome) => 'Uchinchi setdagi tie-breakning aniq hisobi';
const bo_a42 = (match, outcome) => 'To&apos;rtinchi setdagi tie-breakning aniq hisobi';
const bo_b42 = (match, outcome) => 'Beshinchi setdagi tie-breakning aniq hisobi';
const bo_c42 = (match, outcome) => 'Birinchi setdagi tie-breaklarning aniq jami hisobi';
const bo_d42 = (match, outcome) => 'Ikkinchi setdagi tie-breaklarning aniq jami hisobi';
const bo_e42 = (match, outcome) => 'Uchinchi setdagi tie-breaklarning aniq jami hisobi';
const bo_f42 = (match, outcome) => 'To&apos;rtinchi setdagi tie-breaklarning aniq jami hisobi';
const bo_g42 = (match, outcome) => 'Beshinchi setdagi tie-breaklarning aniq jami hisobi';
const bo_h42 = (match, outcome) => 'Birinchi setdagi tie-breakda kim g&apos;alaba qozonadi?';
const bo_i42 = (match, outcome) => 'Ikkinchi setdagi tie-breakda kim g&apos;alaba qozonadi?';
const bo_j42 = (match, outcome) => 'Uchinchi setdagi tie-breakda kim g&apos;alaba qozonadi?';
const bo_k42 = (match, outcome) => 'To&apos;rtinchi setdagi tie-breakda kim g&apos;alaba qozonadi?';
const bo_l42 = (match, outcome) => 'Beshinchi setdagi tie-breakda kim g&apos;alaba qozonadi?';
const bo_m42 = (match, outcome) => 'Birinchi setdagi jami breyklar soni';
const bo_n42 = (match, outcome) => 'O&apos;yindagi jami breyklar soni';
const bo_o42 = (match, outcome) => `${match.homeTeam} o&apos;yinda biror setda g&apos;alaba qozonadi`;
const bo_p42 = (match, outcome) => `${match.awayTeam} o&apos;yinda biror setda g&apos;alaba qozonadi`;
const bo_q42 = (match, outcome) => `G&apos;alaba va birinchi set jami hisobi ${outcome.condition}`;
const bo_r42 = (match, outcome) => 'Eng sermahsul bo&apos;lmagan setning jami hisobi';
const bo_s42 = (match, outcome) => 'O&apos;yinda kim birinchi bo&apos;lib eysni amalga oshiradi';
const bo_t42 = (match, outcome) => 'O&apos;yinda kim birinchi bo&apos;lib qo&apos;shxatoni amalga oshiradi?';
const bo_u42 = (match, outcome) => `${match.homeTeam}: to&apos;p oshirilishing eng maksimal tezligi (km/s)`;
const bo_v42 = (match, outcome) => `${match.awayTeam}: to&apos;p oshirilishing eng maksimal tezligi (km/s)`;
const bo_w42 = (match, outcome) => 'Birinchi setni yutqazib o&apos;yinda g&apos;alaba qozonish';
const bo_x42 = (match, outcome) => `${match.homeTeam}: birinchi to&apos;p oshirish %`;
const bo_y42 = (match, outcome) => `${match.awayTeam}: birinchi to&apos;p oshirish %`;
const bo_z42 = (match, outcome) => 'O&apos;yindagi breyklar bo&apos;yicha natija';
const bo_a43 = (match, outcome) => `Jami brayklar soni: ${match.homeTeam}`;
const bo_b43 = (match, outcome) => `Jami brayklar soni: ${match.awayTeam}`;
const bo_c43 = (match, outcome) => 'O&apos;yinda kim birinchi breyk qiladi';
const bo_d43 = (match, outcome) => `${match.homeTeam} 1- yoki 2-setlarda breyk qiladi`;
const bo_e43 = (match, outcome) => 'O&apos;yinda 6:0 yoki 0:6 hisobli set bo&apos;ladimi?';
const bo_f43 = (match, outcome) => `${outcome.condition}-geym aniq hisobi`;
const bo_g43 = (match, outcome) => 'O&apos;yindagi eyslarning jami hisobi';
const bo_h43 = (match, outcome) => `O&apos;yindagi eyslarning jami hisobi: ${match.homeTeam}`;
const bo_i43 = (match, outcome) => `O&apos;yindagi eyslarning jami hisobi: ${match.awayTeam}`;
const bo_j43 = (match, outcome) => 'O&apos;yindagi qo&apos;shxatolarning jami hisobi';
const bo_k43 = (match, outcome) => `O&apos;yindagi qo&apos;shxatolarning jami hisobi: ${match.homeTeam}`;
const bo_l43 = (match, outcome) => `O&apos;yindagi qo&apos;shxatolarning jami hisobi: ${match.awayTeam}`;
const bo_m43 = (match, outcome) => 'Setlar sermahsulligi (Jami hisob)';
const bo_n43 = (match, outcome) => 'O&apos;yin to&apos;pni maydondan to&apos;g&apos;ridan-to&apos;g&apos;ri chiqarib yuborish orqali g&apos;alaba qozoniladi';
const bo_o43 = (match, outcome) => `1- yoki 2- geymda eys: ${match.homeTeam}`;
const bo_p43 = (match, outcome) => `1- yoki 2- geymda eys: ${match.awayTeam}`;
const bo_q43 = (match, outcome) => `1- yoki 2- geymda qo&apos;shxato: ${match.homeTeam}`;
const bo_r43 = (match, outcome) => `1- yoki 2- geymda qo&apos;shxato: ${match.awayTeam}`;
const bo_s43 = (match, outcome) => 'Birinchi setdagi jami eyslar soni';
const bo_t43 = (match, outcome) => 'O&apos;yinchi o&apos;yin davomida o&apos;yindan bosh tortadi (diskvalifikatsiya)';
const bo_u43 = (match, outcome) => `${match.homeTeam} ning birinchi to&apos;p oshirilishi tushishi %`;
const bo_v43 = (match, outcome) => `${match.awayTeam} ning birinchi to&apos;p oshirilishi tushishi %`;
const bo_w43 = (match, outcome) => 'Breyklar bo&apos;yicha birinchi set natijasi';
const bo_x43 = (match, outcome) => 'Breyklar bo&apos;yicha ikkinchi set natijasi';
const bo_y43 = (match, outcome) => 'Breyklar bo&apos;yicha uchinchi set natijasi';
const bo_z43 = (match, outcome) => 'Breyklar bo&apos;yicha to&apos;rtinchi set natijasi';
const bo_a44 = (match, outcome) => 'Breyklar bo&apos;yicha beshinchi set natijasi';
const bo_b44 = (match, outcome) => 'O&apos;yindagi breyklar bo&apos;yicha fora';
const bo_c44 = (match, outcome) => 'Birinchi setdagi breyklar bo&apos;yicha fora';
const bo_d44 = (match, outcome) => 'Ikkinchi setdagi breyklar bo&apos;yicha fora';
const bo_e44 = (match, outcome) => 'Uchinchi setdagi breyklar bo&apos;yicha fora';
const bo_f44 = (match, outcome) => 'To&apos;rtinchi setdagi breyklar bo&apos;yicha fora';
const bo_g44 = (match, outcome) => 'Beshinchi setdagi breyklar bo&apos;yicha fora';
const bo_h44 = (match, outcome) => `${outcome.condition}-geymda ${outcome.conditionTwo} ochkoni kim yutadi`;
const bo_i44 = (match, outcome) => `${outcome.conditionTwo}- va ${outcome.condition}-geym natijasi`;
const bo_j44 = (match, outcome) => `${outcome.conditionTwo}-geymda fora`;
const bo_k44 = (match, outcome) => `${outcome.conditionTwo}-geymda jami hisob`;
const bo_l44 = (match, outcome) => `Kim 1-setda birinchi bo&apos;lib  ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_m44 = (match, outcome) => `Kim 2-setda birinchi bo&apos;lib  ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_n44 = (match, outcome) => `Kim 3-setda birinchi bo&apos;lib  ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_o44 = (match, outcome) => `Kim 4-setda birinchi bo&apos;lib  ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_p44 = (match, outcome) => `Kim 5-setda birinchi bo&apos;lib  ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_q44 = (match, outcome) => 'O&apos;yindagi partiyalar bo&apos;yicha fora';
const bo_r44 = (match, outcome) => 'Birinchi set aniq jami hisobi';
const bo_s44 = (match, outcome) => 'Ikkinchi set aniq jami hisobi';
const bo_t44 = (match, outcome) => 'Uchinchi set aniq jami hisobi';
const bo_u44 = (match, outcome) => 'To&apos;rtinchi set aniq jami hisobi';
const bo_v44 = (match, outcome) => 'Beshinchi set aniq jami hisobi';
const bo_w44 = (match, outcome) => 'To&apos;rtinchi setning aniq jami hisobi';
const bo_x44 = (match, outcome) => 'Beshinchi setning aniq jami hisobi';
const bo_y44 = (match, outcome) => `${match.homeTeam} to&apos;rtinchi setda farq bilan g&apos;alaba qozonadi`;
const bo_z44 = (match, outcome) => `${match.homeTeam} beshinchi setda farq bilan g&apos;alaba qozonadi`;
const bo_a45 = (match, outcome) => `${match.awayTeam} to&apos;rtinchi setda farq bilan g&apos;alaba qozonadi`;
const bo_b45 = (match, outcome) => `${match.awayTeam} beshinchi setda farq bilan g&apos;alaba qozonadi`;
const bo_c45 = (match, outcome) => 'Eng sermahsul set jami hisobi';
const bo_d45 = (match, outcome) => 'Eng sermahsul bo&apos;lmagan set jami hisobi';
const bo_e45 = (match, outcome) => 'To&apos;rtinchi setda farq bilan g&apos;alaba';
const bo_f45 = (match, outcome) => 'Beshinchi setda farq bilan g&apos;alaba';
const bo_g45 = (match, outcome) => 'Uchinchi setning 10 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
const bo_h45 = (match, outcome) => 'To&apos;rtinchi setning 10 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
const bo_i45 = (match, outcome) => 'Uchinchi setning 10 ochkogacha bo&apos;lgan kichik setida fora';
const bo_j45 = (match, outcome) => 'To&apos;rtinchi setning 10 ochkogacha bo&apos;lgan kichik setida fora';
const bo_k45 = (match, outcome) => 'Uchinchi setning 10 ochkogacha bo&apos;lgan kichik setida jami hisob';
const bo_l45 = (match, outcome) => 'To&apos;rtinchi setning 10 ochkogacha bo&apos;lgan kichik setida jami hisob';
const bo_m45 = (match, outcome) => 'Uchinchi setning 15 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
const bo_n45 = (match, outcome) => 'To&apos;rtinchi setning 15 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
const bo_o45 = (match, outcome) => 'Uchinchi setning 15 ochkogacha bo&apos;lgan kichik setida fora';
const bo_p45 = (match, outcome) => 'To&apos;rtinchi setning 15 ochkogacha bo&apos;lgan kichik setida fora';
const bo_q45 = (match, outcome) => 'Uchinchi setning 15 ochkogacha bo&apos;lgan kichik setida jami hisob';
const bo_r45 = (match, outcome) => 'To&apos;rtinchi setning 15 ochkogacha bo&apos;lgan kichik setida jami hisob';
const bo_s45 = (match, outcome) => `Kim to&apos;rtinchi setda ${numeralNeuterEnding(outcome.condition)} ochko yutadi`;
const bo_t45 = (match, outcome) => `Kim beshinchi setda ${numeralNeuterEnding(outcome.condition)} ochko yutadi`;
const bo_u45 = (match, outcome) => 'Oltin setda fora';
const bo_v45 = (match, outcome) => 'Oltin set jami hisobi';
const bo_w45 = (match, outcome) => `${match.homeTeam} oltin set jami hisobi`;
const bo_x45 = (match, outcome) => `${match.awayTeam} oltin set jami hisobi`;
const bo_y45 = (match, outcome) => 'Oltin set natijasi';
const bo_z45 = (match, outcome) => `Oltin setda kim birinchi bo&apos;lib ${outcome.condition} ${plural(outcome.condition, ['ochko', 'ochko', 'ochko'])} to&apos;playdi`;
const bo_a46 = (match, outcome) => 'Oltin set juft/toq';
const bo_b46 = (match, outcome) => `Oltin set jami hisobi ${outcome.condition} va g&apos;alaba`;
const bo_c46 = (match, outcome) => 'Oltin setda farq bilan g&apos;alaba';
const bo_d46 = (match, outcome) => 'Nechta setda mini tie-braek bo&apos;ladi?';
const bo_e46 = (match, outcome) => 'Birinchi chorak jami hisobi';
const bo_f46 = (match, outcome) => 'Ikkinchi chorak jami hisobi';
const bo_g46 = (match, outcome) => 'Uchinchi chorak jami hisobi';
const bo_h46 = (match, outcome) => 'To&apos;rtinchi chorak jami hisobi';
const bo_i46 = (match, outcome) => `${outcome.condition}-raundda kim g&apos;alaba qozonadi?`;
const bo_j46 = (match, outcome) => '13-sektor tushadimi?';
const bo_k46 = (match, outcome) => `${outcome.condition}-raundda 13-sektor tushadimi?`;

const fa_b1 = (match, outcome) => `F1(${signed(outcome.condition)})`;
const fa_c1 = (match, outcome) => `F2(${signed(-outcome.condition)})`;
const fa_d1 = (match, outcome) => `${outcome.condition} dan kam`;
const fa_e1 = (match, outcome) => `${outcome.condition} dan ko&apos;p`;
const fa_f1 = (match, outcome) => 'Juft';
const fa_g1 = (match, outcome) => 'Toq';
const fa_h1 = (match, outcome) => 'G&apos;1';
const fa_i1 = (match, outcome) => 'G&apos;2';
const fa_j1 = (match, outcome) => '1-si yuqoriroq';
const fa_k1 = (match, outcome) => '2-si yuqoriroq';
const fa_l1 = (match, outcome) => 'Ha';
const fa_m1 = (match, outcome) => 'Yo&apos;q';
const fa_n1 = (match, outcome) => '0-2';
const fa_o1 = (match, outcome) => '0-3';
const fa_p1 = (match, outcome) => '1-2';
const fa_q1 = (match, outcome) => '1-3';
const fa_r1 = (match, outcome) => '2-0';
const fa_s1 = (match, outcome) => '2-1';
const fa_t1 = (match, outcome) => '2-3';
const fa_u1 = (match, outcome) => '3-0';
const fa_v1 = (match, outcome) => '3-1';
const fa_w1 = (match, outcome) => '3-2';
const fa_x1 = (match, outcome) => `${match.homeTeam}`;
const fa_y1 = (match, outcome) => `${match.awayTeam}`;
const fa_z1 = (match, outcome) => 'Х';
const fa_a2 = (match, outcome) => 'Hechkim';
const fa_b2 = (match, outcome) => '1X';
const fa_c2 = (match, outcome) => '12';
const fa_d2 = (match, outcome) => '2X';
const fa_e2 = (match, outcome) => `G&apos;1Jkam ${outcome.condition}`;
const fa_f2 = (match, outcome) => `G&apos;1Jko&apos;p ${outcome.condition}`;
const fa_g2 = (match, outcome) => `G&apos;2Jkam ${outcome.condition}`;
const fa_h2 = (match, outcome) => `G&apos;2Jko&apos;p ${outcome.condition}`;
const fa_i2 = (match, outcome) => `ХJkam ${outcome.condition}`;
const fa_j2 = (match, outcome) => `ХJko&apos;p ${outcome.condition}`;
const fa_k2 = (match, outcome) => '0';
const fa_l2 = (match, outcome) => '1';
const fa_m2 = (match, outcome) => '2';
const fa_n2 = (match, outcome) => '3';
const fa_o2 = (match, outcome) => '4';
const fa_p2 = (match, outcome) => '≥ 5';
const fa_q2 = (match, outcome) => 'Ikkala jamoa ham to&apos;p kiritadi';
const fa_r2 = (match, outcome) => 'Bitta jamoa to&apos;p kiritadi';
const fa_s2 = (match, outcome) => 'Ikkala jamoa to&apos;p kirita olmaydi';
const fa_t2 = (match, outcome) => '0-0';
const fa_u2 = (match, outcome) => '0-1';
const fa_v2 = (match, outcome) => '0-4';
const fa_w2 = (match, outcome) => '0-5';
const fa_x2 = (match, outcome) => '1-0';
const fa_y2 = (match, outcome) => '1-1';
const fa_z2 = (match, outcome) => '1-4';
const fa_a3 = (match, outcome) => '1-5';
const fa_b3 = (match, outcome) => '2-2';
const fa_c3 = (match, outcome) => '2-4';
const fa_d3 = (match, outcome) => '2-5';
const fa_e3 = (match, outcome) => '2-6';
const fa_f3 = (match, outcome) => '3-3';
const fa_g3 = (match, outcome) => '3-4';
const fa_h3 = (match, outcome) => '3-5';
const fa_i3 = (match, outcome) => '4-0';
const fa_j3 = (match, outcome) => '4-1';
const fa_k3 = (match, outcome) => '4-2';
const fa_l3 = (match, outcome) => '4-3';
const fa_m3 = (match, outcome) => '4-4';
const fa_n3 = (match, outcome) => '5-0';
const fa_o3 = (match, outcome) => '5-1';
const fa_p3 = (match, outcome) => '5-2';
const fa_q3 = (match, outcome) => '5-3';
const fa_r3 = (match, outcome) => 'Har qanday boshqa';
const fa_s3 = (match, outcome) => `≤ ${outcome.condition}`;
const fa_t3 = (match, outcome) => `${outcome.condition + 1} - ${outcome.condition + 2}`;
const fa_u3 = (match, outcome) => `${outcome.condition + 3} - ${outcome.condition + 4}`;
const fa_v3 = (match, outcome) => `${outcome.condition + 5} - ${outcome.condition + 6}`;
const fa_w3 = (match, outcome) => `${outcome.condition + 7} - ${outcome.condition + 8}`;
const fa_x3 = (match, outcome) => `≥ ${outcome.condition + 9}`;
const fa_y3 = (match, outcome) => '6-9';
const fa_z3 = (match, outcome) => '10-12';
const fa_a4 = (match, outcome) => '13-16';
const fa_b4 = (match, outcome) => '17-20';
const fa_c4 = (match, outcome) => '≥21';
const fa_d4 = (match, outcome) => `O&apos;tish: ${match.homeTeam}`;
const fa_e4 = (match, outcome) => `O&apos;tish: ${match.awayTeam}`;
const fa_f4 = (match, outcome) => '1-yarim';
const fa_g4 = (match, outcome) => '2-yarim';
const fa_h4 = (match, outcome) => '1-chorak';
const fa_i4 = (match, outcome) => '2-chorak';
const fa_j4 = (match, outcome) => '3-chorak';
const fa_k4 = (match, outcome) => '4-chorak';
const fa_l4 = (match, outcome) => 'G&apos;1: 1-2';
const fa_m4 = (match, outcome) => 'G&apos;1: 3-5';
const fa_n4 = (match, outcome) => 'G&apos;1: 6-9';
const fa_o4 = (match, outcome) => 'G&apos;1: 10-12';
const fa_p4 = (match, outcome) => 'G&apos;1: 13-16';
const fa_q4 = (match, outcome) => 'G&apos;1: 17-20';
const fa_r4 = (match, outcome) => 'G&apos;1: ≥21';
const fa_s4 = (match, outcome) => 'G&apos;2: 1-2';
const fa_t4 = (match, outcome) => 'G&apos;2: 3-5';
const fa_u4 = (match, outcome) => 'G&apos;2: 6-9';
const fa_v4 = (match, outcome) => 'G&apos;2: 10-12';
const fa_w4 = (match, outcome) => 'G&apos;2: 13-16';
const fa_x4 = (match, outcome) => 'G&apos;2: 17-20';
const fa_y4 = (match, outcome) => 'G&apos;2: ≥21';
const fa_z4 = (match, outcome) => 'G&apos;1: 3-4';
const fa_a5 = (match, outcome) => 'G&apos;1: 5-7';
const fa_b5 = (match, outcome) => 'G&apos;1: ≥8';
const fa_c5 = (match, outcome) => 'Х2';
const fa_d5 = (match, outcome) => 'G&apos;2: 3-4';
const fa_e5 = (match, outcome) => 'G&apos;2: 5-7';
const fa_f5 = (match, outcome) => 'G&apos;2: ≥8';
const fa_g5 = (match, outcome) => 'Х1';
const fa_h5 = (match, outcome) => 'Jarima';
const fa_i5 = (match, outcome) => '3 ochkolik';
const fa_j5 = (match, outcome) => '2 ochkolik';
const fa_k5 = (match, outcome) => `G&apos;1 ≥ ${outcome.condition}`;
const fa_l5 = (match, outcome) => `Farq ${outcome.condition} dan kam`;
const fa_m5 = (match, outcome) => `G&apos;2 ≥ ${outcome.condition}`;
const fa_n5 = (match, outcome) => `G&apos;1: ${outcome.condition}=21 dan katta`;
const fa_o5 = (match, outcome) => `G&apos;2: ${outcome.condition}=21 dan katta`;
const fa_p5 = (match, outcome) => 'G&apos;1: 8 va undan ko&apos;p';
const fa_q5 = (match, outcome) => 'G&apos;2: 8 va undan ko&apos;p';
const fa_r5 = (match, outcome) => 'Hech qaysi';
const fa_s5 = (match, outcome) => 'G&apos;1: 1';
const fa_t5 = (match, outcome) => 'G&apos;1: 2';
const fa_u5 = (match, outcome) => 'G&apos;1: 3';
const fa_v5 = (match, outcome) => 'G&apos;1: 4';
const fa_w5 = (match, outcome) => 'G&apos;1: ≥ 5';
const fa_x5 = (match, outcome) => 'G&apos;2: 1';
const fa_y5 = (match, outcome) => 'G&apos;2: 2';
const fa_z5 = (match, outcome) => 'G&apos;2: 3';
const fa_a6 = (match, outcome) => 'G&apos;2: 4';
const fa_b6 = (match, outcome) => 'G&apos;2: ≥ 5';
const fa_c6 = (match, outcome) => 'Ikkala';
const fa_d6 = (match, outcome) => 'Bitta';
const fa_e6 = (match, outcome) => 'Birorta ham';
const fa_f6 = (match, outcome) => '0 yoki 1';
const fa_g6 = (match, outcome) => '5';
const fa_h6 = (match, outcome) => '6';
const fa_i6 = (match, outcome) => '7';
const fa_j6 = (match, outcome) => '≥ 8';
const fa_k6 = (match, outcome) => 'G&apos;1G&apos;1';
const fa_l6 = (match, outcome) => 'G&apos;1X';
const fa_m6 = (match, outcome) => 'G&apos;1G&apos;2';
const fa_n6 = (match, outcome) => 'XG&apos;1';
const fa_o6 = (match, outcome) => 'XX';
const fa_p6 = (match, outcome) => 'XG&apos;2';
const fa_q6 = (match, outcome) => 'G&apos;2G&apos;1';
const fa_r6 = (match, outcome) => 'G&apos;2X';
const fa_s6 = (match, outcome) => 'G&apos;2G&apos;2';
const fa_t6 = (match, outcome) => `${outcome.condition + 1}`;
const fa_u6 = (match, outcome) => `${outcome.condition + 2}`;
const fa_v6 = (match, outcome) => `${outcome.condition + 3}`;
const fa_w6 = (match, outcome) => `${outcome.condition + 4}`;
const fa_x6 = (match, outcome) => `${outcome.condition + 5}`;
const fa_y6 = (match, outcome) => `${outcome.condition + 6}`;
const fa_z6 = (match, outcome) => `≥ ${outcome.condition + 7}`;
const fa_a7 = (match, outcome) => `от ${outcome.condition + 1} до ${outcome.condition + 2}`;
const fa_b7 = (match, outcome) => `от ${outcome.condition + 3} до ${outcome.condition + 4}`;
const fa_c7 = (match, outcome) => `от ${outcome.condition + 5} до ${outcome.condition + 6}`;
const fa_d7 = (match, outcome) => '4-6';
const fa_e7 = (match, outcome) => '7 va undan ko&apos;p';
const fa_f7 = (match, outcome) => 'G&apos;1Jkam';
const fa_g7 = (match, outcome) => 'G&apos;1Jko&apos;p';
const fa_h7 = (match, outcome) => 'G&apos;2Jkam';
const fa_i7 = (match, outcome) => 'G&apos;2Jko&apos;p';
const fa_j7 = (match, outcome) => 'G&apos;1: 2-3';
const fa_k7 = (match, outcome) => 'G&apos;1: 4-6';
const fa_l7 = (match, outcome) => 'G&apos;1: ≥7';
const fa_m7 = (match, outcome) => 'G&apos;2: 2-3';
const fa_n7 = (match, outcome) => 'G&apos;2: 4-6';
const fa_o7 = (match, outcome) => 'G&apos;2: ≥7';
const fa_p7 = (match, outcome) => `${outcome.condition}`;
const fa_q7 = (match, outcome) => `≥ ${outcome.condition + 6}`;
const fa_r7 = (match, outcome) => 'G&apos;1: muddatidan avval g&apos;alaba';
const fa_s7 = (match, outcome) => 'G&apos;1: ochkolar bo&apos;yicha g&apos;alaba';
const fa_t7 = (match, outcome) => 'Durrang';
const fa_u7 = (match, outcome) => 'G&apos;2: muddatidan avval g&apos;alaba';
const fa_v7 = (match, outcome) => 'G&apos;2: ochkolar bo&apos;yicha g&apos;alaba';
const fa_w7 = (match, outcome) => 'G&apos;1: 1 raund';
const fa_x7 = (match, outcome) => 'G&apos;1: 2 raund';
const fa_y7 = (match, outcome) => 'G&apos;1: 3 raund';
const fa_z7 = (match, outcome) => 'G&apos;1: 4 raund';
const fa_a8 = (match, outcome) => 'G&apos;1: 5 raund';
const fa_b8 = (match, outcome) => 'G&apos;1: 6 raund';
const fa_c8 = (match, outcome) => 'G&apos;1: 7 raund';
const fa_d8 = (match, outcome) => 'G&apos;1: 8 raund';
const fa_e8 = (match, outcome) => 'G&apos;1: 9 raund';
const fa_f8 = (match, outcome) => 'G&apos;1: 10 raund';
const fa_g8 = (match, outcome) => 'G&apos;1: 11 raund';
const fa_h8 = (match, outcome) => 'G&apos;1: 12 raund';
const fa_i8 = (match, outcome) => 'G&apos;2: 1 raund';
const fa_j8 = (match, outcome) => 'G&apos;2: 2 raund';
const fa_k8 = (match, outcome) => 'G&apos;2: 3 raund';
const fa_l8 = (match, outcome) => 'G&apos;2: 4 raund';
const fa_m8 = (match, outcome) => 'G&apos;2: 5 raund';
const fa_n8 = (match, outcome) => 'G&apos;2: 6 raund';
const fa_o8 = (match, outcome) => 'G&apos;2: 7 raund';
const fa_p8 = (match, outcome) => 'G&apos;2: 8 raund';
const fa_q8 = (match, outcome) => 'G&apos;2: 9 raund';
const fa_r8 = (match, outcome) => 'G&apos;2: 10 raund';
const fa_s8 = (match, outcome) => 'G&apos;2: 11 raund';
const fa_t8 = (match, outcome) => 'G&apos;2: 12 raund';
const fa_u8 = (match, outcome) => 'X';
const fa_v8 = (match, outcome) => `FФ2(${signed(-outcome.condition)})`;
const fa_w8 = (match, outcome) => '5 va undan ko&apos;p';
const fa_x8 = (match, outcome) => 'Ikkala jamoa';
const fa_y8 = (match, outcome) => 'Bitta jamoa';
const fa_z8 = (match, outcome) => 'Hechqaysi';
const fa_a9 = (match, outcome) => `Har bir jamoa  ${outcome.condition + 1} yoki undan ko&apos;p to&apos;p kiritadi`;
const fa_b9 = (match, outcome) => `Faqat bitta jamoa ${outcome.condition + 1} yoki undan ko&apos;p to&apos;p kiritadi`;
const fa_c9 = (match, outcome) => `Hechqaysi jamoa ${outcome.condition + 1} yoki undan ko&apos;p to&apos;p kiritmaydi`;
const fa_d9 = (match, outcome) => 'Bosh bilan';
const fa_e9 = (match, outcome) => 'Oyoq bilan, o&apos;yindan';
const fa_f9 = (match, outcome) => 'Avtogol bilan';
const fa_g9 = (match, outcome) => 'Penaltidan';
const fa_h9 = (match, outcome) => 'Burchak zarbasi';
const fa_i9 = (match, outcome) => 'O&apos;yindan tashqari holat';
const fa_j9 = (match, outcome) => 'SK';
const fa_k9 = (match, outcome) => 'Gol';
const fa_l9 = (match, outcome) => 'Bo&apos;ladi';
const fa_m9 = (match, outcome) => 'Bo&apos;lmaydi';
const fa_n9 = (match, outcome) => `${outcome.condition} dan oldin`;
const fa_o9 = (match, outcome) => `${outcome.condition} dan keyin`;
const fa_p9 = (match, outcome) => 'Birinchi bo&apos;limda';
const fa_q9 = (match, outcome) => 'Ikkinchi bo&apos;limda';
const fa_r9 = (match, outcome) => 'Gol kiritilmaydi';
const fa_s9 = (match, outcome) => 'Kirita olmaydi';
const fa_t9 = (match, outcome) => 'G&apos;1D';
const fa_u9 = (match, outcome) => 'DG&apos;1';
const fa_v9 = (match, outcome) => 'DD';
const fa_w9 = (match, outcome) => 'DG&apos;2';
const fa_x9 = (match, outcome) => 'G&apos;2D';
const fa_y9 = (match, outcome) => '0-6';
const fa_z9 = (match, outcome) => '1-6';
const fa_a10 = (match, outcome) => '6-0';
const fa_b10 = (match, outcome) => '6-1';
const fa_c10 = (match, outcome) => 'Goli durrang';
const fa_d10 = (match, outcome) => 'Golsiz durrang';
const fa_e10 = (match, outcome) => `G&apos;2ko&apos;p ${outcome.condition}`;
const fa_f10 = (match, outcome) => 'Kiritadi';
const fa_g10 = (match, outcome) => 'Kiritmaydi';
const fa_h10 = (match, outcome) => 'Har qanday boshqa hisob';
const fa_i10 = (match, outcome) => 'Ikkala jamoa to&apos;p kiritadi';
const fa_j10 = (match, outcome) => 'Ikkala jamoa ham to&apos;p kiritmaydi';
const fa_k10 = (match, outcome) => 'Birinchisi kamroq';
const fa_l10 = (match, outcome) => 'Tenglik';
const fa_m10 = (match, outcome) => 'Birinchisi ko&apos;proq';
const fa_n10 = (match, outcome) => 'Ha/Ha';
const fa_o10 = (match, outcome) => 'Ha/Yo&apos;q';
const fa_p10 = (match, outcome) => 'Yo&apos;q/Ha';
const fa_q10 = (match, outcome) => 'Yo&apos;q/Yo&apos;q';
const fa_r10 = (match, outcome) => `Jko&apos;p ${outcome.condition}/Ha`;
const fa_s10 = (match, outcome) => `Jko&apos;p ${outcome.condition}/Yo&apos;q`;
const fa_t10 = (match, outcome) => `Jkam ${outcome.condition}/Ha`;
const fa_u10 = (match, outcome) => `Jkam ${outcome.condition}/Yo&apos;q`;
const fa_v10 = (match, outcome) => 'G&apos;1 asosiy vaqtda';
const fa_w10 = (match, outcome) => 'G&apos;2 asosiy vaqtda';
const fa_x10 = (match, outcome) => 'G&apos;1 qo&apos;shimcha vaqtda';
const fa_y10 = (match, outcome) => 'G&apos;2 qo&apos;shimcha vaqtda';
const fa_z10 = (match, outcome) => 'G&apos;1 penaltilar seriyasida';
const fa_a11 = (match, outcome) => 'G&apos;2 penaltilar seriyasida';
const fa_b11 = (match, outcome) => '1-bo&apos;lim';
const fa_c11 = (match, outcome) => 'Tanaffus';
const fa_d11 = (match, outcome) => '2-bo&apos;lim';
const fa_e11 = (match, outcome) => '5-4';
const fa_f11 = (match, outcome) => 'G&apos;1 har qanday boshqa hisob bilan';
const fa_g11 = (match, outcome) => '4-5';
const fa_h11 = (match, outcome) => 'G&apos;2  har qanday boshqa hisob bilan';
const fa_i11 = (match, outcome) => 'Hech kim';
const fa_j11 = (match, outcome) => '1-10';
const fa_k11 = (match, outcome) => '11-20';
const fa_l11 = (match, outcome) => '21-30';
const fa_m11 = (match, outcome) => '31-40';
const fa_n11 = (match, outcome) => '41-50';
const fa_o11 = (match, outcome) => '51-60';
const fa_p11 = (match, outcome) => '61-70';
const fa_q11 = (match, outcome) => '71-80';
const fa_r11 = (match, outcome) => '81-O&apos;yin asosiy vaqti oxirigacha';
const fa_s11 = (match, outcome) => 'Gol yo&apos;q';
const fa_t11 = (match, outcome) => 'G&apos;1: 8 va undan katta';
const fa_u11 = (match, outcome) => 'Ikkalasi ham kiritadi';
const fa_v11 = (match, outcome) => 'Bittasi kiritadi';
const fa_w11 = (match, outcome) => 'Ikklasi ham kiritolmaydi';
const fa_x11 = (match, outcome) => `Har bir jamoa ${outcome.condition + 1} ta va undan ko&apos;p gol kiritadi`;
const fa_y11 = (match, outcome) => `Faqat bitta jamoa ${outcome.condition + 1} ta va undan ko&apos;p gol kiritadi`;
const fa_z11 = (match, outcome) => `Hechqaysi jamoa ${outcome.condition + 1} ta va undan ko&apos;p gol kirita olmaydi`;
const fa_a12 = (match, outcome) => '1<2';
const fa_b12 = (match, outcome) => '1=2';
const fa_c12 = (match, outcome) => '1>2';
const fa_d12 = (match, outcome) => '1<3';
const fa_e12 = (match, outcome) => '1=3';
const fa_f12 = (match, outcome) => '1>3';
const fa_g12 = (match, outcome) => '2<3';
const fa_h12 = (match, outcome) => '2=3';
const fa_i12 = (match, outcome) => '2>3';
const fa_j12 = (match, outcome) => 'Birorta';
const fa_k12 = (match, outcome) => 'Birinchisi kichik';
const fa_l12 = (match, outcome) => 'Birinchisi katta';
const fa_m12 = (match, outcome) => 'W1';
const fa_n12 = (match, outcome) => 'W2';
const fa_o12 = (match, outcome) => `Under ${outcome.condition}`;
const fa_p12 = (match, outcome) => `Over ${outcome.condition}`;
const fa_q12 = (match, outcome) => 'W1: 1 round';
const fa_r12 = (match, outcome) => 'W1: 2 round';
const fa_s12 = (match, outcome) => 'W1: 3 round';
const fa_t12 = (match, outcome) => 'W1: 4 round';
const fa_u12 = (match, outcome) => 'W1: 5 round';
const fa_v12 = (match, outcome) => 'W1: Point Victory';
const fa_w12 = (match, outcome) => 'Draw';
const fa_x12 = (match, outcome) => 'W2: 1 round';
const fa_y12 = (match, outcome) => 'W2: 2 round';
const fa_z12 = (match, outcome) => 'W2: 3 round';
const fa_a13 = (match, outcome) => 'W2: 4 round';
const fa_b13 = (match, outcome) => 'W2: 5 round';
const fa_c13 = (match, outcome) => 'W2: Point Victory';
const fa_d13 = (match, outcome) => 'Yes';
const fa_e13 = (match, outcome) => 'No';
const fa_f13 = (match, outcome) => 'yes';
const fa_g13 = (match, outcome) => 'no';
const fa_h13 = (match, outcome) => 'Sariq shar';
const fa_i13 = (match, outcome) => 'Yashil shar';
const fa_j13 = (match, outcome) => 'Jigarrang shar';
const fa_k13 = (match, outcome) => 'Ko&apos;k shar';
const fa_l13 = (match, outcome) => 'Pushti shar';
const fa_m13 = (match, outcome) => 'Qora shar';
const fa_n13 = (match, outcome) => `≥ ${outcome.condition + 5}`;
const fa_o13 = (match, outcome) => '≤ 14';
const fa_p13 = (match, outcome) => '15 dan 17 gacha';
const fa_q13 = (match, outcome) => '18 dan 19 gacha';
const fa_r13 = (match, outcome) => '≥ 20';
const fa_s13 = (match, outcome) => '2--si yuqoriroq';
const fa_t13 = (match, outcome) => 'G&apos;1-0';
const fa_u13 = (match, outcome) => 'G&apos;1-15';
const fa_v13 = (match, outcome) => 'G&apos;1-30';
const fa_w13 = (match, outcome) => 'G&apos;1-40';
const fa_x13 = (match, outcome) => '0-G&apos;2';
const fa_y13 = (match, outcome) => '15-G&apos;2';
const fa_z13 = (match, outcome) => '30-G&apos;2';
const fa_a14 = (match, outcome) => '40-G&apos;2';
const fa_b14 = (match, outcome) => '3-6';
const fa_c14 = (match, outcome) => '5-7';
const fa_d14 = (match, outcome) => '6-2';
const fa_e14 = (match, outcome) => '6-3';
const fa_f14 = (match, outcome) => '6-4';
const fa_g14 = (match, outcome) => '6-7';
const fa_h14 = (match, outcome) => '7-5';
const fa_i14 = (match, outcome) => '7-6';
const fa_j14 = (match, outcome) => '7-0';
const fa_k14 = (match, outcome) => '7-1';
const fa_l14 = (match, outcome) => '7-2';
const fa_m14 = (match, outcome) => '7-3';
const fa_n14 = (match, outcome) => '7-4';
const fa_o14 = (match, outcome) => 'G&apos;1 boshqa harqanday hisob bilan';
const fa_p14 = (match, outcome) => '0-7';
const fa_q14 = (match, outcome) => '1-7';
const fa_r14 = (match, outcome) => '2-7';
const fa_s14 = (match, outcome) => '3-7';
const fa_t14 = (match, outcome) => '4-7';
const fa_u14 = (match, outcome) => 'G&apos;2 boshqa harqanday hisob bilan';
const fa_v14 = (match, outcome) => '8';
const fa_w14 = (match, outcome) => '9';
const fa_x14 = (match, outcome) => '10';
const fa_y14 = (match, outcome) => '11';
const fa_z14 = (match, outcome) => '≥ 13';
const fa_a15 = (match, outcome) => `${match.homeTeam} (O&apos;.T.O)`;
const fa_b15 = (match, outcome) => `${match.awayTeam} (O&apos;.T.O)`;
const fa_c15 = (match, outcome) => `${match.homeTeam}`;
const fa_d15 = (match, outcome) => 'Ikkalasi G&apos;1';
const fa_e15 = (match, outcome) => 'Ikkalasi G&apos;2';
const fa_f15 = (match, outcome) => '1-ая выше';
const fa_g15 = (match, outcome) => '2-ая выше';
const fa_h15 = (match, outcome) => `${outcome.condition + 1} dan ${outcome.condition + 2} gacha`;
const fa_i15 = (match, outcome) => `${outcome.condition + 3} dan ${outcome.condition + 4} gacha`;
const fa_j15 = (match, outcome) => `${outcome.condition + 5} dan ${outcome.condition + 6} gacha`;
const fa_k15 = (match, outcome) => '7 va undan katta';
const fa_l15 = (match, outcome) => 'F1';
const fa_m15 = (match, outcome) => 'F2';
const fa_n15 = (match, outcome) => 'G&apos;1: 7 va undan ko&apos;p';
const fa_o15 = (match, outcome) => 'G&apos;2: 7 va undan ko&apos;p';
const fa_p15 = (match, outcome) => '6-5';
const fa_q15 = (match, outcome) => '5-6';

let groupConfig = {
    32: {
        0: 'O&apos;yin',
        1: 'Birinchi set',
        2: 'Ikkinchi set',
        3: 'Uchinchi set',
        4: '10 ochkogacha kichik set (Birinchi set)',
        5: '15 ochkogacha kichik set (Birinchi set)',
        6: '10 ochkogacha kichik set (Ikkinchi set)',
        7: '15 ochkogacha kichik set (Ikkinchi set)',
        8: '10 ochkogacha kichik set (Uchinchi set)',
        9: '15 ochkogacha kichik set (Uchinchi set)'
    },
    35: {
        0: 'O&apos;yin',
        1: 'Birinchi davr'
    },
    31: {
        0: 'O&apos;yin',
        1: 'Birinchi chorak',
        2: 'Ikkinchi chorak',
        3: 'Uchinchi chorak',
        4: 'To&apos;rtinchi chorak',
        5: 'Ikki ochkolik to&apos;p otishlar',
        6: 'Uch ochkolik to&apos;p otishlar',
        7: 'O&apos;yinning birinchi yarmi',
        8: 'O&apos;yinning ikkinchi yarmi'
    },
    41: {
        0: 'O&apos;yin',
        1: 'O&apos;yinning birinchi yarmi',
        2: 'O&apos;yinning ikkinchi yarmi',
        3: 'Ikki ochkolik to&apos;p otishlar',
        4: 'Uch ochkolik to&apos;p otishlar'
    },
    18: {
        0: 'O&apos;yin',
        1: 'Birinchi davr',
        2: 'Ikkinchi davr',
        3: 'Uchinchi davr'
    },
    3: {
        0: 'O&apos;yin',
        1: 'Birinchi set',
        2: 'Ikkinchi set',
        3: 'Uchinchi set',
        4: '10 ochkogacha bo&apos;lgan kichik set (birinchi set)',
        5: '15 ochkogacha bo&apos;lgan kichik set (birinchi set)',
        6: '10 ochkogacha bo&apos;lgan kichik set (ikkinchi set)',
        7: '15 ochkogacha bo&apos;lgan kichik set (ikkinchi set)'
    },
    20: {
        0: 'O&apos;yin',
        1: 'Birinchi o&apos;t ochis marrasi',
        2: 'Ikkinchi o&apos;t ochis marrasi',
        3: 'Uchinchi o&apos;t ochis marrasi',
        4: 'To&apos;rtinchi o&apos;t ochis marrasi',
        5: 'Beshinchi o&apos;t ochis marrasi',
        6: 'Oltinchi o&apos;t ochis marrasi',
        7: 'Yettinchi o&apos;t ochis marrasi',
        8: 'Sakkizinchi o&apos;t ochis marrasi'
    },
    42: {
        0: 'O&apos;yin',
        1: 'Birinchi xarita',
        2: 'Ikkinchi xarita',
        3: 'Uchinchi xarita',
        4: 'To&apos;rtinchi xarita',
        5: 'Beshinchi xarita'
    },
    36: {
        0: 'O&apos;yin',
        1: 'Birinchi davr'
    },
    7: {
        0: 'O&apos;yin',
        1: 'Birinchi bo&apos;lim',
        2: 'Ikkinchi bo&apos;lim',
        3: '1-daqiqadan 15-daqiqagacha',
        4: '16-daqiqadan 30-daqiqagacha',
        5: '31-daqiqadan tanaffusgacha',
        6: '46-daqiqadan 60-daqiqagacha',
        7: '61-daqiqadan 75-daqiqagacha',
        8: '75-daqiqadan O&apos;yin oxirigacha',
        9: 'Burchak zarbalari',
        10: 'Burchak zarbalari (birinchi bo&apos;lim)',
        11: 'Sariq kartochkalar',
        12: 'Sariq kartochkalar  (birinchi bo&apos;lim)',
        13: 'Qo&apos;shimcha bo&apos;limlar',
        14: 'Birinchi qo&apos;shimcha bo&apos;lim',
        15: 'Ikkinchi qo&apos;shimcha bo&apos;lim',
        16: 'Penaltilar seriyasi'
    },
    34: {
        0: 'O&apos;yin',
        1: 'Birinchi bo&apos;lim',
        2: 'Ikkinchi bo&apos;lim',
        3: '1-daqiqadan 15-daqiqagacha',
        4: '16-daqiqadan 30-daqiqagacha',
        5: '31-daqiqadan bo&apos;lim so&apos;ngigacha',
        6: '46-daqiqadan 60-daqiqagacha',
        7: '61-daqiqadan 75-daqiqagacha',
        8: '76-daqiqadan o&apos;yin so&apos;ngigacha',
        9: 'Burchak zarbalari',
        10: 'Sariq kartochkalar'
    },
    19: {
        0: 'O&apos;yin',
        1: 'Birinchi davr',
        2: 'Ikkinchi davr'
    },
    30: {
        0: 'O&apos;yin',
        1: 'Birinchi davr',
        2: 'Ikkinchi davr',
        3: 'Uchinchi davr',
        4: '1-daqiqadan 10-daqiqagacha',
        5: '11-daqiqadan 20-daqiqagacha',
        6: '21-daqiqadan 30-daqiqagacha',
        7: '31-daqiqadan 40-daqiqagacha',
        8: '41-daqiqadan 50-daqiqagacha',
        9: '51-daqiqadan 60-daqiqagacha'
    },
    9: {
        0: 'O&apos;yin',
        1: 'Birinchi davr',
        2: 'Ikkinchi davr'
    },
    29: {
        0: 'O&apos;yin',
        1: 'Birinchi davr',
        2: 'Ikkinchi davr',
        3: 'Uchinchi davr',
        4: 'To&apos;rtinchi davr',
        5: 'Beshinchi davr',
        6: 'Oltinchi davr',
        7: 'Yettinchi davr',
        8: 'Sakkizinchi davr',
        9: 'To&apos;qqizinchi davr',
        10: 'O&apos;ninchi davr',
        11: 'O&apos;n birinchi davr',
        12: 'O&apos;n ikkinchi davr',
        13: 'O&apos;n uchinchi davr',
        14: 'O&apos;n to&apos;rtinchi davr',
        15: 'O&apos;n beshinchi davr',
        16: 'O&apos;n oltinchi davr',
        17: 'O&apos;n yettinchi davr',
        18: 'O&apos;n sakkizinchi davr',
        19: 'O&apos;n to&apos;qqizinchi davr',
        20: 'Yigirmanchi davr',
        21: 'Yigirma birinchi davr',
        22: 'Yigirma ikkinchi davr',
        23: 'Yigirma uchinchi davr',
        24: 'Yigirma to&apos;rtinchi davr',
        25: 'Yigirma beshinchi davr',
        26: 'Yigirma oltinchi davr',
        27: 'Yigirma yettinchi davr',
        28: 'Yigirma sakkizinchi davr',
        29: 'Yigirma to&apos;qqizinchi davr',
        30: 'O&apos;ttizinchi davr',
        31: 'O&apos;ttiz birinchi davr',
        32: 'O&apos;ttiz ikkinchi davr',
        33: 'O&apos;ttiz uchinchi davr',
        34: 'O&apos;ttiz to&apos;rtinchi davr',
        35: 'O&apos;ttiz beshinchi davr',
        36: 'O&apos;ttiz oltinchi davr',
        37: 'O&apos;ttiz yettinchi davr'
    },
    2: {
        0: 'O&apos;yin',
        1: 'Birinchi set',
        2: 'Ikkinchi set',
        3: 'Uchinchi set',
        4: 'To&apos;rtinchi set',
        5: 'Beshinchi set',
        6: 'Oltinchi set',
        7: 'Yettinchi set'
    },
    6: {
        0: 'O&apos;yin',
        1: 'Birinchi set',
        2: 'Ikkinchi set',
        3: 'Uchinchi set',
        4: 'To&apos;rtinchi set',
        5: 'Beshinchi set'
    },
    4: {
        0: 'O&apos;yin',
        1: 'Birinchi set',
        2: 'Ikkinchi set',
        3: 'Uchinchi set',
        4: 'To&apos;rtinchi set',
        5: 'Beshinchi set',
        6: 'Oltinchi set',
        7: '10 ochkogacha bo&apos;lgan kichik set (birinchi set)',
        8: '15 ochkogacha bo&apos;lgan kichik set (birinchi set)',
        9: '10 ochkogacha bo&apos;lgan kichik set (ikkinchi set)',
        10: '15 ochkogacha bo&apos;lgan kichik set (ikkinchi set)',
        11: '10 ochkogacha bo&apos;lgan kichik set (uchinchi set)',
        12: '15 ochkogacha bo&apos;lgan kichik set (uchinchi set)',
        13: '10 ochkogacha bo&apos;lgan kichik set (to&apos;rtinchi set)',
        14: '15 ochkogacha bo&apos;lgan kichik set (to&apos;rtinchi set)'
    },
    8: {
        0: 'O&apos;yin',
        1: 'Birinchi chorak',
        2: 'Ikkinchi chorak',
        3: 'Uchinchi chorak',
        4: 'To&apos;rtinchi chorak'
    }
};

let slotConfig = {
    32: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        557: sl_e1,
        607: sl_f1,
        122: sl_g1,
        129: sl_h1,
        138: sl_i1,
        182: sl_j1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        558: sl_e1,
        608: sl_f1,
        123: sl_g1,
        130: sl_h1,
        139: sl_i1,
        183: sl_j1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        559: sl_e1,
        609: sl_f1,
        124: sl_g1,
        131: sl_h1,
        140: sl_i1,
        184: sl_j1,
        362: sl_k1,
        17: sl_c1,
        176: sl_d1,
        358: sl_k1,
        13: sl_c1,
        172: sl_d1,
        363: sl_k1,
        18: sl_c1,
        177: sl_d1,
        359: sl_k1,
        14: sl_c1,
        173: sl_d1,
        364: sl_k1,
        19: sl_c1,
        178: sl_d1,
        360: sl_k1,
        15: sl_c1,
        174: sl_d1
    },
    35: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1
    },
    31: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        769: sl_l1,
        138: sl_i1,
        182: sl_j1,
        775: sl_m1,
        765: sl_n1,
        629: sl_e1,
        633: sl_o1,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        770: sl_l1,
        139: sl_i1,
        183: sl_j1,
        776: sl_m1,
        766: sl_n1,
        630: sl_e1,
        634: sl_o1,
        666: sl_b1,
        23: sl_c1,
        197: sl_d1,
        771: sl_l1,
        140: sl_i1,
        184: sl_j1,
        777: sl_m1,
        767: sl_n1,
        631: sl_e1,
        635: sl_o1,
        667: sl_b1,
        24: sl_c1,
        198: sl_d1,
        772: sl_l1,
        141: sl_i1,
        185: sl_j1,
        778: sl_m1,
        768: sl_n1,
        632: sl_e1,
        636: sl_o1,
        676: sl_b1,
        248: sl_c1,
        62: sl_d1,
        241: sl_i1,
        233: sl_j1,
        406: sl_p1,
        675: sl_b1,
        246: sl_c1,
        61: sl_d1,
        240: sl_i1,
        232: sl_j1,
        405: sl_p1,
        672: sl_b1,
        58: sl_c1,
        238: sl_d1,
        234: sl_i1,
        236: sl_j1,
        673: sl_b1,
        59: sl_c1,
        239: sl_d1,
        235: sl_i1,
        237: sl_j1
    },
    41: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        782: sl_l1,
        785: sl_m1,
        780: sl_n1,
        138: sl_i1,
        182: sl_j1,
        639: sl_e1,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        783: sl_l1,
        786: sl_m1,
        781: sl_n1,
        139: sl_i1,
        183: sl_j1,
        640: sl_e1,
        64: sl_c1,
        678: sl_b1,
        250: sl_d1,
        63: sl_c1,
        677: sl_b1,
        249: sl_d1
    },
    18: {
        664: sl_b1,
        195: sl_d1,
        698: sl_q1,
        21: sl_c1,
        734: sl_r1,
        665: sl_b1,
        196: sl_d1,
        699: sl_q1,
        22: sl_c1,
        735: sl_r1,
        666: sl_b1,
        197: sl_d1,
        700: sl_q1,
        23: sl_c1,
        736: sl_r1
    },
    3: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        896: sl_s1,
        138: sl_i1,
        182: sl_j1,
        557: sl_t1,
        83: sl_u1,
        788: sl_v1,
        842: sl_w1,
        845: sl_x1,
        848: sl_y1,
        607: sl_f1,
        791: sl_z1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        897: sl_s1,
        139: sl_i1,
        183: sl_j1,
        558: sl_t1,
        84: sl_u1,
        789: sl_v1,
        843: sl_w1,
        846: sl_x1,
        849: sl_y1,
        608: sl_f1,
        792: sl_z1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        898: sl_s1,
        140: sl_i1,
        184: sl_j1,
        559: sl_t1,
        85: sl_u1,
        790: sl_v1,
        844: sl_w1,
        847: sl_x1,
        850: sl_y1,
        609: sl_f1,
        793: sl_z1,
        362: sl_k1,
        17: sl_c1,
        176: sl_d1,
        358: sl_k1,
        13: sl_c1,
        172: sl_d1,
        363: sl_k1,
        18: sl_c1,
        177: sl_d1,
        359: sl_k1,
        14: sl_c1,
        173: sl_d1
    },
    20: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        851: sl_l1,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        852: sl_l1,
        666: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        853: sl_l1,
        667: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        854: sl_l1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        25: sl_c1,
        668: sl_b1,
        855: sl_l1,
        200: sl_d1,
        143: sl_i1,
        187: sl_j1,
        26: sl_c1,
        669: sl_b1,
        856: sl_l1,
        201: sl_d1,
        144: sl_i1,
        188: sl_j1,
        27: sl_c1,
        670: sl_b1,
        857: sl_l1,
        202: sl_d1,
        145: sl_i1,
        189: sl_j1,
        28: sl_c1,
        671: sl_b1,
        858: sl_l1
    },
    42: {
        557: sl_a2,
        1865: sl_b2,
        558: sl_a2,
        1866: sl_b2,
        559: sl_a2,
        1867: sl_b2,
        560: sl_a2,
        1868: sl_b2,
        561: sl_a2,
        1869: sl_b2
    },
    36: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1
    },
    7: {
        426: sl_v1,
        526: sl_w1,
        419: sl_c2,
        519: sl_d2,
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        734: sl_r1,
        756: sl_l1,
        698: sl_e2,
        794: sl_f2,
        860: sl_g2,
        273: sl_h2,
        83: sl_u1,
        727: sl_i2,
        729: sl_j2,
        731: sl_k2,
        648: sl_l2,
        420: sl_c2,
        520: sl_d2,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        735: sl_r1,
        757: sl_l1,
        699: sl_e2,
        859: sl_f2,
        861: sl_g2,
        274: sl_h2,
        84: sl_u1,
        728: sl_i2,
        649: sl_l2,
        652: sl_b1,
        641: sl_l2,
        2: sl_c1,
        160: sl_d1,
        148: sl_i1,
        154: sl_j1,
        655: sl_b1,
        642: sl_l2,
        5: sl_c1,
        163: sl_d1,
        149: sl_i1,
        155: sl_j1,
        657: sl_b1,
        643: sl_l2,
        7: sl_c1,
        165: sl_d1,
        150: sl_i1,
        156: sl_j1,
        658: sl_b1,
        644: sl_l2,
        930: sl_c1,
        166: sl_d1,
        151: sl_i1,
        157: sl_j1,
        660: sl_b1,
        645: sl_l2,
        9: sl_c1,
        168: sl_d1,
        152: sl_i1,
        158: sl_j1,
        663: sl_b1,
        646: sl_l2,
        12: sl_c1,
        171: sl_d1,
        153: sl_i1,
        159: sl_j1,
        680: sl_b1,
        66: sl_c1,
        255: sl_d1,
        438: sl_m2,
        354: sl_i1,
        355: sl_j1,
        681: sl_b1,
        67: sl_c1,
        258: sl_d1,
        356: sl_i1,
        357: sl_j1,
        690: sl_b1,
        81: sl_c1,
        353: sl_d1,
        440: sl_n2,
        441: sl_o2,
        682: sl_b1,
        68: sl_c1,
        259: sl_d1,
        146: sl_i1,
        650: sl_l2,
        740: sl_r1,
        69: sl_c1,
        262: sl_d1,
        683: sl_b1,
        694: sl_j2,
        180: sl_j1,
        70: sl_c1,
        263: sl_d1,
        684: sl_b1,
        72: sl_c1,
        277: sl_d1,
        686: sl_b1,
        181: sl_p2,
        147: sl_q2,
        741: sl_r1,
        276: sl_r2,
        275: sl_s2
    },
    34: {
        419: sl_c2,
        519: sl_d2,
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        734: sl_r1,
        756: sl_t2,
        698: sl_e2,
        794: sl_f2,
        860: sl_g2,
        83: sl_u1,
        420: sl_c2,
        520: sl_d2,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        735: sl_r1,
        757: sl_t2,
        699: sl_e2,
        795: sl_f2,
        861: sl_g2,
        84: sl_u1,
        652: sl_b1,
        2: sl_c1,
        160: sl_d1,
        148: sl_i1,
        154: sl_j1,
        655: sl_b1,
        5: sl_c1,
        163: sl_d1,
        149: sl_i1,
        155: sl_j1,
        657: sl_b1,
        7: sl_c1,
        165: sl_d1,
        150: sl_i1,
        156: sl_j1,
        658: sl_b1,
        930: sl_c1,
        166: sl_d1,
        151: sl_i1,
        157: sl_j1,
        660: sl_b1,
        9: sl_c1,
        168: sl_d1,
        152: sl_i1,
        158: sl_j1,
        663: sl_b1,
        12: sl_c1,
        171: sl_d1,
        153: sl_i1,
        159: sl_j1,
        255: sl_d1,
        353: sl_d1
    },
    19: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        877: sl_t2,
        138: sl_i1,
        182: sl_j1,
        875: sl_m1,
        873: sl_n1,
        196: sl_d1,
        878: sl_t2,
        876: sl_i1,
        874: sl_j1,
        665: sl_b1,
        22: sl_c1
    },
    30: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        756: sl_l1,
        138: sl_i1,
        182: sl_j1,
        734: sl_r1,
        83: sl_u1,
        698: sl_q1,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        757: sl_l1,
        139: sl_i1,
        183: sl_j1,
        735: sl_r1,
        84: sl_u1,
        699: sl_q1,
        666: sl_b1,
        23: sl_c1,
        197: sl_d1,
        758: sl_l1,
        140: sl_i1,
        184: sl_j1,
        736: sl_r1,
        85: sl_u1,
        700: sl_q1,
        653: sl_b1,
        161: sl_d1,
        3: sl_c1,
        654: sl_b1,
        162: sl_d1,
        4: sl_c1,
        656: sl_b1,
        164: sl_d1,
        6: sl_c1,
        659: sl_b1,
        167: sl_d1,
        8: sl_c1,
        661: sl_b1,
        169: sl_d1,
        10: sl_c1,
        662: sl_b1,
        170: sl_d1,
        11: sl_c1
    },
    9: {
        664: sl_b1,
        195: sl_d1,
        665: sl_b1,
        196: sl_d1
    },
    29: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        466: sl_u2,
        557: sl_v2,
        799: sl_w2,
        83: sl_u1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        467: sl_u2,
        558: sl_v2,
        800: sl_w2,
        84: sl_u1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        468: sl_u2,
        559: sl_v2,
        801: sl_w2,
        85: sl_u1,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        469: sl_u2,
        560: sl_v2,
        802: sl_w2,
        86: sl_u1,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        470: sl_u2,
        561: sl_v2,
        803: sl_w2,
        87: sl_u1,
        371: sl_b1,
        26: sl_c1,
        200: sl_d1,
        471: sl_u2,
        562: sl_v2,
        804: sl_w2,
        88: sl_u1,
        372: sl_b1,
        27: sl_c1,
        201: sl_d1,
        472: sl_u2,
        563: sl_v2,
        805: sl_w2,
        89: sl_u1,
        373: sl_b1,
        28: sl_c1,
        202: sl_d1,
        473: sl_u2,
        564: sl_v2,
        806: sl_w2,
        90: sl_u1,
        374: sl_b1,
        29: sl_c1,
        203: sl_d1,
        474: sl_u2,
        565: sl_v2,
        807: sl_w2,
        91: sl_u1,
        375: sl_b1,
        30: sl_c1,
        204: sl_d1,
        475: sl_u2,
        566: sl_v2,
        808: sl_w2,
        92: sl_u1,
        376: sl_b1,
        31: sl_c1,
        205: sl_d1,
        476: sl_u2,
        567: sl_v2,
        809: sl_w2,
        93: sl_u1,
        377: sl_b1,
        32: sl_c1,
        206: sl_d1,
        477: sl_u2,
        568: sl_v2,
        810: sl_w2,
        94: sl_u1,
        378: sl_b1,
        33: sl_c1,
        207: sl_d1,
        478: sl_u2,
        569: sl_v2,
        811: sl_w2,
        95: sl_u1,
        379: sl_b1,
        34: sl_c1,
        208: sl_d1,
        479: sl_u2,
        570: sl_v2,
        812: sl_w2,
        96: sl_u1,
        380: sl_b1,
        35: sl_c1,
        209: sl_d1,
        480: sl_u2,
        571: sl_v2,
        813: sl_w2,
        97: sl_u1,
        381: sl_b1,
        36: sl_c1,
        210: sl_d1,
        481: sl_u2,
        572: sl_v2,
        814: sl_w2,
        98: sl_u1,
        382: sl_b1,
        37: sl_c1,
        211: sl_d1,
        482: sl_u2,
        573: sl_v2,
        815: sl_w2,
        99: sl_u1,
        383: sl_b1,
        38: sl_c1,
        212: sl_d1,
        483: sl_u2,
        574: sl_v2,
        816: sl_w2,
        100: sl_u1,
        384: sl_b1,
        39: sl_c1,
        213: sl_d1,
        484: sl_u2,
        575: sl_v2,
        817: sl_w2,
        101: sl_u1,
        385: sl_b1,
        40: sl_c1,
        214: sl_d1,
        485: sl_u2,
        576: sl_v2,
        818: sl_w2,
        104: sl_u1,
        386: sl_b1,
        41: sl_c1,
        215: sl_d1,
        486: sl_u2,
        577: sl_v2,
        819: sl_w2,
        105: sl_u1,
        387: sl_b1,
        42: sl_c1,
        216: sl_d1,
        487: sl_u2,
        578: sl_v2,
        820: sl_w2,
        106: sl_u1,
        388: sl_b1,
        43: sl_c1,
        217: sl_d1,
        488: sl_u2,
        579: sl_v2,
        821: sl_w2,
        107: sl_u1,
        389: sl_b1,
        44: sl_c1,
        218: sl_d1,
        489: sl_u2,
        580: sl_v2,
        822: sl_w2,
        108: sl_u1,
        390: sl_b1,
        45: sl_c1,
        219: sl_d1,
        490: sl_u2,
        581: sl_v2,
        823: sl_w2,
        109: sl_u1,
        391: sl_x2,
        46: sl_y2,
        220: sl_z2,
        491: sl_a3,
        582: sl_b3,
        824: sl_c3,
        110: sl_d3,
        392: sl_b1,
        47: sl_c1,
        221: sl_d1,
        492: sl_u2,
        583: sl_v2,
        825: sl_w2,
        111: sl_u1,
        393: sl_b1,
        48: sl_c1,
        222: sl_d1,
        493: sl_u2,
        584: sl_v2,
        826: sl_w2,
        112: sl_u1,
        394: sl_b1,
        49: sl_c1,
        223: sl_d1,
        494: sl_u2,
        585: sl_v2,
        827: sl_w2,
        113: sl_u1,
        395: sl_b1,
        50: sl_c1,
        224: sl_d1,
        495: sl_u2,
        586: sl_v2,
        828: sl_w2,
        114: sl_u1,
        396: sl_b1,
        51: sl_c1,
        225: sl_d1,
        496: sl_u2,
        587: sl_v2,
        829: sl_w2,
        115: sl_u1,
        397: sl_b1,
        52: sl_c1,
        226: sl_d1,
        497: sl_u2,
        588: sl_v2,
        830: sl_w2,
        116: sl_u1,
        398: sl_b1,
        53: sl_c1,
        227: sl_d1,
        498: sl_u2,
        589: sl_v2,
        831: sl_w2,
        117: sl_u1,
        399: sl_b1,
        54: sl_c1,
        228: sl_d1,
        499: sl_u2,
        590: sl_v2,
        832: sl_w2,
        118: sl_u1,
        400: sl_b1,
        55: sl_c1,
        229: sl_d1,
        500: sl_u2,
        591: sl_v2,
        833: sl_w2,
        119: sl_u1,
        401: sl_b1,
        56: sl_c1,
        230: sl_d1,
        501: sl_u2,
        592: sl_v2,
        834: sl_w2,
        120: sl_u1,
        402: sl_b1,
        57: sl_c1,
        231: sl_d1,
        502: sl_u2,
        593: sl_v2,
        835: sl_w2,
        121: sl_u1
    },
    2: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        607: sl_e3,
        557: sl_f3,
        863: sl_l1,
        885: sl_l1,
        122: sl_g3,
        129: sl_h3,
        83: sl_i3,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        608: sl_e3,
        558: sl_f3,
        864: sl_l1,
        886: sl_l1,
        123: sl_g3,
        130: sl_h3,
        84: sl_i3,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        609: sl_e3,
        559: sl_f3,
        865: sl_l1,
        887: sl_l1,
        124: sl_g3,
        131: sl_h3,
        85: sl_i3,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        610: sl_e3,
        560: sl_f3,
        866: sl_l1,
        888: sl_l1,
        125: sl_g3,
        132: sl_h3,
        86: sl_i3,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        611: sl_e3,
        561: sl_f3,
        867: sl_l1,
        889: sl_l1,
        126: sl_g3,
        133: sl_h3,
        87: sl_i3,
        371: sl_b1,
        26: sl_c1,
        200: sl_d1,
        143: sl_i1,
        187: sl_j1,
        612: sl_e3,
        562: sl_f3,
        868: sl_l1,
        890: sl_l1,
        127: sl_g3,
        134: sl_h3,
        88: sl_i3,
        372: sl_b1,
        27: sl_c1,
        201: sl_d1,
        144: sl_i1,
        188: sl_j1,
        613: sl_e3,
        563: sl_f3,
        869: sl_l1,
        891: sl_l1,
        128: sl_g3,
        135: sl_h3,
        89: sl_i3
    },
    6: {
        1861: sl_j3,
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        333: sl_k3,
        557: sl_l3,
        745: sl_r1,
        896: sl_m3,
        618: sl_n3,
        594: sl_o3,
        759: sl_p3,
        750: sl_q3,
        190: sl_r3,
        83: sl_u1,
        300: sl_s3,
        310: sl_t3,
        545: sl_u3,
        508: sl_v3,
        552: sl_w3,
        708: sl_x3,
        76: sl_y3,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        334: sl_k3,
        558: sl_l3,
        746: sl_r1,
        897: sl_m3,
        619: sl_n3,
        595: sl_o3,
        760: sl_p3,
        751: sl_q3,
        191: sl_r3,
        84: sl_u1,
        301: sl_s3,
        311: sl_t3,
        546: sl_u3,
        509: sl_v3,
        553: sl_w3,
        709: sl_x3,
        77: sl_y3,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        335: sl_k3,
        559: sl_l3,
        747: sl_r1,
        898: sl_m3,
        620: sl_n3,
        596: sl_o3,
        761: sl_p3,
        752: sl_q3,
        192: sl_r3,
        85: sl_u1,
        302: sl_s3,
        312: sl_t3,
        547: sl_u3,
        510: sl_v3,
        554: sl_w3,
        710: sl_x3,
        78: sl_y3,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        336: sl_k3,
        560: sl_l3,
        748: sl_r1,
        899: sl_m3,
        621: sl_n3,
        597: sl_o3,
        762: sl_p3,
        753: sl_q3,
        193: sl_r3,
        86: sl_u1,
        303: sl_s3,
        313: sl_t3,
        548: sl_u3,
        511: sl_v3,
        555: sl_w3,
        711: sl_x3,
        79: sl_y3,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        337: sl_k3,
        561: sl_l3,
        749: sl_r1,
        900: sl_m3,
        622: sl_n3,
        598: sl_o3,
        763: sl_p3,
        754: sl_q3,
        194: sl_r3,
        87: sl_u1,
        304: sl_s3,
        314: sl_t3,
        549: sl_u3,
        512: sl_v3,
        556: sl_w3,
        712: sl_x3,
        80: sl_y3
    },
    4: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        896: sl_m3,
        557: sl_e1,
        836: sl_v1,
        909: sl_w1,
        914: sl_l1,
        920: sl_l1,
        83: sl_u1,
        903: sl_z1,
        607: sl_z3,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        897: sl_m3,
        558: sl_e1,
        837: sl_v1,
        910: sl_w1,
        915: sl_l1,
        921: sl_l1,
        84: sl_u1,
        904: sl_z1,
        608: sl_z3,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        898: sl_m3,
        559: sl_e1,
        838: sl_v1,
        911: sl_w1,
        916: sl_l1,
        922: sl_l1,
        85: sl_u1,
        905: sl_z1,
        609: sl_z3,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        899: sl_m3,
        560: sl_e1,
        839: sl_v1,
        912: sl_w1,
        917: sl_l1,
        923: sl_l1,
        86: sl_u1,
        906: sl_z1,
        610: sl_z3,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        900: sl_m3,
        561: sl_e1,
        840: sl_v1,
        913: sl_w1,
        918: sl_l1,
        924: sl_l1,
        87: sl_u1,
        907: sl_z1,
        611: sl_z3,
        26: sl_c1,
        200: sl_d1,
        143: sl_i1,
        187: sl_j1,
        371: sl_b1,
        562: sl_e1,
        919: sl_l1,
        925: sl_l1,
        901: sl_m3,
        908: sl_z1,
        88: sl_u1,
        362: sl_k1,
        17: sl_c1,
        176: sl_d1,
        358: sl_k1,
        13: sl_c1,
        172: sl_d1,
        363: sl_k1,
        18: sl_c1,
        177: sl_d1,
        359: sl_k1,
        14: sl_c1,
        173: sl_d1,
        364: sl_k1,
        19: sl_c1,
        178: sl_d1,
        360: sl_k1,
        15: sl_c1,
        174: sl_d1,
        365: sl_k1,
        20: sl_c1,
        179: sl_d1,
        361: sl_k1,
        16: sl_c1,
        175: sl_d1
    },
    8: {
        664: sl_b1,
        195: sl_d1,
        665: sl_b1,
        196: sl_d1,
        666: sl_b1,
        197: sl_d1,
        667: sl_b1,
        198: sl_d1
    }
};

let baseOutcomeConfig = {
    11: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    32: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        122: bo_a2,
        123: bo_b2,
        124: bo_c2,
        129: bo_d2,
        130: bo_e2,
        131: bo_f2,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        257: bo_d1,
        307: bo_e1,
        443: bo_h1,
        608: bo_i1,
        362: bo_m2,
        363: bo_n2,
        364: bo_o2,
        17: bo_p2,
        18: bo_q2,
        19: bo_r2,
        176: bo_s2,
        177: bo_t2,
        178: bo_u2,
        358: bo_v2,
        359: bo_w2,
        360: bo_x2,
        13: bo_y2,
        14: bo_z2,
        15: bo_a3,
        172: bo_b3,
        173: bo_c3,
        174: bo_d3,
        256: bo_d1,
        306: bo_e1
    },
    35: {
        138: bo_e3,
        256: bo_d1,
        21: bo_f3,
        673: bo_g3,
        182: bo_h3,
        306: bo_e1,
        698: bo_g1,
        731: bo_i3,
        656: bo_j3,
        195: bo_k3,
        74: bo_b1,
        349: bo_c1,
        443: bo_h1,
        608: bo_i1,
        911: bo_l3,
        426: bo_m3,
        535: bo_n3,
        871: bo_o3,
        710: bo_p3,
        742: bo_q3
    },
    10: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_c1,
        403: bo_g1,
        1: bo_r3,
        443: bo_h1,
        608: bo_i1
    },
    31: {
        74: bo_b1,
        349: bo_c1,
        21: bo_s3,
        22: bo_t3,
        23: bo_u3,
        24: bo_v3,
        256: bo_d1,
        306: bo_e1,
        195: bo_w3,
        196: bo_x3,
        197: bo_y3,
        198: bo_z3,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        403: bo_g1,
        138: bo_e4,
        139: bo_f4,
        140: bo_g4,
        141: bo_h4,
        182: bo_i4,
        183: bo_j4,
        184: bo_k4,
        185: bo_l4,
        238: bo_m4,
        682: bo_n4,
        239: bo_o4,
        58: bo_p4,
        59: bo_q4,
        681: bo_r4,
        234: bo_s4,
        235: bo_t4,
        236: bo_u4,
        237: bo_v4,
        725: bo_w4,
        726: bo_x4,
        727: bo_y4,
        728: bo_z4,
        782: bo_a5,
        778: bo_b5,
        779: bo_c5,
        780: bo_d5,
        781: bo_e5,
        783: bo_f5,
        773: bo_g5,
        474: bo_h5,
        421: bo_i5,
        530: bo_j5,
        422: bo_k5,
        531: bo_l5,
        444: bo_m5,
        888: bo_n5,
        280: bo_o5,
        317: bo_p5,
        424: bo_q5,
        533: bo_r5,
        423: bo_s5,
        532: bo_t5,
        637: bo_u5,
        788: bo_v5,
        784: bo_w5,
        785: bo_x5,
        786: bo_y5,
        787: bo_z5,
        774: bo_w5,
        775: bo_x5,
        776: bo_y5,
        777: bo_z5,
        281: bo_a6,
        137: bo_b6,
        246: bo_c6,
        248: bo_d6,
        240: bo_e6,
        232: bo_f6,
        241: bo_g6,
        233: bo_h6,
        61: bo_i6,
        62: bo_j6,
        684: bo_k6,
        685: bo_l6,
        443: bo_h1,
        608: bo_i1,
        890: bo_m6,
        242: bo_n6,
        245: bo_o6,
        243: bo_p6,
        60: bo_q6,
        683: bo_r6,
        406: bo_s6,
        405: bo_t6,
        404: bo_u6,
        700: bo_v6,
        408: bo_w6,
        407: bo_x6,
        247: bo_y6,
        244: bo_z6,
        638: bo_a7,
        639: bo_b7,
        640: bo_c7,
        641: bo_d7,
        646: bo_e7,
        642: bo_f7,
        643: bo_g7,
        644: bo_h7,
        645: bo_i7
    },
    41: {
        74: bo_b1,
        349: bo_c1,
        21: bo_j7,
        22: bo_k7,
        403: bo_g1,
        673: bo_l7,
        674: bo_m7,
        195: bo_n7,
        196: bo_o7,
        791: bo_p7,
        792: bo_q7,
        637: bo_u5,
        796: bo_v5,
        794: bo_r7,
        795: bo_s7,
        789: bo_r7,
        790: bo_s7,
        725: bo_t7,
        726: bo_u7,
        793: bo_a5,
        411: bo_v7,
        701: bo_w7,
        251: bo_x7,
        252: bo_y7,
        409: bo_k5,
        430: bo_l5,
        410: bo_z7,
        431: bo_a8,
        281: bo_a6,
        137: bo_b6,
        249: bo_c6,
        250: bo_d6,
        63: bo_i6,
        64: bo_j6,
        686: bo_k6,
        687: bo_l6,
        103: bo_f1,
        256: bo_d1,
        306: bo_e1,
        138: bo_b8,
        139: bo_c8,
        182: bo_d8,
        183: bo_e8,
        443: bo_h1,
        608: bo_i1,
        648: bo_f8,
        649: bo_g8
    },
    18: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_h8,
        196: bo_i8,
        197: bo_j8,
        673: bo_k8,
        674: bo_l8,
        675: bo_m8,
        610: bo_n8,
        443: bo_h1,
        608: bo_i1,
        806: bo_o8,
        893: bo_p8,
        707: bo_q8,
        708: bo_r8,
        709: bo_s8,
        889: bo_o3,
        904: bo_t8,
        253: bo_u8,
        688: bo_v8,
        65: bo_w8,
        751: bo_q3,
        21: bo_x8,
        22: bo_y8,
        23: bo_z8,
        743: bo_a9,
        744: bo_b9,
        745: bo_c9,
        615: bo_d9,
        350: bo_u8
    },
    3: {
        73: bo_b1,
        318: bo_c1,
        21: bo_e9,
        22: bo_f9,
        23: bo_g9,
        195: bo_h9,
        196: bo_i9,
        197: bo_j9,
        352: bo_k9,
        746: bo_q3,
        102: bo_l9,
        403: bo_g1,
        138: bo_m9,
        139: bo_n9,
        140: bo_o9,
        182: bo_p9,
        183: bo_q9,
        184: bo_r9,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        74: bo_s9,
        854: bo_t9,
        855: bo_u9,
        856: bo_v9,
        857: bo_t9,
        858: bo_u9,
        859: bo_v9,
        797: bo_w9,
        798: bo_x9,
        799: bo_y9,
        851: bo_z9,
        852: bo_a10,
        853: bo_b10,
        83: bo_c10,
        84: bo_d10,
        85: bo_e10,
        905: bo_f10,
        906: bo_g10,
        907: bo_h10,
        443: bo_h1,
        608: bo_i1,
        362: bo_i10,
        363: bo_j10,
        17: bo_k10,
        18: bo_l10,
        176: bo_m10,
        177: bo_n10,
        358: bo_o10,
        359: bo_p10,
        13: bo_q10,
        14: bo_r10,
        172: bo_s10,
        173: bo_t10,
        616: bo_u10,
        617: bo_v10,
        618: bo_w10,
        891: bo_x10,
        257: bo_d1,
        307: bo_e1,
        800: bo_y10,
        801: bo_z10,
        802: bo_a11
    },
    20: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        698: bo_g1,
        195: bo_b11,
        196: bo_c11,
        197: bo_d11,
        198: bo_e11,
        199: bo_f11,
        200: bo_g11,
        201: bo_h11,
        202: bo_i11,
        138: bo_j11,
        139: bo_k11,
        140: bo_l11,
        141: bo_m11,
        142: bo_n11,
        143: bo_o11,
        144: bo_p11,
        145: bo_q11,
        182: bo_r11,
        183: bo_s11,
        184: bo_t11,
        185: bo_u11,
        186: bo_v11,
        187: bo_w11,
        188: bo_x11,
        189: bo_y11,
        21: bo_z11,
        22: bo_a12,
        23: bo_b12,
        24: bo_c12,
        25: bo_d12,
        26: bo_e12,
        27: bo_f12,
        28: bo_g12,
        673: bo_h12,
        674: bo_i12,
        675: bo_j12,
        676: bo_k12,
        677: bo_l12,
        678: bo_m12,
        679: bo_n12,
        680: bo_o12,
        860: bo_p12,
        861: bo_q12,
        862: bo_r12,
        863: bo_s12,
        864: bo_t12,
        865: bo_u12,
        866: bo_v12,
        867: bo_w12,
        443: bo_h1,
        608: bo_i1
    },
    5: {
        349: bo_c1,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1,
        945: bo_x12,
        948: bo_y12,
        949: bo_z12
    },
    40: {
        656: bo_j3,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    37: {
        443: bo_h1,
        608: bo_i1
    },
    38: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_c1,
        615: bo_a13,
        413: bo_b13,
        414: bo_c13
    },
    42: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_c1,
        615: bo_d13,
        413: bo_b13,
        414: bo_e13,
        566: bo_f13,
        567: bo_g13,
        568: bo_h13,
        569: bo_i13,
        570: bo_j13,
        698: bo_k13,
        366: bo_l13,
        367: bo_m13,
        368: bo_n13,
        369: bo_o13,
        370: bo_p13,
        940: bo_q13,
        941: bo_r13,
        942: bo_s13,
        943: bo_t13,
        944: bo_u13
    },
    26: {
        443: bo_h1,
        608: bo_i1
    },
    25: {
        443: bo_h1,
        608: bo_i1
    },
    16: {
        443: bo_h1,
        608: bo_i1
    },
    12: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    36: {
        610: bo_v13,
        698: bo_g1,
        656: bo_j3,
        74: bo_b1,
        349: bo_c1,
        615: bo_d9,
        256: bo_d1,
        306: bo_e1,
        673: bo_k8,
        21: bo_x8,
        195: bo_h8,
        443: bo_h1,
        608: bo_i1
    },
    7: {
        425: bo_w13,
        534: bo_x13,
        540: bo_y13,
        343: bo_z13,
        345: bo_a14,
        260: bo_b14,
        261: bo_c14,
        83: bo_d14,
        84: bo_e14,
        803: bo_f14,
        868: bo_g14,
        869: bo_h14,
        870: bo_i14,
        805: bo_j14,
        892: bo_k14,
        346: bo_l14,
        419: bo_m14,
        528: bo_n14,
        420: bo_o14,
        529: bo_p14,
        707: bo_q14,
        708: bo_r14,
        706: bo_s14,
        804: bo_t14,
        474: bo_u14,
        614: bo_v14,
        609: bo_w14,
        416: bo_x14,
        732: bo_y14,
        525: bo_z14,
        850: bo_a15,
        473: bo_b15,
        442: bo_c15,
        729: bo_d15,
        538: bo_e15,
        542: bo_f15,
        730: bo_g15,
        471: bo_h15,
        635: bo_i15,
        714: bo_j15,
        624: bo_k15,
        625: bo_l15,
        715: bo_m15,
        650: bo_n15,
        651: bo_o15,
        652: bo_p15,
        653: bo_q15,
        654: bo_r15,
        655: bo_s15,
        634: bo_t15,
        626: bo_u15,
        733: bo_v15,
        734: bo_w15,
        258: bo_x15,
        259: bo_y15,
        66: bo_z15,
        67: bo_a16,
        81: bo_b16,
        68: bo_c16,
        689: bo_d16,
        690: bo_e16,
        699: bo_f16,
        691: bo_g16,
        723: bo_h16,
        633: bo_i16,
        74: bo_b1,
        349: bo_j16,
        656: bo_k16,
        698: bo_g1,
        322: bo_l16,
        904: bo_m16,
        1: bo_r3,
        136: bo_n16,
        747: bo_q3,
        871: bo_o16,
        255: bo_p16,
        705: bo_q16,
        323: bo_r16,
        324: bo_s16,
        702: bo_t16,
        278: bo_u16,
        256: bo_v16,
        306: bo_w16,
        195: bo_x16,
        196: bo_y16,
        21: bo_z16,
        22: bo_a17,
        282: bo_b17,
        911: bo_c17,
        353: bo_d17,
        673: bo_g3,
        674: bo_e17,
        2: bo_f17,
        5: bo_g17,
        7: bo_h17,
        939: bo_i17,
        9: bo_j17,
        12: bo_k17,
        417: bo_l17,
        526: bo_m17,
        325: bo_n17,
        103: bo_o17,
        160: bo_p17,
        163: bo_q17,
        165: bo_r17,
        166: bo_s17,
        168: bo_t17,
        171: bo_u17,
        148: bo_v17,
        149: bo_w17,
        150: bo_x17,
        151: bo_y17,
        152: bo_z17,
        153: bo_a18,
        154: bo_b18,
        155: bo_c18,
        156: bo_d18,
        157: bo_e18,
        158: bo_f18,
        159: bo_g18,
        731: bo_d9,
        765: bo_h18,
        766: bo_i18,
        415: bo_j18,
        524: bo_k18,
        418: bo_l18,
        527: bo_m18,
        743: bo_n18,
        744: bo_o18,
        710: bo_p3,
        321: bo_p18,
        326: bo_q18,
        327: bo_r18,
        724: bo_s18,
        661: bo_t18,
        664: bo_u18,
        666: bo_v18,
        667: bo_w18,
        669: bo_x18,
        672: bo_y18,
        426: bo_z18,
        535: bo_a19,
        537: bo_b19,
        541: bo_c19,
        539: bo_d19,
        138: bo_e19,
        139: bo_f19,
        182: bo_g19,
        183: bo_h19,
        437: bo_i19,
        436: bo_j19,
        694: bo_k13,
        71: bo_k19,
        271: bo_l19,
        268: bo_m19,
        265: bo_n19,
        267: bo_o19,
        270: bo_p19,
        272: bo_q19,
        269: bo_r19,
        266: bo_s19,
        264: bo_t19,
        281: bo_u19,
        137: bo_v19,
        660: bo_j3,
        880: bo_w19,
        879: bo_x19,
        429: bo_y19,
        433: bo_z19,
        443: bo_h1,
        608: bo_i1,
        881: bo_a20,
        273: bo_b20,
        274: bo_c20,
        435: bo_d20,
        704: bo_e20,
        432: bo_f20,
        428: bo_g20,
        434: bo_h20,
        439: bo_i20,
        440: bo_j20,
        441: bo_k20,
        438: bo_l20,
        623: bo_m20,
        180: bo_n20,
        146: bo_o20,
        659: bo_p20,
        749: bo_q20,
        69: bo_r20,
        262: bo_s20,
        692: bo_t20,
        703: bo_u20,
        70: bo_v20,
        263: bo_w20,
        693: bo_x20,
        72: bo_y20,
        277: bo_z20,
        695: bo_a21,
        750: bo_b21,
        181: bo_c21,
        147: bo_d21,
        276: bo_e21,
        275: bo_f21,
        735: bo_g21,
        736: bo_h21,
        737: bo_i21,
        738: bo_j21,
        739: bo_k21,
        740: bo_l21,
        356: bo_m21,
        357: bo_n21,
        354: bo_o21,
        355: bo_p21,
        937: bo_q21,
        657: bo_r21,
        658: bo_s21,
        412: bo_t21
    },
    14: {
        443: bo_h1,
        608: bo_i1
    },
    34: {
        425: bo_u21,
        534: bo_v21,
        540: bo_y13,
        343: bo_z13,
        345: bo_a14,
        260: bo_b14,
        261: bo_c14,
        83: bo_d14,
        84: bo_e14,
        803: bo_f14,
        868: bo_g14,
        869: bo_h14,
        870: bo_i14,
        346: bo_l14,
        419: bo_m14,
        528: bo_n14,
        420: bo_o14,
        529: bo_p14,
        707: bo_q14,
        708: bo_r14,
        706: bo_s14,
        538: bo_e15,
        74: bo_b1,
        349: bo_w21,
        656: bo_k16,
        698: bo_g1,
        322: bo_l16,
        904: bo_m16,
        1: bo_r3,
        136: bo_n16,
        747: bo_q3,
        871: bo_o16,
        255: bo_p16,
        705: bo_q16,
        323: bo_r16,
        324: bo_s16,
        702: bo_t16,
        278: bo_x21,
        256: bo_v16,
        306: bo_w16,
        195: bo_x16,
        196: bo_y16,
        21: bo_z16,
        22: bo_a17,
        282: bo_b17,
        911: bo_c17,
        353: bo_d17,
        673: bo_g3,
        674: bo_e17,
        2: bo_f17,
        5: bo_g17,
        7: bo_h17,
        939: bo_i17,
        9: bo_j17,
        12: bo_k17,
        417: bo_l17,
        526: bo_m17,
        325: bo_n17,
        103: bo_o17,
        160: bo_p17,
        163: bo_q17,
        165: bo_r17,
        166: bo_s17,
        168: bo_t17,
        171: bo_u17,
        148: bo_v17,
        149: bo_w17,
        150: bo_x17,
        151: bo_y17,
        152: bo_z17,
        153: bo_a18,
        154: bo_b18,
        155: bo_c18,
        156: bo_d18,
        157: bo_e18,
        158: bo_f18,
        159: bo_g18,
        731: bo_d9,
        765: bo_h18,
        766: bo_i18,
        415: bo_y21,
        524: bo_z21,
        418: bo_l18,
        527: bo_m18,
        743: bo_n18,
        744: bo_o18,
        710: bo_p3,
        321: bo_p18,
        326: bo_q18,
        327: bo_r18,
        724: bo_s18,
        661: bo_t18,
        664: bo_u18,
        666: bo_v18,
        667: bo_w18,
        669: bo_x18,
        672: bo_y18,
        426: bo_z18,
        535: bo_a19,
        537: bo_b19,
        541: bo_c19,
        539: bo_d19,
        138: bo_e19,
        139: bo_f19,
        182: bo_g19,
        183: bo_h19,
        443: bo_h1,
        608: bo_i1
    },
    19: {
        74: bo_b1,
        349: bo_c1,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_a22,
        103: bo_f1,
        615: bo_d9,
        886: bo_b22,
        887: bo_c22,
        911: bo_d22,
        884: bo_e22,
        885: bo_f22,
        882: bo_g22,
        883: bo_h22,
        723: bo_i22,
        673: bo_g3,
        674: bo_e17,
        21: bo_f3,
        22: bo_j22,
        138: bo_d1,
        182: bo_e1,
        443: bo_h1,
        608: bo_i1
    },
    30: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        21: bo_x8,
        22: bo_y8,
        23: bo_z8,
        279: bo_k22,
        610: bo_v13,
        256: bo_d1,
        306: bo_e1,
        195: bo_h8,
        196: bo_i8,
        197: bo_j8,
        673: bo_k8,
        674: bo_l8,
        675: bo_m8,
        350: bo_u8,
        103: bo_l22,
        415: bo_m22,
        524: bo_n22,
        743: bo_o22,
        744: bo_p22,
        745: bo_q22,
        710: bo_r22,
        403: bo_g1,
        426: bo_s22,
        535: bo_t22,
        706: bo_u22,
        343: bo_v22,
        346: bo_w22,
        83: bo_x22,
        84: bo_y22,
        85: bo_z22,
        344: bo_a23,
        347: bo_b23,
        765: bo_c23,
        766: bo_d23,
        767: bo_e23,
        138: bo_f23,
        139: bo_g23,
        140: bo_h23,
        182: bo_i23,
        183: bo_j23,
        184: bo_k23,
        751: bo_q3,
        911: bo_l23,
        889: bo_c1,
        637: bo_m23,
        615: bo_d9,
        412: bo_n23,
        634: bo_o23,
        626: bo_p23,
        611: bo_q23,
        443: bo_h1,
        608: bo_i1,
        904: bo_r23,
        449: bo_s23,
        446: bo_t23,
        451: bo_u23,
        711: bo_v23,
        712: bo_w23,
        713: bo_x23,
        450: bo_y23,
        447: bo_z23,
        448: bo_a24,
        662: bo_b24,
        663: bo_c24,
        665: bo_d24,
        668: bo_e24,
        670: bo_f24,
        671: bo_g24,
        3: bo_h24,
        4: bo_i24,
        6: bo_j24,
        8: bo_k24,
        10: bo_l24,
        11: bo_m24,
        161: bo_n24,
        162: bo_o24,
        164: bo_p24,
        167: bo_q24,
        169: bo_r24,
        170: bo_s24,
        707: bo_t24,
        708: bo_u24,
        709: bo_v24,
        946: bo_w24,
        947: bo_x24
    },
    23: {
        443: bo_h1,
        608: bo_i1
    },
    13: {
        468: bo_y24,
        470: bo_z24,
        467: bo_a25,
        469: bo_b25,
        464: bo_c25,
        466: bo_d25,
        465: bo_e25,
        463: bo_f25,
        289: bo_g25,
        288: bo_h25,
        292: bo_i25,
        461: bo_j25,
        283: bo_k25,
        295: bo_l25,
        293: bo_m25,
        284: bo_n25,
        285: bo_o25,
        316: bo_p25,
        286: bo_q25,
        287: bo_r25,
        290: bo_s25,
        291: bo_t25,
        462: bo_u25,
        294: bo_v25
    },
    39: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        698: bo_g1,
        349: bo_w25,
        950: bo_x25,
        955: bo_y25,
        951: bo_z25,
        952: bo_a26,
        953: bo_b26,
        954: bo_c26
    },
    33: {
        348: bo_d26,
        443: bo_h1,
        608: bo_i1
    },
    24: {
        443: bo_h1,
        608: bo_i1
    },
    9: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_a22,
        673: bo_g3,
        674: bo_e17,
        443: bo_h1,
        608: bo_i1
    },
    21: {
        443: bo_h1,
        608: bo_i1
    },
    29: {
        394: bo_e26,
        395: bo_f26,
        396: bo_g26,
        397: bo_h26,
        398: bo_i26,
        399: bo_j26,
        400: bo_k26,
        401: bo_l26,
        402: bo_m26,
        100: bo_n26,
        101: bo_o26,
        104: bo_p26,
        105: bo_q26,
        106: bo_r26,
        107: bo_s26,
        108: bo_t26,
        109: bo_u26,
        110: bo_v26,
        111: bo_w26,
        112: bo_x26,
        113: bo_y26,
        114: bo_z26,
        115: bo_a27,
        116: bo_b27,
        117: bo_c27,
        118: bo_d27,
        119: bo_e27,
        120: bo_f27,
        121: bo_g27,
        808: bo_h27,
        809: bo_i27,
        810: bo_j27,
        811: bo_k27,
        812: bo_l27,
        813: bo_m27,
        814: bo_n27,
        815: bo_o27,
        816: bo_p27,
        817: bo_q27,
        818: bo_r27,
        819: bo_s27,
        820: bo_t27,
        821: bo_u27,
        822: bo_v27,
        823: bo_w27,
        824: bo_x27,
        825: bo_y27,
        826: bo_z27,
        827: bo_a28,
        828: bo_b28,
        829: bo_c28,
        830: bo_d28,
        831: bo_e28,
        832: bo_f28,
        833: bo_g28,
        834: bo_h28,
        835: bo_i28,
        836: bo_j28,
        837: bo_k28,
        838: bo_l28,
        839: bo_m28,
        840: bo_n28,
        841: bo_o28,
        842: bo_p28,
        843: bo_q28,
        844: bo_r28,
        366: bo_s28,
        367: bo_t28,
        368: bo_u28,
        369: bo_v28,
        370: bo_w28,
        371: bo_x28,
        372: bo_y28,
        373: bo_z28,
        374: bo_a29,
        375: bo_b29,
        376: bo_c29,
        377: bo_d29,
        378: bo_e29,
        379: bo_f29,
        380: bo_g29,
        381: bo_h29,
        382: bo_i29,
        383: bo_j29,
        384: bo_k29,
        385: bo_l29,
        386: bo_m29,
        387: bo_n29,
        388: bo_o29,
        389: bo_p29,
        390: bo_q29,
        391: bo_r29,
        392: bo_s29,
        393: bo_t29,
        481: bo_u29,
        482: bo_v29,
        483: bo_w29,
        484: bo_x29,
        485: bo_y29,
        486: bo_z29,
        487: bo_a30,
        488: bo_b30,
        489: bo_c30,
        490: bo_d30,
        491: bo_e30,
        492: bo_f30,
        493: bo_g30,
        494: bo_h30,
        495: bo_i30,
        496: bo_j30,
        497: bo_k30,
        498: bo_l30,
        499: bo_m30,
        500: bo_n30,
        501: bo_o30,
        502: bo_p30,
        503: bo_q30,
        504: bo_r30,
        505: bo_s30,
        506: bo_t30,
        507: bo_u30,
        508: bo_v30,
        509: bo_w30,
        510: bo_x30,
        511: bo_y30,
        566: bo_z30,
        567: bo_a31,
        568: bo_b31,
        569: bo_c31,
        570: bo_d31,
        571: bo_e31,
        572: bo_f31,
        573: bo_g31,
        574: bo_h31,
        575: bo_i31,
        576: bo_j31,
        577: bo_k31,
        578: bo_l31,
        579: bo_m31,
        580: bo_n31,
        581: bo_o31,
        582: bo_p31,
        583: bo_q31,
        584: bo_r31,
        585: bo_s31,
        586: bo_t31,
        587: bo_u31,
        588: bo_v31,
        589: bo_w31,
        590: bo_x31,
        591: bo_y31,
        592: bo_z31,
        593: bo_a32,
        594: bo_b32,
        595: bo_c32,
        596: bo_d32,
        597: bo_e32,
        598: bo_f32,
        599: bo_g32,
        600: bo_h32,
        601: bo_i32,
        602: bo_j32,
        83: bo_k32,
        84: bo_l32,
        85: bo_m32,
        86: bo_n32,
        87: bo_o32,
        88: bo_p32,
        89: bo_q32,
        90: bo_r32,
        91: bo_s32,
        92: bo_t32,
        93: bo_u32,
        94: bo_v32,
        95: bo_w32,
        96: bo_x32,
        97: bo_y32,
        98: bo_z32,
        99: bo_a33,
        74: bo_b1,
        349: bo_c1,
        254: bo_b33,
        403: bo_g1,
        21: bo_c33,
        22: bo_d33,
        23: bo_e33,
        24: bo_f33,
        25: bo_g33,
        26: bo_h33,
        27: bo_i33,
        28: bo_j33,
        29: bo_k33,
        30: bo_l33,
        31: bo_m33,
        32: bo_n33,
        33: bo_o33,
        34: bo_p33,
        35: bo_q33,
        36: bo_r33,
        37: bo_s33,
        38: bo_t33,
        39: bo_u33,
        40: bo_v33,
        41: bo_w33,
        42: bo_x33,
        43: bo_y33,
        44: bo_z33,
        45: bo_a34,
        46: bo_b34,
        47: bo_c34,
        48: bo_d34,
        49: bo_e34,
        50: bo_f34,
        51: bo_g34,
        52: bo_h34,
        53: bo_i34,
        54: bo_j34,
        55: bo_k34,
        56: bo_l34,
        57: bo_m34,
        195: bo_n34,
        196: bo_o34,
        197: bo_p34,
        198: bo_q34,
        199: bo_r34,
        200: bo_s34,
        201: bo_t34,
        202: bo_u34,
        203: bo_v34,
        204: bo_w34,
        205: bo_x34,
        206: bo_y34,
        207: bo_z34,
        208: bo_a35,
        209: bo_b35,
        210: bo_c35,
        211: bo_d35,
        212: bo_e35,
        213: bo_f35,
        214: bo_g35,
        215: bo_h35,
        216: bo_i35,
        217: bo_j35,
        218: bo_k35,
        219: bo_l35,
        220: bo_m35,
        221: bo_n35,
        222: bo_o35,
        223: bo_p35,
        224: bo_q35,
        225: bo_r35,
        226: bo_s35,
        227: bo_t35,
        228: bo_u35,
        229: bo_v35,
        230: bo_w35,
        231: bo_x35,
        475: bo_y35,
        476: bo_z35,
        477: bo_a36,
        478: bo_b36,
        479: bo_c36,
        480: bo_d36,
        443: bo_h1,
        608: bo_i1
    },
    15: {
        443: bo_h1,
        608: bo_i1
    },
    2: {
        73: bo_b1,
        318: bo_c1,
        21: bo_e36,
        22: bo_f36,
        23: bo_g36,
        24: bo_h36,
        25: bo_i36,
        26: bo_j36,
        27: bo_k36,
        195: bo_n34,
        196: bo_o34,
        197: bo_p34,
        198: bo_q34,
        199: bo_r34,
        200: bo_s34,
        201: bo_t34,
        352: bo_l36,
        102: bo_f1,
        403: bo_g1,
        138: bo_m36,
        139: bo_n36,
        140: bo_o36,
        141: bo_p36,
        142: bo_q36,
        143: bo_r36,
        144: bo_s36,
        182: bo_t36,
        183: bo_u36,
        184: bo_v36,
        185: bo_w36,
        186: bo_x36,
        187: bo_y36,
        188: bo_z36,
        566: bo_a37,
        567: bo_b37,
        568: bo_c37,
        569: bo_d37,
        570: bo_e37,
        571: bo_f37,
        572: bo_g37,
        366: bo_s28,
        367: bo_t28,
        368: bo_u28,
        369: bo_v28,
        370: bo_w28,
        371: bo_x28,
        372: bo_y28,
        122: bo_h37,
        123: bo_i37,
        124: bo_j37,
        125: bo_k37,
        126: bo_l37,
        127: bo_m37,
        128: bo_n37,
        129: bo_o37,
        130: bo_p37,
        131: bo_q37,
        132: bo_r37,
        133: bo_s37,
        134: bo_t37,
        135: bo_u37,
        872: bo_v37,
        873: bo_w37,
        874: bo_x37,
        875: bo_y37,
        876: bo_z37,
        877: bo_a38,
        878: bo_b38,
        616: bo_c38,
        617: bo_d38,
        618: bo_e38,
        619: bo_f38,
        620: bo_g38,
        621: bo_h38,
        622: bo_i38,
        894: bo_j38,
        895: bo_k38,
        896: bo_l38,
        897: bo_m38,
        898: bo_n38,
        899: bo_o38,
        900: bo_p38,
        443: bo_h1,
        608: bo_i1,
        83: bo_q38,
        84: bo_r38,
        85: bo_s38,
        86: bo_t38,
        87: bo_u38,
        88: bo_v38,
        89: bo_w38,
        257: bo_d1,
        307: bo_e1,
        752: bo_x38,
        753: bo_x38
    },
    6: {
        553: bo_y38,
        339: bo_z38,
        547: bo_a39,
        138: bo_m9,
        139: bo_n9,
        140: bo_o9,
        141: bo_b39,
        142: bo_c39,
        182: bo_p9,
        183: bo_q9,
        184: bo_r9,
        185: bo_d39,
        186: bo_e39,
        83: bo_c10,
        84: bo_d10,
        85: bo_e10,
        86: bo_f39,
        87: bo_g39,
        807: bo_h39,
        636: bo_i39,
        334: bo_j39,
        335: bo_k39,
        336: bo_l39,
        337: bo_m39,
        906: bo_n39,
        907: bo_o39,
        908: bo_p39,
        909: bo_q39,
        300: bo_r39,
        301: bo_s39,
        302: bo_t39,
        303: bo_u39,
        304: bo_v39,
        310: bo_w39,
        311: bo_x39,
        312: bo_y39,
        313: bo_z39,
        314: bo_a40,
        554: bo_b40,
        555: bo_c40,
        556: bo_d40,
        557: bo_e40,
        558: bo_f40,
        517: bo_g40,
        518: bo_h40,
        519: bo_i40,
        520: bo_j40,
        521: bo_k40,
        561: bo_l40,
        562: bo_m40,
        563: bo_n40,
        564: bo_o40,
        565: bo_p40,
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_q40,
        25: bo_r40,
        195: bo_h9,
        196: bo_i9,
        197: bo_j9,
        198: bo_s40,
        199: bo_t40,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        903: bo_u40,
        445: bo_v40,
        754: bo_w40,
        755: bo_x40,
        756: bo_y40,
        757: bo_z40,
        758: bo_a41,
        452: bo_b41,
        453: bo_c41,
        454: bo_d41,
        566: bo_e41,
        567: bo_f41,
        568: bo_g41,
        569: bo_h41,
        570: bo_i41,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_j41,
        370: bo_k41,
        522: bo_l41,
        627: bo_m41,
        628: bo_n41,
        629: bo_o41,
        630: bo_p41,
        631: bo_q41,
        632: bo_r41,
        190: bo_s41,
        191: bo_t41,
        192: bo_u41,
        193: bo_v41,
        194: bo_w41,
        759: bo_x41,
        760: bo_y41,
        761: bo_z41,
        762: bo_a42,
        763: bo_b42,
        768: bo_c42,
        769: bo_d42,
        770: bo_e42,
        771: bo_f42,
        772: bo_g42,
        603: bo_h42,
        604: bo_i42,
        605: bo_j42,
        606: bo_k42,
        607: bo_l42,
        257: bo_d1,
        307: bo_e1,
        696: bo_g1,
        333: bo_m42,
        341: bo_n42,
        427: bo_o42,
        536: bo_p42,
        905: bo_q42,
        320: bo_r42,
        514: bo_s42,
        516: bo_t42,
        305: bo_u42,
        315: bo_v42,
        523: bo_w42,
        299: bo_x42,
        309: bo_y42,
        697: bo_z42,
        298: bo_a43,
        308: bo_b43,
        515: bo_c43,
        549: bo_d43,
        548: bo_e43,
        443: bo_h1,
        608: bo_i1,
        550: bo_v40,
        551: bo_v40,
        455: bo_b41,
        456: bo_b41,
        457: bo_c41,
        458: bo_c41,
        459: bo_d41,
        460: bo_d41,
        512: bo_l41,
        513: bo_l41,
        901: bo_f43,
        902: bo_f43,
        340: bo_g43,
        328: bo_h43,
        329: bo_i43,
        342: bo_j43,
        330: bo_k43,
        331: bo_l43,
        722: bo_m43,
        560: bo_n43,
        543: bo_o43,
        544: bo_p43,
        545: bo_q43,
        546: bo_r43,
        332: bo_s43,
        559: bo_t43,
        296: bo_u43,
        297: bo_v43,
        717: bo_w43,
        718: bo_x43,
        719: bo_y43,
        720: bo_z43,
        721: bo_a44,
        552: bo_b44,
        76: bo_c44,
        77: bo_d44,
        78: bo_e44,
        79: bo_f44,
        80: bo_g44,
        647: bo_h44,
        741: bo_i44,
        82: bo_j44,
        338: bo_k44
    },
    17: {
        348: bo_d26,
        443: bo_h1,
        608: bo_i1
    },
    4: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_q40,
        25: bo_r40,
        195: bo_h9,
        196: bo_i9,
        197: bo_j9,
        198: bo_s40,
        199: bo_t40,
        352: bo_p1,
        764: bo_q3,
        102: bo_f1,
        403: bo_g1,
        138: bo_m9,
        139: bo_n9,
        140: bo_o9,
        141: bo_b39,
        142: bo_c39,
        182: bo_p9,
        183: bo_q9,
        184: bo_r9,
        185: bo_d39,
        186: bo_e39,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_j41,
        370: bo_k41,
        566: bo_l44,
        567: bo_m44,
        568: bo_n44,
        569: bo_o44,
        570: bo_p44,
        74: bo_q44,
        923: bo_r44,
        924: bo_s44,
        925: bo_t44,
        926: bo_u44,
        927: bo_v44,
        929: bo_t9,
        930: bo_u9,
        931: bo_v9,
        932: bo_w44,
        933: bo_x44,
        845: bo_w9,
        846: bo_x9,
        847: bo_y9,
        848: bo_y44,
        849: bo_z44,
        918: bo_z9,
        919: bo_a10,
        920: bo_b10,
        921: bo_a45,
        922: bo_b45,
        83: bo_c10,
        84: bo_d10,
        85: bo_e10,
        86: bo_f39,
        87: bo_g39,
        905: bo_q42,
        906: bo_n39,
        907: bo_o39,
        908: bo_p39,
        909: bo_q39,
        807: bo_h39,
        319: bo_c45,
        320: bo_d45,
        912: bo_y10,
        913: bo_z10,
        914: bo_a11,
        915: bo_e45,
        916: bo_f45,
        443: bo_h1,
        608: bo_i1,
        257: bo_d1,
        307: bo_e1,
        362: bo_i10,
        363: bo_j10,
        364: bo_g45,
        365: bo_h45,
        17: bo_k10,
        18: bo_l10,
        19: bo_i45,
        20: bo_j45,
        176: bo_m10,
        177: bo_n10,
        178: bo_k45,
        179: bo_l45,
        358: bo_o10,
        359: bo_p10,
        360: bo_m45,
        361: bo_n45,
        13: bo_q10,
        14: bo_r10,
        15: bo_o45,
        16: bo_p45,
        172: bo_s10,
        173: bo_t10,
        174: bo_q45,
        175: bo_r45,
        281: bo_a6,
        137: bo_a6,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        619: bo_s45,
        620: bo_t45,
        891: bo_x10,
        26: bo_u45,
        200: bo_v45,
        143: bo_w45,
        187: bo_x45,
        371: bo_y45,
        571: bo_z45,
        928: bo_v45,
        934: bo_v45,
        88: bo_a46,
        910: bo_b46,
        917: bo_c46,
        936: bo_d46
    },
    8: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_e46,
        196: bo_f46,
        197: bo_g46,
        198: bo_h46,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    27: {
        443: bo_h1,
        608: bo_i1
    },
    28: {
        403: bo_g1,
        615: bo_i46,
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        935: bo_q3,
        612: bo_j46,
        613: bo_k46,
        443: bo_h1,
        608: bo_i1
    }
};

let outcomeConfig = {
    7: {
        426: (match, outcome) => `Aniq ${outcome.condition} ${plural(outcome.condition, ['gol', 'gol', 'gol'])} bilan`,
        535: (match, outcome) => `Aniq ${outcome.condition} ${plural(outcome.condition, ['gol', 'gol', 'gol'])} bilan`
    },
    6: {
        455: (match, outcome) => '15x15',
        456: (match, outcome) => '15x15',
        457: (match, outcome) => '30x30',
        458: (match, outcome) => '30x30',
        459: (match, outcome) => '40x40',
        460: (match, outcome) => '40x40'
    }
};

let baseFactorNameConfig = {
    11: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    32: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        616: {
            1: fa_x1,
            2: fa_y1
        },
        617: {
            1: fa_x1,
            2: fa_y1
        },
        618: {
            1: fa_x1,
            2: fa_y1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_h1,
            2: fa_i1
        },
        363: {
            1: fa_h1,
            2: fa_i1
        },
        364: {
            1: fa_h1,
            2: fa_i1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_h1,
            2: fa_i1
        },
        359: {
            1: fa_h1,
            2: fa_i1
        },
        360: {
            1: fa_h1,
            2: fa_i1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        }
    },
    35: {
        138: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        731: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        742: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        }
    },
    10: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    31: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        675: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        676: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        238: {
            1: fa_d1,
            2: fa_e1
        },
        682: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        239: {
            1: fa_d1,
            2: fa_e1
        },
        58: {
            1: fa_b1,
            2: fa_c1
        },
        59: {
            1: fa_b1,
            2: fa_c1
        },
        681: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        234: {
            1: fa_d1,
            2: fa_e1
        },
        235: {
            1: fa_d1,
            2: fa_e1
        },
        236: {
            1: fa_d1,
            2: fa_e1
        },
        237: {
            1: fa_d1,
            2: fa_e1
        },
        725: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        726: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        727: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        728: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        782: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        778: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        779: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        780: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        781: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        783: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_i1
        },
        773: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_i1
        },
        474: {
            1: fa_d4,
            2: fa_e4
        },
        421: {
            1: fa_l1,
            2: fa_m1
        },
        530: {
            1: fa_l1,
            2: fa_m1
        },
        422: {
            1: fa_l1,
            2: fa_m1
        },
        531: {
            1: fa_l1,
            2: fa_m1
        },
        444: {
            1: fa_f4,
            2: fa_g4
        },
        888: {
            1: fa_h4,
            2: fa_i4,
            3: fa_j4,
            4: fa_k4
        },
        280: {
            1: fa_d1,
            2: fa_e1
        },
        317: {
            1: fa_d1,
            2: fa_e1
        },
        424: {
            1: fa_l1,
            2: fa_m1
        },
        533: {
            1: fa_l1,
            2: fa_m1
        },
        423: {
            1: fa_l1,
            2: fa_m1
        },
        532: {
            1: fa_l1,
            2: fa_m1
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        788: {
            1: fa_l4,
            2: fa_m4,
            3: fa_n4,
            4: fa_o4,
            5: fa_p4,
            6: fa_q4,
            7: fa_r4,
            8: fa_s4,
            9: fa_t4,
            10: fa_u4,
            11: fa_v4,
            12: fa_w4,
            13: fa_x4,
            14: fa_y4
        },
        784: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        785: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        786: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        787: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        774: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        775: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        776: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        777: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        246: {
            1: fa_d1,
            2: fa_e1
        },
        248: {
            1: fa_d1,
            2: fa_e1
        },
        240: {
            1: fa_d1,
            2: fa_e1
        },
        232: {
            1: fa_d1,
            2: fa_e1
        },
        241: {
            1: fa_d1,
            2: fa_e1
        },
        233: {
            1: fa_d1,
            2: fa_e1
        },
        61: {
            1: fa_b1,
            2: fa_c1
        },
        62: {
            1: fa_b1,
            2: fa_c1
        },
        684: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        685: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        890: {
            1: fa_h4,
            2: fa_i4,
            3: fa_j4,
            4: fa_k4
        },
        242: {
            1: fa_d1,
            2: fa_e1
        },
        245: {
            1: fa_d1,
            2: fa_e1
        },
        243: {
            1: fa_d1,
            2: fa_e1
        },
        60: {
            1: fa_b1,
            2: fa_c1
        },
        683: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        406: {
            1: fa_x1,
            2: fa_y1
        },
        405: {
            1: fa_x1,
            2: fa_y1
        },
        404: {
            1: fa_x1,
            2: fa_y1
        },
        700: {
            1: fa_h5,
            2: fa_i5,
            3: fa_j5
        },
        408: {
            1: fa_x1,
            2: fa_y1
        },
        407: {
            1: fa_x1,
            2: fa_y1
        },
        247: {
            1: fa_d1,
            2: fa_e1
        },
        244: {
            1: fa_d1,
            2: fa_e1
        },
        638: {
            1: fa_x1,
            2: fa_y1
        },
        639: {
            1: fa_x1,
            2: fa_y1
        },
        640: {
            1: fa_x1,
            2: fa_y1
        },
        641: {
            1: fa_x1,
            2: fa_y1
        },
        646: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        642: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        643: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        644: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        645: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        }
    },
    41: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        791: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        792: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        796: {
            1: fa_l4,
            2: fa_m4,
            3: fa_n4,
            4: fa_o4,
            5: fa_p4,
            6: fa_q4,
            7: fa_n5,
            8: fa_s4,
            9: fa_t4,
            10: fa_u4,
            11: fa_v4,
            12: fa_w4,
            13: fa_x4,
            14: fa_o5
        },
        794: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_c5
        },
        795: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_c5
        },
        789: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_g5
        },
        790: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_g5
        },
        725: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        726: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        793: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        411: {
            1: fa_x1,
            2: fa_y1
        },
        701: {
            1: fa_f4,
            2: fa_g4,
            3: fa_r5
        },
        251: {
            1: fa_d1,
            2: fa_e1
        },
        252: {
            1: fa_d1,
            2: fa_e1
        },
        409: {
            1: fa_l1,
            2: fa_m1
        },
        430: {
            1: fa_l1,
            2: fa_m1
        },
        410: {
            1: fa_l1,
            2: fa_m1
        },
        431: {
            1: fa_l1,
            2: fa_m1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        249: {
            1: fa_d1,
            2: fa_e1
        },
        250: {
            1: fa_d1,
            2: fa_e1
        },
        63: {
            1: fa_b1,
            2: fa_c1
        },
        64: {
            1: fa_b1,
            2: fa_c1
        },
        686: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        687: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        648: {
            1: fa_x1,
            2: fa_y1
        },
        649: {
            1: fa_x1,
            2: fa_y1
        }
    },
    18: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        675: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        610: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        806: {
            1: fa_s5,
            2: fa_t5,
            3: fa_u5,
            4: fa_v5,
            5: fa_w5,
            6: fa_c5
        },
        893: {
            1: fa_x5,
            2: fa_y5,
            3: fa_z5,
            4: fa_a6,
            5: fa_b6,
            6: fa_c5
        },
        707: {
            1: fa_c6,
            2: fa_d6,
            3: fa_e6
        },
        708: {
            1: fa_c6,
            2: fa_d6,
            3: fa_e6
        },
        709: {
            1: fa_c6,
            2: fa_d6,
            3: fa_e6
        },
        889: {
            1: fa_f6,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_g6,
            6: fa_h6,
            7: fa_i6,
            8: fa_j6
        },
        904: {
            1: fa_k6,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6,
            9: fa_s6
        },
        253: {
            1: fa_d1,
            2: fa_e1
        },
        688: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        65: {
            1: fa_b1,
            2: fa_c1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        }
    },
    3: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        746: {
            1: fa_r1,
            2: fa_s1,
            3: fa_p1,
            4: fa_n1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        854: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        855: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        856: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        857: {
            1: fa_s3,
            2: fa_a7,
            3: fa_b7,
            4: fa_c7,
            5: fa_z6
        },
        858: {
            1: fa_s3,
            2: fa_a7,
            3: fa_b7,
            4: fa_c7,
            5: fa_z6
        },
        859: {
            1: fa_s3,
            2: fa_a7,
            3: fa_b7,
            4: fa_c7,
            5: fa_z6
        },
        797: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_i1
        },
        798: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_i1
        },
        799: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_i1
        },
        851: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_h1
        },
        852: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_h1
        },
        853: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_h1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        906: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        907: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_h1,
            2: fa_i1
        },
        363: {
            1: fa_h1,
            2: fa_i1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_h1,
            2: fa_i1
        },
        359: {
            1: fa_h1,
            2: fa_i1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_x1,
            2: fa_y1
        },
        617: {
            1: fa_x1,
            2: fa_y1
        },
        618: {
            1: fa_x1,
            2: fa_y1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        800: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        801: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        802: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        }
    },
    20: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        145: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        189: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        675: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        676: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        677: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        678: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        679: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        680: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        860: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        861: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        862: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        863: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        864: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        865: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        866: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        867: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    5: {
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        945: {
            1: fa_l1,
            2: fa_m1
        },
        948: {
            1: fa_r7,
            2: fa_s7,
            3: fa_t7,
            4: fa_u7,
            5: fa_v7
        },
        949: {
            1: fa_w7,
            2: fa_x7,
            3: fa_y7,
            4: fa_z7,
            5: fa_a8,
            6: fa_b8,
            7: fa_c8,
            8: fa_d8,
            9: fa_e8,
            10: fa_f8,
            11: fa_g8,
            12: fa_h8,
            13: fa_s7,
            14: fa_t7,
            15: fa_i8,
            16: fa_j8,
            17: fa_k8,
            18: fa_l8,
            19: fa_m8,
            20: fa_n8,
            21: fa_o8,
            22: fa_p8,
            23: fa_q8,
            24: fa_r8,
            25: fa_s8,
            26: fa_t8,
            27: fa_v7
        }
    },
    40: {
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    37: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    38: {
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        413: {
            1: fa_x1,
            2: fa_y1
        },
        414: {
            1: fa_x1,
            2: fa_y1
        }
    },
    42: {
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        413: {
            1: fa_x1,
            2: fa_y1
        },
        414: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        569: {
            1: fa_x1,
            2: fa_y1
        },
        570: {
            1: fa_x1,
            2: fa_y1
        },
        698: {
            1: fa_h1,
            2: fa_u8,
            3: fa_i1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        940: {
            1: fa_h1,
            2: fa_i1
        },
        941: {
            1: fa_h1,
            2: fa_i1
        },
        942: {
            1: fa_h1,
            2: fa_i1
        },
        943: {
            1: fa_h1,
            2: fa_i1
        },
        944: {
            1: fa_h1,
            2: fa_i1
        }
    },
    26: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    25: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    16: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    12: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    36: {
        610: {
            1: fa_h1,
            2: fa_i1
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        21: {
            1: fa_b1,
            2: fa_v8
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    7: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        805: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        892: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_x8,
            2: fa_y8,
            3: fa_z8
        },
        708: {
            1: fa_x8,
            2: fa_y8,
            3: fa_z8
        },
        706: {
            1: fa_a9,
            2: fa_b9,
            3: fa_c9
        },
        804: {
            1: fa_d9,
            2: fa_e9,
            3: fa_f9,
            4: fa_g9
        },
        474: {
            1: fa_d4,
            2: fa_e4
        },
        614: {
            1: fa_x1,
            2: fa_y1
        },
        609: {
            1: fa_l1,
            2: fa_m1
        },
        416: {
            1: fa_l1,
            2: fa_m1
        },
        732: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        525: {
            1: fa_l1,
            2: fa_m1
        },
        850: {
            1: fa_h9,
            2: fa_i9,
            3: fa_j9,
            4: fa_k9
        },
        473: {
            1: fa_l9,
            2: fa_m9
        },
        442: {
            1: fa_l9,
            2: fa_m9
        },
        729: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        542: {
            1: fa_l1,
            2: fa_m1
        },
        730: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        471: {
            1: fa_l9,
            2: fa_m9
        },
        635: {
            1: fa_l1,
            2: fa_m1
        },
        714: {
            1: fa_n9,
            2: fa_a2,
            3: fa_o9
        },
        624: {
            1: fa_x1,
            2: fa_y1
        },
        625: {
            1: fa_x1,
            2: fa_y1
        },
        715: {
            1: fa_p9,
            2: fa_q9,
            3: fa_r9
        },
        650: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        651: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        652: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        653: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        654: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        655: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        733: {
            1: fa_p9,
            2: fa_q9,
            3: fa_s9
        },
        734: {
            1: fa_p9,
            2: fa_q9,
            3: fa_s9
        },
        258: {
            1: fa_d1,
            2: fa_e1
        },
        259: {
            1: fa_d1,
            2: fa_e1
        },
        66: {
            1: fa_b1,
            2: fa_c1
        },
        67: {
            1: fa_b1,
            2: fa_c1
        },
        81: {
            1: fa_b1,
            2: fa_c1
        },
        68: {
            1: fa_b1,
            2: fa_c1
        },
        689: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        690: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        699: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        691: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        723: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        633: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_k6,
            2: fa_t9,
            3: fa_m6,
            4: fa_u9,
            5: fa_v9,
            6: fa_w9,
            7: fa_q6,
            8: fa_x9,
            9: fa_s6
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_y9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_z9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_a10,
            30: fa_b10,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_c10,
            2: fa_d10,
            3: fa_t7
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_n9,
            2: fa_a2,
            3: fa_o9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_e10,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_f10,
            2: fa_g10
        },
        526: {
            1: fa_f10,
            2: fa_g10
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        710: {
            1: fa_i10,
            2: fa_r2,
            3: fa_j10
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_k10,
            2: fa_l10,
            3: fa_m10
        },
        661: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        664: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        666: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        667: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        669: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        672: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        437: {
            1: fa_l1,
            2: fa_m1
        },
        436: {
            1: fa_l1,
            2: fa_m1
        },
        694: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        71: {
            1: fa_b1,
            2: fa_c1
        },
        271: {
            1: fa_d1,
            2: fa_e1
        },
        268: {
            1: fa_d1,
            2: fa_e1
        },
        265: {
            1: fa_d1,
            2: fa_e1
        },
        267: {
            1: fa_d1,
            2: fa_e1
        },
        270: {
            1: fa_d1,
            2: fa_e1
        },
        272: {
            1: fa_d1,
            2: fa_e1
        },
        269: {
            1: fa_d1,
            2: fa_e1
        },
        266: {
            1: fa_d1,
            2: fa_e1
        },
        264: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        660: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        880: {
            1: fa_n10,
            2: fa_o10,
            3: fa_p10,
            4: fa_q10
        },
        879: {
            1: fa_r10,
            2: fa_s10,
            3: fa_t10,
            4: fa_u10
        },
        429: {
            1: fa_l1,
            2: fa_m1
        },
        433: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        881: {
            1: fa_v10,
            2: fa_w10,
            3: fa_x10,
            4: fa_y10,
            5: fa_z10,
            6: fa_a11
        },
        273: {
            1: fa_d1,
            2: fa_e1
        },
        274: {
            1: fa_d1,
            2: fa_e1
        },
        435: {
            1: fa_l1,
            2: fa_m1
        },
        704: {
            1: fa_b11,
            2: fa_c11,
            3: fa_d11
        },
        432: {
            1: fa_l1,
            2: fa_m1
        },
        428: {
            1: fa_l1,
            2: fa_m1
        },
        434: {
            1: fa_l1,
            2: fa_m1
        },
        439: {
            1: fa_l1,
            2: fa_m1
        },
        440: {
            1: fa_l1,
            2: fa_m1
        },
        441: {
            1: fa_l1,
            2: fa_m1
        },
        438: {
            1: fa_l1,
            2: fa_m1
        },
        623: {
            1: fa_x1,
            2: fa_y1
        },
        180: {
            1: fa_d1,
            2: fa_e1
        },
        146: {
            1: fa_d1,
            2: fa_e1
        },
        659: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        749: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        69: {
            1: fa_b1,
            2: fa_c1
        },
        262: {
            1: fa_d1,
            2: fa_e1
        },
        692: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        703: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        70: {
            1: fa_b1,
            2: fa_c1
        },
        263: {
            1: fa_d1,
            2: fa_e1
        },
        693: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        72: {
            1: fa_b1,
            2: fa_c1
        },
        277: {
            1: fa_d1,
            2: fa_e1
        },
        695: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        750: {
            1: fa_x2,
            2: fa_r1,
            3: fa_u1,
            4: fa_s1,
            5: fa_v1,
            6: fa_w1,
            7: fa_j3,
            8: fa_k3,
            9: fa_l3,
            10: fa_q3,
            11: fa_e11,
            12: fa_f11,
            13: fa_u2,
            14: fa_n1,
            15: fa_o1,
            16: fa_p1,
            17: fa_q1,
            18: fa_t1,
            19: fa_z2,
            20: fa_c3,
            21: fa_g3,
            22: fa_h3,
            23: fa_g11,
            24: fa_h11
        },
        181: {
            1: fa_d1,
            2: fa_e1
        },
        147: {
            1: fa_d1,
            2: fa_e1
        },
        276: {
            1: fa_d1,
            2: fa_e1
        },
        275: {
            1: fa_d1,
            2: fa_e1
        },
        735: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        736: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        737: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        738: {
            1: fa_x1,
            2: fa_i11,
            3: fa_y1
        },
        739: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        740: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        356: {
            1: fa_d1,
            2: fa_e1
        },
        357: {
            1: fa_d1,
            2: fa_e1
        },
        354: {
            1: fa_d1,
            2: fa_e1
        },
        355: {
            1: fa_d1,
            2: fa_e1
        },
        937: {
            1: fa_j11,
            2: fa_k11,
            3: fa_l11,
            4: fa_m11,
            5: fa_n11,
            6: fa_o11,
            7: fa_p11,
            8: fa_q11,
            9: fa_r11,
            10: fa_s11
        },
        657: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        658: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        412: {
            1: fa_l1,
            2: fa_m1
        }
    },
    14: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    34: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_x8,
            2: fa_y8,
            3: fa_z8
        },
        708: {
            1: fa_x8,
            2: fa_y8,
            3: fa_z8
        },
        706: {
            1: fa_a9,
            2: fa_b9,
            3: fa_c9
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_k6,
            2: fa_t9,
            3: fa_m6,
            4: fa_u9,
            5: fa_v9,
            6: fa_w9,
            7: fa_q6,
            8: fa_x9,
            9: fa_s6
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_y9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_z9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_a10,
            30: fa_b10,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_c10,
            2: fa_d10,
            3: fa_t7
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_n9,
            2: fa_a2,
            3: fa_o9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_e10,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_f10,
            2: fa_g10
        },
        526: {
            1: fa_f10,
            2: fa_g10
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        710: {
            1: fa_i10,
            2: fa_r2,
            3: fa_j10
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_k10,
            2: fa_l10,
            3: fa_m10
        },
        661: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        664: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        666: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        667: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        669: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        672: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    19: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        886: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        887: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        884: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_t11,
            5: fa_c5
        },
        885: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_t11,
            5: fa_c5
        },
        882: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_t11,
            5: fa_c5
        },
        883: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_t11,
            5: fa_c5
        },
        723: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    30: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        21: {
            1: fa_b1,
            2: fa_v8
        },
        22: {
            1: fa_b1,
            2: fa_v8
        },
        23: {
            1: fa_b1,
            2: fa_v8
        },
        279: {
            1: fa_d1,
            2: fa_e1
        },
        610: {
            1: fa_h1,
            2: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        675: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        710: {
            1: fa_u11,
            2: fa_v11,
            3: fa_w11
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        706: {
            1: fa_x11,
            2: fa_y11,
            3: fa_z11
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        344: {
            1: fa_d1,
            2: fa_e1
        },
        347: {
            1: fa_d1,
            2: fa_e1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        767: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_h10
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        889: {
            1: fa_f6,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_g6,
            6: fa_h6,
            7: fa_i6,
            8: fa_j6
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        412: {
            1: fa_l1,
            2: fa_m1
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        611: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        904: {
            1: fa_k6,
            2: fa_t9,
            3: fa_m6,
            4: fa_u9,
            5: fa_v9,
            6: fa_w9,
            7: fa_q6,
            8: fa_x9,
            9: fa_s6
        },
        449: {
            1: fa_l1,
            2: fa_m1
        },
        446: {
            1: fa_l1,
            2: fa_m1
        },
        451: {
            1: fa_l1,
            2: fa_m1
        },
        711: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12
        },
        712: {
            1: fa_d12,
            2: fa_e12,
            3: fa_f12
        },
        713: {
            1: fa_g12,
            2: fa_h12,
            3: fa_i12
        },
        450: {
            1: fa_l1,
            2: fa_m1
        },
        447: {
            1: fa_l1,
            2: fa_m1
        },
        448: {
            1: fa_l1,
            2: fa_m1
        },
        662: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        663: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        665: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        668: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        670: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        671: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        3: {
            1: fa_b1,
            2: fa_c1
        },
        4: {
            1: fa_b1,
            2: fa_c1
        },
        6: {
            1: fa_b1,
            2: fa_c1
        },
        8: {
            1: fa_b1,
            2: fa_c1
        },
        10: {
            1: fa_b1,
            2: fa_c1
        },
        11: {
            1: fa_b1,
            2: fa_c1
        },
        161: {
            1: fa_d1,
            2: fa_e1
        },
        162: {
            1: fa_d1,
            2: fa_e1
        },
        164: {
            1: fa_d1,
            2: fa_e1
        },
        167: {
            1: fa_d1,
            2: fa_e1
        },
        169: {
            1: fa_d1,
            2: fa_e1
        },
        170: {
            1: fa_d1,
            2: fa_e1
        },
        707: {
            1: fa_c6,
            2: fa_d6,
            3: fa_j12
        },
        708: {
            1: fa_c6,
            2: fa_d6,
            3: fa_j12
        },
        709: {
            1: fa_c6,
            2: fa_d6,
            3: fa_j12
        },
        946: {
            1: fa_l1,
            2: fa_m1
        },
        947: {
            1: fa_l1,
            2: fa_m1
        }
    },
    23: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    13: {
        468: {
            1: fa_f1,
            2: fa_g1
        },
        470: {
            1: fa_f1,
            2: fa_g1
        },
        467: {
            1: fa_f1,
            2: fa_g1
        },
        469: {
            1: fa_f1,
            2: fa_g1
        },
        464: {
            1: fa_k12,
            2: fa_l12
        },
        466: {
            1: fa_l1,
            2: fa_m1
        },
        465: {
            1: fa_l1,
            2: fa_m1
        },
        463: {
            1: fa_l1,
            2: fa_m1
        },
        289: {
            1: fa_d1,
            2: fa_e1
        },
        288: {
            1: fa_d1,
            2: fa_e1
        },
        292: {
            1: fa_d1,
            2: fa_e1
        },
        461: {
            1: fa_l1,
            2: fa_m1
        },
        283: {
            1: fa_d1,
            2: fa_e1
        },
        295: {
            1: fa_d1,
            2: fa_e1
        },
        293: {
            1: fa_d1,
            2: fa_e1
        },
        284: {
            1: fa_d1,
            2: fa_e1
        },
        285: {
            1: fa_d1,
            2: fa_e1
        },
        316: {
            1: fa_d1,
            2: fa_e1
        },
        286: {
            1: fa_d1,
            2: fa_e1
        },
        287: {
            1: fa_d1,
            2: fa_e1
        },
        290: {
            1: fa_d1,
            2: fa_e1
        },
        291: {
            1: fa_d1,
            2: fa_e1
        },
        462: {
            1: fa_l1,
            2: fa_m1
        },
        294: {
            1: fa_d1,
            2: fa_e1
        }
    },
    39: {
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        698: {
            1: fa_m12,
            2: fa_z1,
            3: fa_n12
        },
        349: {
            1: fa_o12,
            2: fa_p12
        },
        950: {
            1: fa_q12,
            2: fa_r12,
            3: fa_s12,
            4: fa_t12,
            5: fa_u12,
            6: fa_v12,
            7: fa_w12,
            8: fa_x12,
            9: fa_y12,
            10: fa_z12,
            11: fa_a13,
            12: fa_b13,
            13: fa_c13
        },
        955: {
            1: fa_d13,
            2: fa_e13
        },
        951: {
            1: fa_f13,
            2: fa_g13
        },
        952: {
            1: fa_f13,
            2: fa_g13
        },
        953: {
            1: fa_f13,
            2: fa_g13
        },
        954: {
            1: fa_f13,
            2: fa_g13
        }
    },
    33: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    24: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    9: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    21: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    29: {
        394: {
            1: fa_h1,
            2: fa_i1
        },
        395: {
            1: fa_h1,
            2: fa_i1
        },
        396: {
            1: fa_h1,
            2: fa_i1
        },
        397: {
            1: fa_h1,
            2: fa_i1
        },
        398: {
            1: fa_h1,
            2: fa_i1
        },
        399: {
            1: fa_h1,
            2: fa_i1
        },
        400: {
            1: fa_h1,
            2: fa_i1
        },
        401: {
            1: fa_h1,
            2: fa_i1
        },
        402: {
            1: fa_h1,
            2: fa_i1
        },
        100: {
            1: fa_f1,
            2: fa_g1
        },
        101: {
            1: fa_f1,
            2: fa_g1
        },
        104: {
            1: fa_f1,
            2: fa_g1
        },
        105: {
            1: fa_f1,
            2: fa_g1
        },
        106: {
            1: fa_f1,
            2: fa_g1
        },
        107: {
            1: fa_f1,
            2: fa_g1
        },
        108: {
            1: fa_f1,
            2: fa_g1
        },
        109: {
            1: fa_f1,
            2: fa_g1
        },
        110: {
            1: fa_f1,
            2: fa_g1
        },
        111: {
            1: fa_f1,
            2: fa_g1
        },
        112: {
            1: fa_f1,
            2: fa_g1
        },
        113: {
            1: fa_f1,
            2: fa_g1
        },
        114: {
            1: fa_f1,
            2: fa_g1
        },
        115: {
            1: fa_f1,
            2: fa_g1
        },
        116: {
            1: fa_f1,
            2: fa_g1
        },
        117: {
            1: fa_f1,
            2: fa_g1
        },
        118: {
            1: fa_f1,
            2: fa_g1
        },
        119: {
            1: fa_f1,
            2: fa_g1
        },
        120: {
            1: fa_f1,
            2: fa_g1
        },
        121: {
            1: fa_f1,
            2: fa_g1
        },
        808: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        809: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        810: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        811: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        812: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        813: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        814: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        815: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        816: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        817: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        818: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        819: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        820: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        821: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        822: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        823: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        824: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        825: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        826: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        827: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        828: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        829: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        830: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        831: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        832: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        833: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        834: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        835: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        836: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        837: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        838: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        839: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        840: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        841: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        842: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        843: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        844: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        371: {
            1: fa_h1,
            2: fa_i1
        },
        372: {
            1: fa_h1,
            2: fa_i1
        },
        373: {
            1: fa_h1,
            2: fa_i1
        },
        374: {
            1: fa_h1,
            2: fa_i1
        },
        375: {
            1: fa_h1,
            2: fa_i1
        },
        376: {
            1: fa_h1,
            2: fa_i1
        },
        377: {
            1: fa_h1,
            2: fa_i1
        },
        378: {
            1: fa_h1,
            2: fa_i1
        },
        379: {
            1: fa_h1,
            2: fa_i1
        },
        380: {
            1: fa_h1,
            2: fa_i1
        },
        381: {
            1: fa_h1,
            2: fa_i1
        },
        382: {
            1: fa_h1,
            2: fa_i1
        },
        383: {
            1: fa_h1,
            2: fa_i1
        },
        384: {
            1: fa_h1,
            2: fa_i1
        },
        385: {
            1: fa_h1,
            2: fa_i1
        },
        386: {
            1: fa_h1,
            2: fa_i1
        },
        387: {
            1: fa_h1,
            2: fa_i1
        },
        388: {
            1: fa_h1,
            2: fa_i1
        },
        389: {
            1: fa_h1,
            2: fa_i1
        },
        390: {
            1: fa_h1,
            2: fa_i1
        },
        391: {
            1: fa_h1,
            2: fa_i1
        },
        392: {
            1: fa_h1,
            2: fa_i1
        },
        393: {
            1: fa_h1,
            2: fa_i1
        },
        481: {
            1: fa_x1,
            2: fa_y1
        },
        482: {
            1: fa_x1,
            2: fa_y1
        },
        483: {
            1: fa_x1,
            2: fa_y1
        },
        484: {
            1: fa_x1,
            2: fa_y1
        },
        485: {
            1: fa_x1,
            2: fa_y1
        },
        486: {
            1: fa_x1,
            2: fa_y1
        },
        487: {
            1: fa_x1,
            2: fa_y1
        },
        488: {
            1: fa_x1,
            2: fa_y1
        },
        489: {
            1: fa_x1,
            2: fa_y1
        },
        490: {
            1: fa_x1,
            2: fa_y1
        },
        491: {
            1: fa_x1,
            2: fa_y1
        },
        492: {
            1: fa_x1,
            2: fa_y1
        },
        493: {
            1: fa_x1,
            2: fa_y1
        },
        494: {
            1: fa_x1,
            2: fa_y1
        },
        495: {
            1: fa_x1,
            2: fa_y1
        },
        496: {
            1: fa_x1,
            2: fa_y1
        },
        497: {
            1: fa_x1,
            2: fa_y1
        },
        498: {
            1: fa_x1,
            2: fa_y1
        },
        499: {
            1: fa_x1,
            2: fa_y1
        },
        500: {
            1: fa_x1,
            2: fa_y1
        },
        501: {
            1: fa_x1,
            2: fa_y1
        },
        502: {
            1: fa_x1,
            2: fa_y1
        },
        503: {
            1: fa_x1,
            2: fa_y1
        },
        504: {
            1: fa_x1,
            2: fa_y1
        },
        505: {
            1: fa_x1,
            2: fa_y1
        },
        506: {
            1: fa_x1,
            2: fa_y1
        },
        507: {
            1: fa_x1,
            2: fa_y1
        },
        508: {
            1: fa_x1,
            2: fa_y1
        },
        509: {
            1: fa_x1,
            2: fa_y1
        },
        510: {
            1: fa_x1,
            2: fa_y1
        },
        511: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        569: {
            1: fa_x1,
            2: fa_y1
        },
        570: {
            1: fa_x1,
            2: fa_y1
        },
        571: {
            1: fa_x1,
            2: fa_y1
        },
        572: {
            1: fa_x1,
            2: fa_y1
        },
        573: {
            1: fa_x1,
            2: fa_y1
        },
        574: {
            1: fa_x1,
            2: fa_y1
        },
        575: {
            1: fa_x1,
            2: fa_y1
        },
        576: {
            1: fa_x1,
            2: fa_y1
        },
        577: {
            1: fa_x1,
            2: fa_y1
        },
        578: {
            1: fa_x1,
            2: fa_y1
        },
        579: {
            1: fa_x1,
            2: fa_y1
        },
        580: {
            1: fa_x1,
            2: fa_y1
        },
        581: {
            1: fa_x1,
            2: fa_y1
        },
        582: {
            1: fa_x1,
            2: fa_y1
        },
        583: {
            1: fa_x1,
            2: fa_y1
        },
        584: {
            1: fa_x1,
            2: fa_y1
        },
        585: {
            1: fa_x1,
            2: fa_y1
        },
        586: {
            1: fa_x1,
            2: fa_y1
        },
        587: {
            1: fa_x1,
            2: fa_y1
        },
        588: {
            1: fa_x1,
            2: fa_y1
        },
        589: {
            1: fa_x1,
            2: fa_y1
        },
        590: {
            1: fa_x1,
            2: fa_y1
        },
        591: {
            1: fa_x1,
            2: fa_y1
        },
        592: {
            1: fa_x1,
            2: fa_y1
        },
        593: {
            1: fa_x1,
            2: fa_y1
        },
        594: {
            1: fa_x1,
            2: fa_y1
        },
        595: {
            1: fa_x1,
            2: fa_y1
        },
        596: {
            1: fa_x1,
            2: fa_y1
        },
        597: {
            1: fa_x1,
            2: fa_y1
        },
        598: {
            1: fa_x1,
            2: fa_y1
        },
        599: {
            1: fa_x1,
            2: fa_y1
        },
        600: {
            1: fa_x1,
            2: fa_y1
        },
        601: {
            1: fa_x1,
            2: fa_y1
        },
        602: {
            1: fa_x1,
            2: fa_y1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        90: {
            1: fa_f1,
            2: fa_g1
        },
        91: {
            1: fa_f1,
            2: fa_g1
        },
        92: {
            1: fa_f1,
            2: fa_g1
        },
        93: {
            1: fa_f1,
            2: fa_g1
        },
        94: {
            1: fa_f1,
            2: fa_g1
        },
        95: {
            1: fa_f1,
            2: fa_g1
        },
        96: {
            1: fa_f1,
            2: fa_g1
        },
        97: {
            1: fa_f1,
            2: fa_g1
        },
        98: {
            1: fa_f1,
            2: fa_g1
        },
        99: {
            1: fa_f1,
            2: fa_g1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        254: {
            1: fa_d1,
            2: fa_e1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        29: {
            1: fa_b1,
            2: fa_c1
        },
        30: {
            1: fa_b1,
            2: fa_c1
        },
        31: {
            1: fa_b1,
            2: fa_c1
        },
        32: {
            1: fa_b1,
            2: fa_c1
        },
        33: {
            1: fa_b1,
            2: fa_c1
        },
        34: {
            1: fa_b1,
            2: fa_c1
        },
        35: {
            1: fa_b1,
            2: fa_c1
        },
        36: {
            1: fa_b1,
            2: fa_c1
        },
        37: {
            1: fa_b1,
            2: fa_c1
        },
        38: {
            1: fa_b1,
            2: fa_c1
        },
        39: {
            1: fa_b1,
            2: fa_c1
        },
        40: {
            1: fa_b1,
            2: fa_c1
        },
        41: {
            1: fa_b1,
            2: fa_c1
        },
        42: {
            1: fa_b1,
            2: fa_c1
        },
        43: {
            1: fa_b1,
            2: fa_c1
        },
        44: {
            1: fa_b1,
            2: fa_c1
        },
        45: {
            1: fa_b1,
            2: fa_c1
        },
        46: {
            1: fa_b1,
            2: fa_c1
        },
        47: {
            1: fa_b1,
            2: fa_c1
        },
        48: {
            1: fa_b1,
            2: fa_c1
        },
        49: {
            1: fa_b1,
            2: fa_c1
        },
        50: {
            1: fa_b1,
            2: fa_c1
        },
        51: {
            1: fa_b1,
            2: fa_c1
        },
        52: {
            1: fa_b1,
            2: fa_c1
        },
        53: {
            1: fa_b1,
            2: fa_c1
        },
        54: {
            1: fa_b1,
            2: fa_c1
        },
        55: {
            1: fa_b1,
            2: fa_c1
        },
        56: {
            1: fa_b1,
            2: fa_c1
        },
        57: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        203: {
            1: fa_d1,
            2: fa_e1
        },
        204: {
            1: fa_d1,
            2: fa_e1
        },
        205: {
            1: fa_d1,
            2: fa_e1
        },
        206: {
            1: fa_d1,
            2: fa_e1
        },
        207: {
            1: fa_d1,
            2: fa_e1
        },
        208: {
            1: fa_d1,
            2: fa_e1
        },
        209: {
            1: fa_d1,
            2: fa_e1
        },
        210: {
            1: fa_d1,
            2: fa_e1
        },
        211: {
            1: fa_d1,
            2: fa_e1
        },
        212: {
            1: fa_d1,
            2: fa_e1
        },
        213: {
            1: fa_d1,
            2: fa_e1
        },
        214: {
            1: fa_d1,
            2: fa_e1
        },
        215: {
            1: fa_d1,
            2: fa_e1
        },
        216: {
            1: fa_d1,
            2: fa_e1
        },
        217: {
            1: fa_d1,
            2: fa_e1
        },
        218: {
            1: fa_d1,
            2: fa_e1
        },
        219: {
            1: fa_d1,
            2: fa_e1
        },
        220: {
            1: fa_d1,
            2: fa_e1
        },
        221: {
            1: fa_d1,
            2: fa_e1
        },
        222: {
            1: fa_d1,
            2: fa_e1
        },
        223: {
            1: fa_d1,
            2: fa_e1
        },
        224: {
            1: fa_d1,
            2: fa_e1
        },
        225: {
            1: fa_d1,
            2: fa_e1
        },
        226: {
            1: fa_d1,
            2: fa_e1
        },
        227: {
            1: fa_d1,
            2: fa_e1
        },
        228: {
            1: fa_d1,
            2: fa_e1
        },
        229: {
            1: fa_d1,
            2: fa_e1
        },
        230: {
            1: fa_d1,
            2: fa_e1
        },
        231: {
            1: fa_d1,
            2: fa_e1
        },
        475: {
            1: fa_x1,
            2: fa_y1
        },
        476: {
            1: fa_x1,
            2: fa_y1
        },
        477: {
            1: fa_x1,
            2: fa_y1
        },
        478: {
            1: fa_x1,
            2: fa_y1
        },
        479: {
            1: fa_x1,
            2: fa_y1
        },
        480: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    15: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    2: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        569: {
            1: fa_x1,
            2: fa_y1
        },
        570: {
            1: fa_x1,
            2: fa_y1
        },
        571: {
            1: fa_x1,
            2: fa_y1
        },
        572: {
            1: fa_x1,
            2: fa_y1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        371: {
            1: fa_h1,
            2: fa_i1
        },
        372: {
            1: fa_h1,
            2: fa_i1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        125: {
            1: fa_l1,
            2: fa_m1
        },
        126: {
            1: fa_l1,
            2: fa_m1
        },
        127: {
            1: fa_l1,
            2: fa_m1
        },
        128: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        132: {
            1: fa_l1,
            2: fa_m1
        },
        133: {
            1: fa_l1,
            2: fa_m1
        },
        134: {
            1: fa_l1,
            2: fa_m1
        },
        135: {
            1: fa_l1,
            2: fa_m1
        },
        872: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        873: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        874: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        875: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        876: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        877: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        878: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        616: {
            1: fa_x1,
            2: fa_y1
        },
        617: {
            1: fa_x1,
            2: fa_y1
        },
        618: {
            1: fa_x1,
            2: fa_y1
        },
        619: {
            1: fa_x1,
            2: fa_y1
        },
        620: {
            1: fa_x1,
            2: fa_y1
        },
        621: {
            1: fa_x1,
            2: fa_y1
        },
        622: {
            1: fa_x1,
            2: fa_y1
        },
        894: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        895: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        896: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        897: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        898: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        899: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        900: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        443: {
            1: fa_j1,
            2: fa_s13
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        752: {
            1: fa_u1,
            2: fa_v1,
            3: fa_w1,
            4: fa_t1,
            5: fa_q1,
            6: fa_o1
        },
        753: {
            1: fa_i3,
            2: fa_j3,
            3: fa_k3,
            4: fa_l3,
            5: fa_g3,
            6: fa_c3,
            7: fa_z2,
            8: fa_v2
        }
    },
    6: {
        553: {
            1: fa_l1,
            2: fa_m1
        },
        339: {
            1: fa_d1,
            2: fa_e1
        },
        547: {
            1: fa_l1,
            2: fa_m1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        807: {
            1: fa_k6,
            2: fa_m6,
            3: fa_q6,
            4: fa_s6
        },
        636: {
            1: fa_l1,
            2: fa_m1
        },
        334: {
            1: fa_d1,
            2: fa_e1
        },
        335: {
            1: fa_d1,
            2: fa_e1
        },
        336: {
            1: fa_d1,
            2: fa_e1
        },
        337: {
            1: fa_d1,
            2: fa_e1
        },
        906: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        907: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        908: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        909: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        300: {
            1: fa_d1,
            2: fa_e1
        },
        301: {
            1: fa_d1,
            2: fa_e1
        },
        302: {
            1: fa_d1,
            2: fa_e1
        },
        303: {
            1: fa_d1,
            2: fa_e1
        },
        304: {
            1: fa_d1,
            2: fa_e1
        },
        310: {
            1: fa_d1,
            2: fa_e1
        },
        311: {
            1: fa_d1,
            2: fa_e1
        },
        312: {
            1: fa_d1,
            2: fa_e1
        },
        313: {
            1: fa_d1,
            2: fa_e1
        },
        314: {
            1: fa_d1,
            2: fa_e1
        },
        554: {
            1: fa_l1,
            2: fa_m1
        },
        555: {
            1: fa_l1,
            2: fa_m1
        },
        556: {
            1: fa_l1,
            2: fa_m1
        },
        557: {
            1: fa_l1,
            2: fa_m1
        },
        558: {
            1: fa_l1,
            2: fa_m1
        },
        517: {
            1: fa_l1,
            2: fa_m1
        },
        518: {
            1: fa_l1,
            2: fa_m1
        },
        519: {
            1: fa_l1,
            2: fa_m1
        },
        520: {
            1: fa_l1,
            2: fa_m1
        },
        521: {
            1: fa_l1,
            2: fa_m1
        },
        561: {
            1: fa_l1,
            2: fa_m1
        },
        562: {
            1: fa_l1,
            2: fa_m1
        },
        563: {
            1: fa_l1,
            2: fa_m1
        },
        564: {
            1: fa_l1,
            2: fa_m1
        },
        565: {
            1: fa_l1,
            2: fa_m1
        },
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        903: {
            1: fa_t13,
            2: fa_u13,
            3: fa_v13,
            4: fa_w13,
            5: fa_x13,
            6: fa_y13,
            7: fa_z13,
            8: fa_a14
        },
        445: {
            1: fa_x1,
            2: fa_y1
        },
        754: {
            1: fa_y9,
            2: fa_z9,
            3: fa_e3,
            4: fa_b14,
            5: fa_d7,
            6: fa_c14,
            7: fa_a10,
            8: fa_b10,
            9: fa_d14,
            10: fa_e14,
            11: fa_f14,
            12: fa_g14,
            13: fa_h14,
            14: fa_i14
        },
        755: {
            1: fa_y9,
            2: fa_z9,
            3: fa_e3,
            4: fa_b14,
            5: fa_d7,
            6: fa_c14,
            7: fa_a10,
            8: fa_b10,
            9: fa_d14,
            10: fa_e14,
            11: fa_f14,
            12: fa_g14,
            13: fa_h14,
            14: fa_i14
        },
        756: {
            1: fa_y9,
            2: fa_z9,
            3: fa_e3,
            4: fa_b14,
            5: fa_d7,
            6: fa_c14,
            7: fa_a10,
            8: fa_b10,
            9: fa_d14,
            10: fa_e14,
            11: fa_f14,
            12: fa_g14,
            13: fa_h14,
            14: fa_i14
        },
        757: {
            1: fa_y9,
            2: fa_z9,
            3: fa_e3,
            4: fa_b14,
            5: fa_d7,
            6: fa_c14,
            7: fa_a10,
            8: fa_b10,
            9: fa_d14,
            10: fa_e14,
            11: fa_f14,
            12: fa_g14,
            13: fa_h14,
            14: fa_i14
        },
        758: {
            1: fa_y9,
            2: fa_z9,
            3: fa_e3,
            4: fa_b14,
            5: fa_d7,
            6: fa_c14,
            7: fa_a10,
            8: fa_b10,
            9: fa_d14,
            10: fa_e14,
            11: fa_f14,
            12: fa_g14,
            13: fa_h14,
            14: fa_i14
        },
        452: {
            1: fa_l1,
            2: fa_m1
        },
        453: {
            1: fa_l1,
            2: fa_m1
        },
        454: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        569: {
            1: fa_x1,
            2: fa_y1
        },
        570: {
            1: fa_x1,
            2: fa_y1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        522: {
            1: fa_x1,
            2: fa_y1
        },
        627: {
            1: fa_l1,
            2: fa_m1
        },
        628: {
            1: fa_l1,
            2: fa_m1
        },
        629: {
            1: fa_l1,
            2: fa_m1
        },
        630: {
            1: fa_l1,
            2: fa_m1
        },
        631: {
            1: fa_l1,
            2: fa_m1
        },
        632: {
            1: fa_l1,
            2: fa_m1
        },
        190: {
            1: fa_d1,
            2: fa_e1
        },
        191: {
            1: fa_d1,
            2: fa_e1
        },
        192: {
            1: fa_d1,
            2: fa_e1
        },
        193: {
            1: fa_d1,
            2: fa_e1
        },
        194: {
            1: fa_d1,
            2: fa_e1
        },
        759: {
            1: fa_j14,
            2: fa_k14,
            3: fa_l14,
            4: fa_m14,
            5: fa_n14,
            6: fa_h14,
            7: fa_o14,
            8: fa_p14,
            9: fa_q14,
            10: fa_r14,
            11: fa_s14,
            12: fa_t14,
            13: fa_c14,
            14: fa_u14
        },
        760: {
            1: fa_j14,
            2: fa_k14,
            3: fa_l14,
            4: fa_m14,
            5: fa_n14,
            6: fa_h14,
            7: fa_o14,
            8: fa_p14,
            9: fa_q14,
            10: fa_r14,
            11: fa_s14,
            12: fa_t14,
            13: fa_c14,
            14: fa_u14
        },
        761: {
            1: fa_j14,
            2: fa_k14,
            3: fa_l14,
            4: fa_m14,
            5: fa_n14,
            6: fa_h14,
            7: fa_o14,
            8: fa_p14,
            9: fa_q14,
            10: fa_r14,
            11: fa_s14,
            12: fa_t14,
            13: fa_c14,
            14: fa_u14
        },
        762: {
            1: fa_j14,
            2: fa_k14,
            3: fa_l14,
            4: fa_m14,
            5: fa_n14,
            6: fa_h14,
            7: fa_o14,
            8: fa_p14,
            9: fa_q14,
            10: fa_r14,
            11: fa_s14,
            12: fa_t14,
            13: fa_c14,
            14: fa_u14
        },
        763: {
            1: fa_j14,
            2: fa_k14,
            3: fa_l14,
            4: fa_m14,
            5: fa_n14,
            6: fa_h14,
            7: fa_o14,
            8: fa_p14,
            9: fa_q14,
            10: fa_r14,
            11: fa_s14,
            12: fa_t14,
            13: fa_c14,
            14: fa_u14
        },
        768: {
            1: fa_i6,
            2: fa_v14,
            3: fa_w14,
            4: fa_x14,
            5: fa_y14,
            6: fa_c2,
            7: fa_z14
        },
        769: {
            1: fa_i6,
            2: fa_v14,
            3: fa_w14,
            4: fa_x14,
            5: fa_y14,
            6: fa_c2,
            7: fa_z14
        },
        770: {
            1: fa_i6,
            2: fa_v14,
            3: fa_w14,
            4: fa_x14,
            5: fa_y14,
            6: fa_c2,
            7: fa_z14
        },
        771: {
            1: fa_i6,
            2: fa_v14,
            3: fa_w14,
            4: fa_x14,
            5: fa_y14,
            6: fa_c2,
            7: fa_z14
        },
        772: {
            1: fa_i6,
            2: fa_v14,
            3: fa_w14,
            4: fa_x14,
            5: fa_y14,
            6: fa_c2,
            7: fa_z14
        },
        603: {
            1: fa_x1,
            2: fa_y1
        },
        604: {
            1: fa_x1,
            2: fa_y1
        },
        605: {
            1: fa_x1,
            2: fa_y1
        },
        606: {
            1: fa_x1,
            2: fa_y1
        },
        607: {
            1: fa_x1,
            2: fa_y1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        696: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        333: {
            1: fa_d1,
            2: fa_e1
        },
        341: {
            1: fa_d1,
            2: fa_e1
        },
        427: {
            1: fa_l1,
            2: fa_m1
        },
        536: {
            1: fa_l1,
            2: fa_m1
        },
        905: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        514: {
            1: fa_x1,
            2: fa_y1
        },
        516: {
            1: fa_x1,
            2: fa_y1
        },
        305: {
            1: fa_d1,
            2: fa_e1
        },
        315: {
            1: fa_d1,
            2: fa_e1
        },
        523: {
            1: fa_l1,
            2: fa_m1
        },
        299: {
            1: fa_d1,
            2: fa_e1
        },
        309: {
            1: fa_d1,
            2: fa_e1
        },
        697: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        298: {
            1: fa_d1,
            2: fa_e1
        },
        308: {
            1: fa_d1,
            2: fa_e1
        },
        515: {
            1: fa_x1,
            2: fa_y1
        },
        549: {
            1: fa_l1,
            2: fa_m1
        },
        548: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        550: {
            1: fa_a15,
            2: fa_y1
        },
        551: {
            1: fa_x1,
            2: fa_b15
        },
        455: {
            1: fa_l1,
            2: fa_m1
        },
        456: {
            1: fa_l1,
            2: fa_m1
        },
        457: {
            1: fa_l1,
            2: fa_m1
        },
        458: {
            1: fa_l1,
            2: fa_m1
        },
        459: {
            1: fa_l1,
            2: fa_m1
        },
        460: {
            1: fa_l1,
            2: fa_m1
        },
        512: {
            1: fa_a15,
            2: fa_y1
        },
        513: {
            1: fa_c15,
            2: fa_b15
        },
        901: {
            1: fa_t13,
            2: fa_u13,
            3: fa_v13,
            4: fa_w13,
            5: fa_x13,
            6: fa_y13,
            7: fa_z13,
            8: fa_a14
        },
        902: {
            1: fa_t13,
            2: fa_u13,
            3: fa_v13,
            4: fa_w13,
            5: fa_x13,
            6: fa_y13,
            7: fa_z13,
            8: fa_a14
        },
        340: {
            1: fa_d1,
            2: fa_e1
        },
        328: {
            1: fa_d1,
            2: fa_e1
        },
        329: {
            1: fa_d1,
            2: fa_e1
        },
        342: {
            1: fa_d1,
            2: fa_e1
        },
        330: {
            1: fa_d1,
            2: fa_e1
        },
        331: {
            1: fa_d1,
            2: fa_e1
        },
        722: {
            1: fa_k10,
            2: fa_l10,
            3: fa_m10
        },
        560: {
            1: fa_l1,
            2: fa_m1
        },
        543: {
            1: fa_l1,
            2: fa_m1
        },
        544: {
            1: fa_l1,
            2: fa_m1
        },
        545: {
            1: fa_l1,
            2: fa_m1
        },
        546: {
            1: fa_l1,
            2: fa_m1
        },
        332: {
            1: fa_d1,
            2: fa_e1
        },
        559: {
            1: fa_l1,
            2: fa_m1
        },
        296: {
            1: fa_d1,
            2: fa_e1
        },
        297: {
            1: fa_d1,
            2: fa_e1
        },
        717: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        718: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        719: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        720: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        721: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        552: {
            1: fa_b1,
            2: fa_c1
        },
        76: {
            1: fa_b1,
            2: fa_c1
        },
        77: {
            1: fa_b1,
            2: fa_c1
        },
        78: {
            1: fa_b1,
            2: fa_c1
        },
        79: {
            1: fa_b1,
            2: fa_c1
        },
        80: {
            1: fa_b1,
            2: fa_c1
        },
        647: {
            1: fa_x1,
            2: fa_y1
        },
        741: {
            1: fa_d15,
            2: fa_t7,
            3: fa_e15
        },
        82: {
            1: fa_b1,
            2: fa_c1
        },
        338: {
            1: fa_d1,
            2: fa_e1
        }
    },
    17: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_f15,
            2: fa_g15
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    4: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        764: {
            1: fa_o1,
            2: fa_q1,
            3: fa_t1,
            4: fa_u1,
            5: fa_v1,
            6: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        569: {
            1: fa_x1,
            2: fa_y1
        },
        570: {
            1: fa_x1,
            2: fa_y1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        923: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        924: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        925: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        926: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        927: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        929: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        930: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        931: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        932: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        933: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        845: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_i1
        },
        846: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_i1
        },
        847: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_i1
        },
        848: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_i1
        },
        849: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_i1
        },
        918: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_h1
        },
        919: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_h1
        },
        920: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_h1
        },
        921: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_h1
        },
        922: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_h1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        906: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        907: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        908: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        909: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        807: {
            1: fa_k6,
            2: fa_m6,
            3: fa_q6,
            4: fa_s6
        },
        319: {
            1: fa_d1,
            2: fa_e1
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        912: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        913: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        914: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        915: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        916: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        362: {
            1: fa_h1,
            2: fa_i1
        },
        363: {
            1: fa_h1,
            2: fa_i1
        },
        364: {
            1: fa_h1,
            2: fa_i1
        },
        365: {
            1: fa_h1,
            2: fa_i1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        20: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        179: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_h1,
            2: fa_i1
        },
        359: {
            1: fa_h1,
            2: fa_i1
        },
        360: {
            1: fa_h1,
            2: fa_i1
        },
        361: {
            1: fa_h1,
            2: fa_i1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        16: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        175: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_x1,
            2: fa_y1
        },
        617: {
            1: fa_x1,
            2: fa_y1
        },
        618: {
            1: fa_x1,
            2: fa_y1
        },
        619: {
            1: fa_x1,
            2: fa_y1
        },
        620: {
            1: fa_x1,
            2: fa_y1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        26: {
            1: fa_l15,
            2: fa_m15
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        371: {
            1: fa_h1,
            2: fa_i1
        },
        571: {
            1: fa_x1,
            2: fa_y1
        },
        928: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        934: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        910: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        917: {
            1: fa_j7,
            2: fa_k7,
            3: fa_n15,
            4: fa_m7,
            5: fa_n7,
            6: fa_o15
        },
        936: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_g6
        }
    },
    8: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        675: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        676: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    27: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    28: {
        403: {
            1: fa_h1,
            2: fa_i1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        935: {
            1: fa_a10,
            2: fa_b10,
            3: fa_d14,
            4: fa_e14,
            5: fa_f14,
            6: fa_p15,
            7: fa_y9,
            8: fa_z9,
            9: fa_e3,
            10: fa_b14,
            11: fa_d7,
            12: fa_q15
        },
        612: {
            1: fa_l1,
            2: fa_m1
        },
        613: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    }
};

let periodConfig = {
    2: {
        208: 'O`yin tugadi',
        207: 'Yettinchi partiya',
        206: 'Oltinchi partiya',
        205: 'Beshinchi partiya',
        200: 'O`yin hali boshlanmadi',
        203: 'Uchinchi partiya',
        202: 'Ikkinchi partiya',
        201: 'Birinchi partiya',
        204: 'To`rtinchi partiya'
    },
    3: {
        304: 'O`yin tugadi',
        303: 'Uchinchi set',
        302: 'Ikkinchi set',
        301: 'Birinchi set',
        300: 'O`yin hali boshlanmadi'
    },
    4: {
        406: 'O`yin tugadi',
        403: 'Uchinchi set',
        402: 'Ikkinchi set',
        401: 'Birinchi set',
        400: 'O`yin hali boshlanmadi',
        407: 'Oltin set',
        405: 'Beshinchi set',
        404: 'To`rtinchi set'
    },
    5: {
        510: 'O`ninchi raund',
        509: 'To`qqizinchi raund',
        508: 'Sakkizinchi raund',
        507: 'Yettinchi raund',
        506: 'Oltinchi raund',
        505: 'Beshinchi raund',
        513: 'O`yin tugadi',
        503: 'Uchinchi raund',
        500: 'O`yin hali boshlanmadi',
        501: 'Birinchi raund',
        502: 'Ikkinchi raund',
        511: 'O`n birinchi raund',
        512: 'O`n ikkinchi raund',
        504: 'To`rtinchi raund'
    },
    6: {
        600: 'O`yin hali boshlanmadi',
        601: 'Birinchi set',
        602: 'Ikkinchi set',
        603: 'Uchinchi set',
        604: 'To`rtinchi set',
        605: 'Beshinchi set',
        606: 'O`yin tugadi'
    },
    7: {
        701: 'Birinchi Bo`lim',
        700: 'O`yin hali boshlanmadi',
        703: 'Ikkinchi Bo`lim',
        704: 'Asosiy vaqt tugadi',
        705: 'Birinchi qo`shimcha bo`lim',
        702: 'Tanaffus',
        707: 'Ikkinchi qo`shimcha bo`lim',
        708: 'Ikkinchi qo`shimcha bo`lim tugadi',
        709: 'Penalti',
        710: 'O`yin tugadi',
        706: 'Birinchi qo`shimcha bo`lim tugadi'
    },
    8: {
        808: 'To`xtalish',
        807: 'To`rtinchi chorak',
        806: 'To`xtalish',
        805: 'Uchinchi chorak',
        804: 'Tanaffus',
        809: 'Overtime',
        802: 'To`xtalish',
        801: 'Birinchi chorak',
        800: 'O`yin hali boshlanmadi',
        810: 'O`yin tugadi',
        803: 'Ikkinchi chorak'
    },
    9: {
        903: 'Ikkinchi Bo`lim',
        902: 'Tanaffus',
        901: 'Birinchi Bo`lim',
        900: 'O`yin hali boshlanmadi',
        904: 'O`yin tugadi'
    },
    12: {
        1203: 'Ikkinchi Bo`lim',
        1202: 'Tanaffus',
        1201: 'Birinchi Bo`lim',
        1200: 'O`yin hali boshlanmadi',
        1204: 'O`yin tugadi'
    },
    18: {
        1808: 'Overtime tugadi',
        1807: 'Overtime',
        1806: 'Asosiy vaqt tugadi',
        1805: 'Uchinchi davr',
        1804: 'Ikkinchi Tanaffus',
        1809: 'Penalti',
        1802: 'Birinchi Tanaffus',
        1801: 'Birinchi davr',
        1800: 'O`yin hali boshlanmadi',
        1810: 'O`yin tugadi',
        1803: 'Ikkinchi davr'
    },
    19: {
        1904: 'Asosiy vaqt tugadi',
        1903: 'Ikkinchi Bo`lim',
        1902: 'Tanaffus',
        1901: 'Birinchi Bo`lim',
        1900: 'O`yin hali boshlanmadi',
        1905: 'O`yin tugadi'
    },
    20: {
        2016: 'Sakkizinchi o`t ochish marrasi',
        2017: 'O`yin tugadi',
        2000: 'O`yin hali boshlanmadi',
        2001: 'Birinchi aylana',
        2002: 'Birinchi o`t ochish marrasi',
        2003: 'Ikkinchi aylana',
        2004: 'Ikkinchi o`t ochish marrasi',
        2005: 'Uchinchi aylana',
        2006: 'Uchinchi o`t ochish marrasi',
        2007: 'To`rtinchi aylana',
        2008: 'To`rtinchi o`t ochish marrasi',
        2009: 'Beshinchi aylana',
        2010: 'Beshinchi o`t ochish marrasi',
        2011: 'Oltinchi aylana',
        2012: 'Oltinchi o`t ochish marrasi',
        2013: 'Yettinchi aylana',
        2014: 'Yettinchi o`t ochish marrasi',
        2015: 'Sakkizinchi aylana'
    },
    28: {
        2801: 'Asosiy vaqt',
        2802: 'O`yin tugadi',
        2800: 'O`yin hali boshlanmadi'
    },
    29: {
        2911: '6-partiya',
        2912: 'Tanaffus',
        2913: '7-partiya',
        2914: 'Tanaffus',
        2915: '8-partiya',
        2916: 'Tanaffus',
        2917: '9-partiya',
        2918: 'Tanaffus',
        2919: '10-partiya',
        2920: 'Tanaffus',
        2921: '11-partiya',
        2964: 'Tanaffus',
        2965: '33-partiya',
        2966: 'Tanaffus',
        2967: '34-partiya',
        2968: 'Tanaffus',
        2969: '35-partiya',
        2970: 'Tanaffus',
        2971: '36-partiya',
        2972: 'Tanaffus',
        2973: '37-partiya',
        2974: 'O`yin tugadi',
        2943: '22-partiya',
        2944: 'Tanaffus',
        2945: '23-partiya',
        2946: 'Tanaffus',
        2947: '24-partiya',
        2948: 'Tanaffus',
        2949: '25-partiya',
        2950: 'Tanaffus',
        2951: '26-partiya',
        2952: 'Tanaffus',
        2953: '27-partiya',
        2954: 'Tanaffus',
        2955: '28-partiya',
        2956: 'Tanaffus',
        2957: '29-partiya',
        2958: 'Tanaffus',
        2959: '30-partiya',
        2960: 'Tanaffus',
        2961: '31-partiya',
        2962: 'Tanaffus',
        2963: '32-partiya',
        2922: 'Tanaffus',
        2923: '12-partiya',
        2924: 'Tanaffus',
        2925: '13-partiya',
        2926: 'Tanaffus',
        2927: '14-partiya',
        2928: 'Tanaffus',
        2929: '15-partiya',
        2930: 'Tanaffus',
        2931: '16-partiya',
        2932: 'Tanaffus',
        2933: '17-partiya',
        2934: 'Tanaffus',
        2935: '18-partiya',
        2936: 'Tanaffus',
        2937: '19-partiya',
        2938: 'Tanaffus',
        2939: '20-partiya',
        2940: 'Tanaffus',
        2941: '21-partiya',
        2942: 'Tanaffus',
        2900: 'O`yin hali boshlanmadi',
        2901: '1-partiya',
        2902: 'Tanaffus',
        2903: '2-partiya',
        2904: 'Tanaffus',
        2905: '3-partiya',
        2906: 'Tanaffus',
        2907: '4-partiya',
        2908: 'Tanaffus',
        2909: '5-partiya',
        2910: 'Tanaffus'
    },
    30: {
        3008: 'Qo`shimcha vaqt tugadi',
        3007: 'Overtime',
        3006: 'Asosiy vaqt tugadi',
        3005: 'Uchinchi davr',
        3004: 'Ikkinchi Tanaffus',
        3009: 'Bullitlar',
        3002: 'Birinchi Tanaffus',
        3001: 'Birinchi davr',
        3000: 'O`yin hali boshlanmadi',
        3010: 'O`yin tugadi',
        3003: 'Ikkinchi davr'
    },
    31: {
        3108: 'To`xtalish',
        3107: 'To`rtinchi chorak',
        3106: 'To`xtalish',
        3105: 'Uchinchi chorak',
        3104: 'Tanaffus',
        3109: 'Overtime',
        3102: 'To`xtalish',
        3101: 'Birinchi chorak',
        3100: 'O`yin hali boshlanmadi',
        3110: 'O`yin tugadi',
        3103: 'Ikkinchi chorak'
    },
    32: {
        3203: 'Uchinchi set',
        3202: 'Ikkinchi set',
        3201: 'Birinchi set',
        3200: 'O`yin hali boshlanmadi',
        3204: 'O`yin tugadi'
    },
    34: {
        3400: 'O`yin hali boshlanmadi',
        3401: 'Birinchi bo`lim',
        3402: 'Tanaffus',
        3403: 'Ikkinchi bo`lim',
        3404: 'Asosiy vaqt tugadi',
        3410: 'O`yin tugadi',
        3406: 'Birinchi qo`shimcha bo`lim tugadi',
        3407: 'Ikkinchi qo`shimcha bo`lim',
        3408: 'Ikkinchi qo`shimcha bo`lim tugadi',
        3409: 'Penalti',
        3405: 'Birinchi qo`shimcha bo`lim'
    },
    35: {
        3500: 'O`yin hali boshlanmadi',
        3501: 'Birinchi Bo`lim',
        3502: 'Tanaffus',
        3503: 'Ikkinchi Bo`lim',
        3504: 'O`yin tugadi'
    },
    36: {
        3601: 'Birinchi davr',
        3602: 'Birinchi Tanaffus',
        3603: 'Ikkinchi davr',
        3604: 'Ikkinchi Tanaffus',
        3605: 'Uchinchi davr',
        3600: 'O`yin hali boshlanmadi',
        3607: 'Overtime',
        3608: 'Qo`shimcha vaqt tugadi',
        3609: 'Bullitlar',
        3610: 'O`yin tugadi',
        3606: 'Asosiy vaqt tugadi'
    },
    37: {
        3701: 'O`yin tugadi',
        3700: 'O`yin hali boshlanmadi'
    },
    38: {
        3801: 'O`yin tugadi',
        3800: 'O`yin hali boshlanmadi'
    },
    39: {
        3901: 'O`yin tugadi',
        3900: 'O`yin hali boshlanmadi',
        3902: 'Birinchi raund',
        3903: 'Ikkinchi raund',
        3904: 'Uchinchi raund',
        3905: 'To`rtinchi raund',
        3906: 'Beshinchi raund'
    },
    40: {
        4001: 'O`yin tugadi',
        4000: 'O`yin hali boshlanmadi'
    },
    41: {
        4102: 'Birinchi Tanaffus',
        4106: 'O`yin tugadi',
        4105: 'Overtime',
        4104: 'Ikkinchi Tanaffus',
        4103: 'O`yinning ikkinchi yarmi',
        4101: 'O`yinning birinchi yarmi',
        4100: 'O`yin hali boshlanmadi'
    },
    42: {
        4202: 'Ikkinchi xarita',
        4206: 'O`yin tugadi',
        4205: 'Beshinchi xarita',
        4204: 'To`rtinchi xarita',
        4203: 'Uchinchi xarita',
        4201: 'Birinchi xarita',
        4200: 'O`yin hali boshlanmadi'
    }
};

export function getGroupName(sportId, groupType) {
    if (groupConfig !== undefined &&
        groupConfig[sportId] !== undefined) {
        return groupConfig[sportId][groupType];
    }

    return undefined;
}

export function getSlotName(sportId, match, slot) {
    let func;

    if (slotConfig !== undefined &&
       slotConfig[sportId] !== undefined) {
        func = slotConfig[sportId][slot.type];
    }

    if (func === undefined) {
        return undefined; 
    }

    return func(match, slot);
}


export function getOutcomeName(sportId, outcome, match) {
    let func;

    if (baseOutcomeConfig !== undefined &&
        baseOutcomeConfig[sportId] !== undefined &&
        baseOutcomeConfig[sportId]) {
        func = baseOutcomeConfig[sportId][outcome.type];
    }

    if (outcomeConfig !== undefined &&
        outcomeConfig[sportId] !== undefined &&
        outcomeConfig[sportId][outcome.type] !== undefined) {
        func = outcomeConfig[sportId][outcome.type];
    }

    if (func === undefined) {
        return undefined;
    }

    return func(match, outcome);
}

export function getRateName(sportId, outcome, factorType, match) {
    let func;

    if (baseFactorNameConfig !== undefined &&
        baseFactorNameConfig[sportId] !== undefined &&
        baseFactorNameConfig[sportId][outcome.type] !== undefined) {
        func = baseFactorNameConfig[sportId][outcome.type][factorType];
    }

    if (func === undefined) {
        return undefined;
    }

    return func(match, outcome);
}

export function getMatchInfoText(matchInfoType) {
    switch(matchInfoType) {
        case 1:
            return "O`yin boshlanmadi";
        case 2:
            return "O`yin tugadi";
        case 3:
            return "Tanaffus";
        case 4:
            return "Asosiy vaqt tugadi";
        case 5:
            return "Birinchi qo`shimcha vaqt tugadi";
        case 6:
            return "Penaltilar seriyasi";
    }
    
    return "";
}

export function getPeriodName(sportId, periodId) {
    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
        return  periodConfig[sportId][periodId];
    }

    return undefined;
}

export function getFoulsText() {
    return "O`yin qoidasi buzilishi";
}

export function getTimeoutText() {
    return "Tanaffus";
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/localization/uz.js